var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-stem-cell-research",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-stem-cell-research:not(.animated) .animable {opacity: 0;}svg#freepik_stories-stem-cell-research.animated #freepik--background-complete--inject-219 {animation: 6s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-stem-cell-research.animated #freepik--magnifying-glass--inject-219 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-stem-cell-research.animated #freepik--Cell--inject-219 {animation: 3s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-stem-cell-research.animated #freepik--DNA--inject-219 {animation: 3s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-stem-cell-research.animated #freepik--Tube--inject-219 {animation: 3s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-stem-cell-research.animated #freepik--stem-cell--inject-219 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-stem-cell-research.animated #freepik--Zoom--inject-219 {animation: 6s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-219",
    className: "animable animator-active",
    style: {
      transformOrigin: "257.384px 243.533px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478,304.27c-1.32-.55-2-2.61-2-2.61s-2.5-12.83-3.46-21.45-3.23-19.18-5.23-23-2-9.1-2-9.1-.86-14.24-.95-27.41-14-17.72-14-17.72c-9.05-1.84-9.5-1.86-13.61-4.07-5.24-2.81-5.9-8.72-5.9-8.72l1.23-11.91.48.39c1.81.67,2.66,0,4.19-5s-2.76-5-2.76-5c3.07-15.39-12.62-17.4-12.62-17.4h-1.22s-16,1.79-12.62,17.4c0,0-4.29,0-2.76,5s2,7.06,3.8,6.38l1-.68,1.13,10.86s-.67,5.91-5.9,8.72c-4.12,2.21-4.57,2.23-13.61,4.07,0,0-13.9,4.55-14,17.72s-1,27.41-1,27.41,0,5.33-2,9.1-4.28,14.34-5.23,23c-.92,8.3-3.89,22.24-4.11,23.27a2.72,2.72,0,0,1-1,.79c-1.33.56-10.28,11.33-10.28,11.33s.55,2,3.27.87,3-2.85,4.05-2.14-.16,14.18.85,15.21,2.11,1.19,2.65.48a1.26,1.26,0,0,0,1.46,1.26,2.12,2.12,0,0,0,1.81-1.18s.23,1.5,1.87.63a2.41,2.41,0,0,0,1.4-2.38s1.64.56,2.26-.71,4.36-14.73,4.51-16.64-1.79-5.54-1.79-5.54,4.57-16.92,7.42-21.67,5.24-18,5.81-22.86,4-30.55,4-30.55l3.32,34.88s-5.79,25.56-6.17,33.7,3.58,45.56,6.05,53.89c0,0-.09,9.68.19,12.1a57.64,57.64,0,0,1,.67,8.62c-.1,3.1-.67,14.05-.1,22.38.4,5.82,3.17,17.63,4.8,24.23h0c.2.79.38,1.51.53,2.12a14.51,14.51,0,0,1-3.65,12.8c-3.69,3.86-8.75,7.12-10.34,10.52-.91,2,.85,6.84,2.24,6.41s1.92-.63,1.92-.63-3.27,2.37-.61,4.47c1.53,1.2,14-7.72,15.85-10.27s2.09-2.81,3.34-4.79,7.58-4.56,5.44-10c-1.59-4-1.89-10.82-1.94-13.89v-1.6h0l-.05-9.55a17.77,17.77,0,0,1,.39-3.71c.54-2.52,1.41-7.32.94-10.61-.67-4.65-2.1-11.62-1.62-15.3s1.52-8.82,1.52-8.82L417,349.55l3.72-42.11.76-1.16.76,1.16,2.19,42.11,1.14,17.82s1.05,5.14,1.52,8.82-1,10.65-1.61,15.3,1.33,12.3,1.33,12.3l-.07,15-.18-.06s.11,1,.17,2.6l0,3h0a25.18,25.18,0,0,1-1.37,8.19c-2.14,5.41,4.18,8,5.44,10s1.53,2.24,3.34,4.79,14.31,11.48,15.85,10.27c2.66-2.1-.61-4.46-.61-4.46a21.67,21.67,0,0,0,2.67,1.05c1.39.42,3.23-3.71,3.19-5.87s-7.73-8.36-12.05-11.48c-3.29-2.38-4.35-9.43-4.67-12.66,1-3.85,5.29-20.8,5.79-28.16.57-8.33,0-19.28-.09-22.38a57.73,57.73,0,0,1,.66-8.62c.29-2.42.19-12.1.19-12.1,2.48-8.33,7.24-42.23,6.85-50.37s-6.43-37-6.43-37l2.59-35.75s3.65,26.37,4.23,31.21,2.95,18.12,5.8,22.86c2.54,4.22,6.81,17.49,7.74,20.41l0,1.26S464,309.1,464.1,311a162.06,162.06,0,0,0,4.52,16.64c.62,1.27,2.26.71,2.26.71a2.39,2.39,0,0,0,1.4,2.38c1.63.87,1.87-.63,1.87-.63a2.12,2.12,0,0,0,1.81,1.18,1.26,1.26,0,0,0,1.46-1.26c.54.71,1.63.55,2.64-.48s-.15-14.5.86-15.21,1.32,1,4.05,2.14,3.27-.87,3.27-.87S479.28,304.83,478,304.27Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "420.905px 304.481px"
    },
    id: "el39he8fy7ya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.05,213.32a4.54,4.54,0,0,0-2.7-.5,6.25,6.25,0,0,0-2.65,1.1,12.16,12.16,0,0,0-2.25,2.06,15.34,15.34,0,0,0-1.76,2.54,21.71,21.71,0,0,0-2,5.92,63.07,63.07,0,0,0-.93,6.33c-.44,4.26-.6,8.58-1,12.89a52.83,52.83,0,0,1-2.59,12.73c-1.46,4.09-3.43,7.95-4.67,12.05a77.23,77.23,0,0,0-2.26,12.68c-.28,2.14-.56,4.28-1,6.4a22.31,22.31,0,0,1-.87,3.13c-.32,1-.65,2.05-.95,3.08A40.12,40.12,0,0,0,367,300a11.9,11.9,0,0,0,0,3.21,4.46,4.46,0,0,0,.5,1.52,2.43,2.43,0,0,0,1.19,1.05,2.39,2.39,0,0,1-1.2-1,4.29,4.29,0,0,1-.52-1.52,11.65,11.65,0,0,1,0-3.23,40,40,0,0,1,1.36-6.32c.29-1,.6-2.07.92-3.1l.47-1.55c.07-.26.15-.52.21-.78s.09-.52.14-.79c.38-2.12.63-4.25.87-6.4a78.42,78.42,0,0,1,2.07-12.78c1.2-4.18,3.11-8.09,4.48-12.14a51.57,51.57,0,0,0,2.36-12.59c.35-4.27.44-8.59.82-12.91a65.11,65.11,0,0,1,.85-6.47,22.92,22.92,0,0,1,2.06-6.3,15.58,15.58,0,0,1,1.88-2.8,13.86,13.86,0,0,1,2.49-2.34,7.55,7.55,0,0,1,3.27-1.38,5.92,5.92,0,0,1,3.59.61Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "380.834px 258.549px"
    },
    id: "elgm8zwva5jab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.67,302.35a3.1,3.1,0,0,1,.61,0,5.43,5.43,0,0,1,.56.09,5.25,5.25,0,0,1,1,.33,6.45,6.45,0,0,1,1.8,1.18,10.42,10.42,0,0,1,2.39,3.38,19.09,19.09,0,0,1,1.27,3.85,33.18,33.18,0,0,1,.65,3.95,60.32,60.32,0,0,1,.21,7.95c-.09,2.64-.33,5.28-.63,7.9-.15,1.31-.32,2.61-.45,3.91s-.26,2.61-.37,3.92-.22,2.61-.3,3.92c-.05.65-.08,1.31-.1,1.95v2c0,1.32,0,2.64-.13,4a19.11,19.11,0,0,1-.22,2c-.08.61-.12,1.28-.16,1.93-.14,2.61-.21,5.24-.28,7.87,0,1.3,0,2.63-.13,3.95q-.06,1-.18,2a16.69,16.69,0,0,1-.33,2c-.31,1.29-.66,2.55-.89,3.83a17.28,17.28,0,0,0-.33,3.85,11,11,0,0,0,.23,1.91c.13.62.32,1.27.48,1.9.32,1.28.64,2.56.91,3.85a34.81,34.81,0,0,1,.86,7.89c-.13,5.24-.16,10.51-.22,15.76l-.14,15.78,0-.06a20,20,0,0,1,1.73,4.55,11.64,11.64,0,0,1,.23,2.43,7.91,7.91,0,0,1-.36,2.41,1.7,1.7,0,0,1-.3.56c-.13.15-.26.31-.4.46-.27.3-.56.59-.84.88L411.14,438c-1.14,1.15-2.27,2.31-3.35,3.51a44,44,0,0,0-3,3.78,15.81,15.81,0,0,1-3.25,3.58,31.18,31.18,0,0,1-4,2.78,41.91,41.91,0,0,1-4.32,2.22,39.12,39.12,0,0,0,4.31-2.24,31,31,0,0,0,4-2.79,15.57,15.57,0,0,0,3.23-3.59,40.82,40.82,0,0,1,3-3.8c1.07-1.22,2.19-2.39,3.32-3.54l1.7-1.73c.28-.29.56-.58.83-.88.14-.15.26-.31.39-.46a1.47,1.47,0,0,0,.27-.51,7.78,7.78,0,0,0,.33-2.36,11.18,11.18,0,0,0-.24-2.38,20.38,20.38,0,0,0-1.74-4.48v-.05l0-15.78c0-5.26,0-10.51.11-15.78a34,34,0,0,0-.91-7.76c-.28-1.28-.6-2.55-.93-3.82-.16-.64-.36-1.25-.5-1.92a12.31,12.31,0,0,1-.26-2,18.37,18.37,0,0,1,.31-4c.23-1.31.58-2.59.87-3.86a15.2,15.2,0,0,0,.31-1.91c.07-.65.12-1.3.16-1.95.09-1.3.07-2.61.1-3.93,0-2.63.1-5.26.23-7.9,0-.66.06-1.31.15-2s.16-1.27.2-1.93c.08-1.29.09-2.6.09-3.91v-2c0-.67.05-1.33.09-2,.07-1.32.17-2.63.27-3.94s.22-2.63.35-3.94.28-2.63.42-3.93c.28-2.6.5-5.21.57-7.82a58.09,58.09,0,0,0-.26-7.81,30.47,30.47,0,0,0-.65-3.82,18.67,18.67,0,0,0-1.22-3.63,9.54,9.54,0,0,0-2.15-3,5.59,5.59,0,0,0-1.5-1,4.2,4.2,0,0,0-.83-.26l-.43-.06a2.45,2.45,0,0,0-.37,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.214px 378.102px"
    },
    id: "el028ryevdyr2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.67,222a2.36,2.36,0,0,0,1.12,0,6,6,0,0,0,1.14-.46c.38-.2.8-.41,1.15-.61s.73-.45,1.1-.69a3.92,3.92,0,0,1,2.54-.77,12.19,12.19,0,0,1,1.25.42.86.86,0,0,0,.61-.07.52.52,0,0,0,.31-.52.55.55,0,0,1-.28.55.9.9,0,0,1-.66.13,10.44,10.44,0,0,0-1.25-.32,2.71,2.71,0,0,0-1.22.23,6,6,0,0,0-1.09.65c-.35.26-.69.53-1.06.78l-1.12.7a6,6,0,0,1-1.24.61,2.92,2.92,0,0,1-1.47.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "439.197px 221.034px"
    },
    id: "elsasjqxo2xwe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.9,217.88a1.35,1.35,0,0,1-.26,1c-.31.51-.76.74-.78.69s.33-.32.61-.79S441.84,217.87,441.9,217.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "441.386px 218.728px"
    },
    id: "el2xikepebj22",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,222c-.05,0-.39-.28-.91-.5s-1-.27-1-.33a1.53,1.53,0,0,1,1.07.15A1.51,1.51,0,0,1,440,222Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "439.045px 221.566px"
    },
    id: "el6zcgs8v84gy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.36,222.27a5.1,5.1,0,0,0,1.61,1.24,13.45,13.45,0,0,0,2,.8,10.09,10.09,0,0,1,4,2,4.09,4.09,0,0,1,.7.91c.19.34.31.69.46,1a2.22,2.22,0,0,0,.58.85,2.52,2.52,0,0,0,.94.47,11,11,0,0,1,2.12.64,1.67,1.67,0,0,1,.75.8,1.11,1.11,0,0,1,0,1.06,1.1,1.1,0,0,0,0-1,1.61,1.61,0,0,0-.76-.74,9.82,9.82,0,0,0-2.12-.53,2.91,2.91,0,0,1-1-.47,2.56,2.56,0,0,1-.7-.91,9.75,9.75,0,0,0-.49-1,3.44,3.44,0,0,0-.67-.8,6.18,6.18,0,0,0-1.82-1.08,19.29,19.29,0,0,0-2.07-.68,14.85,14.85,0,0,1-2.12-.74,5.69,5.69,0,0,1-1.9-1.36Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "439.762px 227.155px"
    },
    id: "elszdfifii7z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,225.5a1,1,0,0,0-.46.19,1.61,1.61,0,0,0-.37.4,1.83,1.83,0,0,1-.52.52,1.56,1.56,0,0,1-1.31.07c-.31-.12-.47-.26-.46-.28s.2.07.51.15a1.56,1.56,0,0,0,1.16-.11A1.59,1.59,0,0,0,443,226a1.85,1.85,0,0,1,.44-.41C443.78,225.38,444,225.48,444,225.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "442.44px 226.125px"
    },
    id: "elscmw4uogknq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.27,227.53s-.12-.3-.41-.53-.6-.24-.6-.3.08-.06.22-.06a.94.94,0,0,1,.51.21.87.87,0,0,1,.3.46C443.32,227.44,443.3,227.53,443.27,227.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "442.782px 227.085px"
    },
    id: "elz4mej6tilo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.65,227a.82.82,0,0,1,.07.47,2.12,2.12,0,0,1-1.25,1.84.82.82,0,0,1-.46.11,3.56,3.56,0,0,0,1.18-1A3.38,3.38,0,0,0,444.65,227Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "443.869px 228.211px"
    },
    id: "elwlfesuw0me9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.22,224.76a3,3,0,0,0-1-.82,3.06,3.06,0,0,0-1.32-.09s.13-.11.38-.17a1.73,1.73,0,0,1,1,.08,1.65,1.65,0,0,1,.8.62C444.21,224.59,444.24,224.75,444.22,224.76Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "443.063px 224.2px"
    },
    id: "elv5tijr7q5za",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.09,221.79a2.32,2.32,0,0,0,1.06-.62,1.13,1.13,0,0,0,.29-.46,1.88,1.88,0,0,0,0-.63,8.24,8.24,0,0,0-1-2.61,2.39,2.39,0,0,1-.25-1.52,2.22,2.22,0,0,1,.9-1.21,10.12,10.12,0,0,1,2.6-1.37,9.89,9.89,0,0,0-2.47,1.52,2,2,0,0,0-.75,1.12,2.12,2.12,0,0,0,.33,1.29,8.78,8.78,0,0,1,1.26,2.71,2.5,2.5,0,0,1,0,.82,1.71,1.71,0,0,1-.42.79,2.65,2.65,0,0,1-.62.54,2.39,2.39,0,0,1-.77.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "435.89px 217.95px"
    },
    id: "el1m6wp64p6da",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.56,213c.06,0,.11.35.11.79a1.77,1.77,0,0,1-.08.8c-.06,0-.11-.35-.11-.79A1.77,1.77,0,0,1,435.56,213Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "435.575px 213.795px"
    },
    id: "elm37ctyf3ev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.62,213.58c0-.05.3.19.42.56s.16.67.11.68-.16-.27-.29-.61A4.35,4.35,0,0,1,434.62,213.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "434.896px 214.197px"
    },
    id: "eljk15615lzxg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.32,215.7s.31,0,.61.2.42.49.38.51-.23-.16-.5-.35S433.3,215.76,433.32,215.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "433.818px 216.056px"
    },
    id: "elz8eocye53hm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.4,218.65a2.5,2.5,0,0,0,.41.35,2.63,2.63,0,0,0,1.28.3,4.37,4.37,0,0,1,.76.1,1.9,1.9,0,0,1,.59.25c.31.21.39.45.37.45s-.14-.17-.44-.33a3.15,3.15,0,0,0-1.3-.27,3.76,3.76,0,0,1-.76-.11,1.73,1.73,0,0,1-.58-.27C432.43,218.89,432.37,218.65,432.4,218.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "434.103px 219.375px"
    },
    id: "elkic7trkzbcb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.52,214.55a1.33,1.33,0,0,1,.33.67,2.33,2.33,0,0,1-.27,1.76c-.18.31-.39.57-.55.81a2.74,2.74,0,0,0-.34.69,2,2,0,0,0-.07.7s-.18-.27-.07-.74a2.17,2.17,0,0,1,.33-.74c.16-.26.36-.52.53-.81a2.39,2.39,0,0,0,.3-1.64C436.64,214.81,436.49,214.57,436.52,214.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "436.216px 216.865px"
    },
    id: "el6lhmedxkez",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.54,216.23c.06,0,.13.29.34.59s.47.48.44.54-.36-.08-.6-.42S435.49,216.23,435.54,216.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "435.917px 216.802px"
    },
    id: "elxiq5rq9722",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.1,216.88a1.87,1.87,0,0,1-.54.07,1.65,1.65,0,0,0-1.13.48c-.32.36-.52.81-.79,1s-.5.28-.5.26.19-.11.4-.36.39-.67.75-1.08a1.43,1.43,0,0,1,.65-.41,2.43,2.43,0,0,1,.61-.08A1.27,1.27,0,0,1,441.1,216.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "439.62px 217.726px"
    },
    id: "elwom048u9hy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.82,216.09s0,.12,0,.31a1.5,1.5,0,0,0,.18.71,1.36,1.36,0,0,0,.14.4,1.25,1.25,0,0,1,.08.35c0,.21,0,.34,0,.34s0-.13-.09-.31a1.53,1.53,0,0,0-.13-.32,1.34,1.34,0,0,1-.15-.4,1.29,1.29,0,0,1-.13-.79C437.69,216.16,437.81,216.07,437.82,216.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "437.963px 217.144px"
    },
    id: "elmughc6eux0q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.59,229.14a9.38,9.38,0,0,1,1,2.84,7.92,7.92,0,0,0,.94,2.64,3.1,3.1,0,0,0,.94,1,2.85,2.85,0,0,0,1.31.45,12,12,0,0,1,1.45.19,2.09,2.09,0,0,1,1.24.73,2,2,0,0,0-1.26-.64,13.76,13.76,0,0,0-1.45-.09,3.12,3.12,0,0,1-1.44-.4,3.73,3.73,0,0,1-1.11-1,8.59,8.59,0,0,1-1.17-2.72,9,9,0,0,0-1.06-2.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "436.725px 233.065px"
    },
    id: "elnbmeabqvzba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.33,231.57a8.1,8.1,0,0,0-.18,2.34,2.51,2.51,0,0,0,.31,1.06,3.07,3.07,0,0,0,.8.81,6.07,6.07,0,0,1,1.87,1.64,2.33,2.33,0,0,1-.08,2.39,2.22,2.22,0,0,0-.09-2.28A5.92,5.92,0,0,0,434,236.1a3.49,3.49,0,0,1-1-.86,3.1,3.1,0,0,1-.48-1.25,8.64,8.64,0,0,1,0-2.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "434.424px 235.63px"
    },
    id: "elv75eiebhoe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.2,235a1.15,1.15,0,0,1-.36.87,1.11,1.11,0,0,1-.82.46c0-.05.35-.23.67-.6S441.14,235,441.2,235Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "440.61px 235.665px"
    },
    id: "el3lxh75cpnc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.49,233.38c-.05,0-.2-.25-.47-.5s-.56-.37-.54-.42.36,0,.67.28S444.54,233.36,444.49,233.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "443.991px 232.911px"
    },
    id: "elvmbu5mgbjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.28,236.32s0,.14-.2.31a2,2,0,0,1-.75.48,2.07,2.07,0,0,1-.88.1c-.23,0-.36-.09-.35-.11a5.19,5.19,0,0,0,1.16-.18A5.39,5.39,0,0,0,444.28,236.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "443.19px 236.77px"
    },
    id: "el42mdp7pjvlw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,220.21a17.42,17.42,0,0,1,3.19,4.62c.6,1.75,1.57,4.51,1.57,4.51a11.78,11.78,0,0,0,1.41,2.2l-.65.24-.53-.36-1.24-.9-.38,1.69-1.29-.68a2.81,2.81,0,0,0,.5-2.05,17,17,0,0,0-.16-1.76l-1.1,1.53a4.52,4.52,0,0,0,.5-2.09,4.81,4.81,0,0,0-.68-1.87l-1.11,1.54a4.93,4.93,0,0,0,.4-2.07,1.11,1.11,0,0,0-.55-.79,5.86,5.86,0,0,0-2-1.82l-1.34-.45.54-1.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "431.165px 226.21px"
    },
    id: "elnsx0g2v2g8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.7,220.32a3,3,0,0,0,1.71-1,5.36,5.36,0,0,0,.58-.88,5.41,5.41,0,0,0,.37-1c.1-.34.19-.71.26-1.06a1.29,1.29,0,0,0-.12-1,3.93,3.93,0,0,1-.26-.5,2.17,2.17,0,0,1-.13-.56,2.15,2.15,0,0,1,0-.56c0-.17.14-.39.34-.39-.2,0-.28.24-.3.4a2,2,0,0,0,0,.54,2.24,2.24,0,0,0,.44,1,1.3,1.3,0,0,1,.23.54,2,2,0,0,1,0,.59c-.05.37-.12.73-.19,1.1a6.22,6.22,0,0,1-.31,1.1,6.69,6.69,0,0,1-.55,1,3.6,3.6,0,0,1-.83.87,4.58,4.58,0,0,1-1.08.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "437.271px 217.215px"
    },
    id: "elqhz0981669",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.74,218.7s.29,0,.52.25.34.45.3.49-.23-.13-.44-.35S433.72,218.75,433.74,218.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "434.153px 219.073px"
    },
    id: "elwcti1fdxtxq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.55,216.72s0-.11.15-.23a1.82,1.82,0,0,1,.53-.39,1,1,0,0,1,.67-.07c.17.05.25.13.24.15s-.11,0-.26,0a1.33,1.33,0,0,0-.57.12C432.9,216.48,432.6,216.77,432.55,216.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "433.345px 216.364px"
    },
    id: "elec6crcctlst",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.83,216.93s0-.12.15-.18a.64.64,0,0,1,.52.1c.35.19.53.49.48.52s-.26-.17-.58-.35a.64.64,0,0,0-.39-.13C436.91,216.9,436.85,216.94,436.83,216.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "437.409px 217.053px"
    },
    id: "elc85m5ktv3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.23,214.41s.09.06.2.16a1,1,0,0,0,.51.25,1.19,1.19,0,0,1,.56.31c.12.12.16.22.14.24a3.49,3.49,0,0,0-.76-.36,1.33,1.33,0,0,1-.33-.13.76.76,0,0,1-.22-.22C437.24,214.52,437.21,214.43,437.23,214.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "437.935px 214.89px"
    },
    id: "elt9i6ika1ej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,214s.08.08.13.23a1.17,1.17,0,0,1,.06.62,1.18,1.18,0,0,1-.31.54c-.1.11-.16.18-.18.17s0-.11.07-.25a1.64,1.64,0,0,0,.22-.5,1.68,1.68,0,0,0,0-.55C439,214.1,439,214,439,214Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "438.95px 214.78px"
    },
    id: "el4kyv2hjkpdo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.1,222.87a8.35,8.35,0,0,0,5.95,1.07,2.66,2.66,0,0,0,.7-.26,3.23,3.23,0,0,0,.57-.49c.19-.19.36-.4.57-.59a1.81,1.81,0,0,1,.74-.42c.29-.08.56,0,.81-.09a.84.84,0,0,0,.61-.4,15.49,15.49,0,0,0,.9-1.33c-.25.48-.52.94-.81,1.39a1.4,1.4,0,0,1-.28.32.93.93,0,0,1-.39.18,5.51,5.51,0,0,0-.78.13,2.88,2.88,0,0,0-1.13,1,3.11,3.11,0,0,1-.61.59,3.05,3.05,0,0,1-.78.36,8,8,0,0,1-3.3.19,8.32,8.32,0,0,1-3.18-1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "440.32px 222.485px"
    },
    id: "elglfrlhwkeoh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.85,219.31s-.09.06-.2.19a2.85,2.85,0,0,0-.34.57,1,1,0,0,0,0,.63c0,.19,0,.31,0,.3s0-.1-.1-.26a2.86,2.86,0,0,1-.1-.31.72.72,0,0,1,.05-.43,1.74,1.74,0,0,1,.42-.6C438.71,219.27,438.85,219.28,438.85,219.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "438.474px 220.146px"
    },
    id: "el52svanyj9pb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.36,218.21s0,.15-.16.31a1.27,1.27,0,0,0-.18.27,1,1,0,0,0,0,.41,1.36,1.36,0,0,1-.29.8c-.14.17-.26.23-.28.22a2.38,2.38,0,0,0,.37-1,1.12,1.12,0,0,1,.07-.47,1,1,0,0,1,.25-.3C440.26,218.29,440.34,218.2,440.36,218.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "439.905px 219.215px"
    },
    id: "el3m380izsylo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.05,220.88s-.08.05-.23.08a.47.47,0,0,1-.27,0,.44.44,0,0,1-.24-.26c-.07-.22-.1-.35-.2-.43s-.18-.09-.18-.11.1-.07.25,0a.5.5,0,0,1,.21.2c.05.09.07.2.11.28a.35.35,0,0,0,.33.23C441,220.83,441.05,220.85,441.05,220.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "440.49px 220.552px"
    },
    id: "el47zt03i55ki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.13,217.9a1,1,0,0,1,.27.73,1,1,0,0,1-.14.55c-.08.13-.16.18-.18.16s.14-.32.12-.7S441.07,217.92,441.13,217.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "441.24px 218.622px"
    },
    id: "elqzq7y365ug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,217s.21.16.49.28.52.12.53.17-.28.16-.61,0S440,217,440,217Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "440.51px 217.267px"
    },
    id: "elfkawrto1kl9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.13,216.31c0,.05-.13.22-.27.49s-.31.48-.36.46,0-.27.19-.55a1.15,1.15,0,0,1,.26-.33C440,216.31,440.11,216.29,440.13,216.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "439.806px 216.782px"
    },
    id: "el4mk6nlbji6w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.13,222.09a2.09,2.09,0,0,1-.36.54,2.9,2.9,0,0,1-1.26,1,1.91,1.91,0,0,1-.87.08.88.88,0,0,0-.6.18c-.31.23-.48.42-.5.4s.1-.23.41-.51a1,1,0,0,1,.69-.25,1.88,1.88,0,0,0,.81-.09,3.23,3.23,0,0,0,1.21-.85C440.94,222.25,441.1,222.07,441.13,222.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "439.334px 223.19px"
    },
    id: "elzdmv1tmcdf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.06,225.61a2,2,0,0,1,.29,1.2,1.78,1.78,0,0,1-.16.6.81.81,0,0,1-.52.44c-.44.11-.82-.06-1.14,0a4.65,4.65,0,0,0-1,.57,1.27,1.27,0,0,1-.58.17.68.68,0,0,1-.56-.26,1.62,1.62,0,0,1-.19-.56.49.49,0,0,0-.3-.4,2.28,2.28,0,0,1-.53-.24.66.66,0,0,1-.2-.54c0-.19,0-.38,0-.57a.56.56,0,0,0-.23-.49.59.59,0,0,1,.26.49c0,.19,0,.38,0,.57a.6.6,0,0,0,.21.48,2,2,0,0,0,.51.21.68.68,0,0,1,.26.18,1,1,0,0,1,.13.27,1.46,1.46,0,0,0,.18.51.57.57,0,0,0,.45.19,1,1,0,0,0,.49-.18,4.47,4.47,0,0,1,1-.63c.42-.12.82,0,1.13-.09a.45.45,0,0,0,.32-.28,1.44,1.44,0,0,0,.1-.5,1.55,1.55,0,0,0-.27-1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "437.648px 227.06px"
    },
    id: "elp068aibmkit",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,230.44s-.06,0-.17.06a1.19,1.19,0,0,1-.52,0,1,1,0,0,1-.62-.48,1.42,1.42,0,0,1-.17-.92,9.19,9.19,0,0,1,.51-1.56c.12-.4.11-.65.14-.66a1.13,1.13,0,0,1,0,.69c-.07.42-.36,1-.44,1.55a1.08,1.08,0,0,0,.62,1.24,1.7,1.7,0,0,0,.47,0C440.94,230.42,441,230.43,441,230.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "440.252px 228.704px"
    },
    id: "eltiik8b93cc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.74,225.5a3.2,3.2,0,0,1,.4.21,2.41,2.41,0,0,1,.42.27,1.61,1.61,0,0,1,.38.5,2.62,2.62,0,0,1,.16.59.88.88,0,0,0,.18.4c.18.19.36.14.36.17s0,0-.12.05a.45.45,0,0,1-.33-.12.86.86,0,0,1-.27-.45,3.19,3.19,0,0,0-.16-.55,1.72,1.72,0,0,0-.69-.74C436.83,225.67,436.72,225.52,436.74,225.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "437.689px 226.595px"
    },
    id: "elgvv4cnsfo58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.7,226.94c0,.05-.11.24-.2.51s-.13.5-.18.5-.13-.26,0-.57S436.66,226.9,436.7,226.94Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "436.475px 227.442px"
    },
    id: "ell4x9ppo303l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.35,228.37s.1.12,0,.34a2,2,0,0,1-.43.7,1.33,1.33,0,0,1-.73.38c-.2,0-.33,0-.33,0s.11-.08.29-.15a1.67,1.67,0,0,0,.63-.39,3.12,3.12,0,0,0,.44-.61C446.34,228.5,446.32,228.37,446.35,228.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "445.627px 229.08px"
    },
    id: "eljg1qrbhuu2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.38,230.88a4.6,4.6,0,0,0,2.35,1.62,8.07,8.07,0,0,0,1.47.35,6.62,6.62,0,0,1,.8.13,1.28,1.28,0,0,1,.72.52,12.08,12.08,0,0,1,1.28,2.88c.08.24.16.49.22.75a3.54,3.54,0,0,1,0,.79,6.9,6.9,0,0,1-.09.78.89.89,0,0,1-.14.37.39.39,0,0,1-.31.2.36.36,0,0,0,.29-.22.9.9,0,0,0,.12-.36,6.52,6.52,0,0,0,0-.77,3.08,3.08,0,0,0-.09-.75,6.18,6.18,0,0,0-.26-.72,12,12,0,0,0-1.39-2.72,1,1,0,0,0-.54-.34c-.22,0-.48,0-.75-.07a8.56,8.56,0,0,1-1.58-.27,5.36,5.36,0,0,1-2.79-1.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "438.466px 235.075px"
    },
    id: "elt9iqbip9478",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.25,233.31a3.52,3.52,0,0,0,.71-.25c.2-.11.43-.27.71-.43a2.09,2.09,0,0,1,.48-.19,2.42,2.42,0,0,1,.54-.06,2.77,2.77,0,0,0,1.7-.49c.38-.26.56-.5.59-.48a1.5,1.5,0,0,1-.51.6,2.67,2.67,0,0,1-1.77.57,3.39,3.39,0,0,0-1.68.6A1,1,0,0,1,440.25,233.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "442.615px 232.373px"
    },
    id: "elmdpla90jkzs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.5,232.73a1.66,1.66,0,0,1,.41.17.89.89,0,0,1,.38.35,1.2,1.2,0,0,1,0,.62,1.69,1.69,0,0,0,.15,1c.11.24.23.36.21.38s-.17-.07-.33-.31a1.56,1.56,0,0,1-.23-1.06,1.1,1.1,0,0,0,0-.52.77.77,0,0,0-.28-.31C437.62,232.87,437.48,232.76,437.5,232.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "438.075px 233.991px"
    },
    id: "el744y3njv18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.69,234.56s-.11-.11-.16-.33a1.22,1.22,0,0,1,0-.4c0-.14,0-.3,0-.46a2.12,2.12,0,0,0-.25-.76c-.1-.19-.15-.31-.13-.33s.12.08.25.26a1.64,1.64,0,0,1,.33.82c0,.18,0,.33,0,.48a1.49,1.49,0,0,0,0,.36A1.55,1.55,0,0,1,436.69,234.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "436.438px 233.419px"
    },
    id: "el5ugzk0jwiq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.29,230.63s-.2,0-.48.06a1.23,1.23,0,0,0-.82.73,1.9,1.9,0,0,1-.37.59.83.83,0,0,1-.53.23c-.33,0-.52-.05-.51-.07a4.25,4.25,0,0,1,.49-.06.8.8,0,0,0,.42-.23,2.16,2.16,0,0,0,.33-.55,1.31,1.31,0,0,1,.43-.55,1.14,1.14,0,0,1,.53-.22C439.11,230.51,439.3,230.61,439.29,230.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "437.935px 231.393px"
    },
    id: "elp2fdu3d5fuk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.28,230.31c.05,0-.12.27-.25.6s-.16.61-.21.61-.11-.32,0-.68S438.25,230.27,438.28,230.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "438.023px 230.913px"
    },
    id: "elr007vpaggi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.14,231a5.53,5.53,0,0,1-.24,1.16c-.11.35-.23.7-.35,1l-.74,2c-.12.34-.23.68-.32,1a2.83,2.83,0,0,0-.1.47c0,.16,0,.33,0,.53,0,.42-.13.76-.14,1.09a5.12,5.12,0,0,0,.05,1,2.92,2.92,0,0,0,.86,1.8,1.82,1.82,0,0,0,.89.46,4.63,4.63,0,0,0,1,0,2.12,2.12,0,0,1,1.11.18,1.54,1.54,0,0,1,.76.81,1.35,1.35,0,0,1,.09.56,4.12,4.12,0,0,1-.12.53.51.51,0,0,0,.27.41,2,2,0,0,1,.44.32,2.35,2.35,0,0,0-.45-.3.51.51,0,0,1-.31-.44c0-.19.09-.35.09-.53a1.22,1.22,0,0,0-.11-.5,1.32,1.32,0,0,0-.73-.7,2,2,0,0,0-1-.12A4.11,4.11,0,0,1,433,242a2.17,2.17,0,0,1-1.06-.47,3.31,3.31,0,0,1-1.08-2,6,6,0,0,1-.12-1.13c0-.4.09-.76.08-1.08,0-.16,0-.35,0-.55a3.48,3.48,0,0,1,.09-.59c.1-.37.2-.72.31-1.07l.69-2.06c.11-.34.21-.68.31-1a4.28,4.28,0,0,0,.18-1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "433.67px 237.66px"
    },
    id: "elczws6zvjor",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.22,238a.64.64,0,0,1,.55-.11,2.69,2.69,0,0,1,1.19.64c.41.33.67.75,1,.88a1,1,0,0,0,.5.1s0,.05-.14.08a.74.74,0,0,1-.42-.05,1.66,1.66,0,0,1-.5-.37,5,5,0,0,0-.52-.49,3,3,0,0,0-1.09-.65A1.73,1.73,0,0,0,436.22,238Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "437.84px 238.735px"
    },
    id: "elbx6gat51ebs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.79,240.49c-.05,0-.21-.29-.34-.69s-.21-.74-.16-.75.21.29.34.69A1.55,1.55,0,0,1,438.79,240.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "438.533px 239.77px"
    },
    id: "ell5xyh72lev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.88,237c0,.06-.24,0-.5,0s-.48.05-.5,0,.19-.19.49-.2S436.9,237,436.88,237Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "436.38px 236.913px"
    },
    id: "elgkgrm473kwm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.89,243s.1.06.23.16a1.51,1.51,0,0,0,.55.3c.48.05.91-.11.92,0s-.36.3-1,.24a1.24,1.24,0,0,1-.61-.39C435.91,243.08,435.87,243,435.89,243Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "436.738px 243.356px"
    },
    id: "elj1he2glmu7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.43,241.34c.05,0,0,.35-.36.56s-.68.14-.66.09.28-.08.55-.25S436.37,241.32,436.43,241.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "435.928px 241.691px"
    },
    id: "elweciwelckzb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.41,241.73a.88.88,0,0,1,.47.1,2.21,2.21,0,0,1,.91.7,1.83,1.83,0,0,1,.35,1.09c0,.3-.11.47-.13.46a3.48,3.48,0,0,1,0-.45,2,2,0,0,0-.37-1,2.54,2.54,0,0,0-.81-.68C433.57,241.82,433.4,241.76,433.41,241.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "434.275px 242.904px"
    },
    id: "elmjjiekttnpd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.44,245s-.18-.1-.43-.32a3.94,3.94,0,0,1-.89-1,2.59,2.59,0,0,1-.29-1.28c0-.33,0-.53.06-.53a1.52,1.52,0,0,1,.08.52,3.17,3.17,0,0,0,.32,1.19,5.91,5.91,0,0,0,.81,1A2,2,0,0,1,434.44,245Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "433.634px 243.435px"
    },
    id: "eliyvlj5z61rk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.79,244.92c-.05,0-.2-.34-.12-.79s.35-.72.39-.69-.12.33-.2.73S432.84,244.9,432.79,244.92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "432.857px 244.179px"
    },
    id: "elbgjvbyy2ze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.94,245.85a1.84,1.84,0,0,0-.22-.84c-.13-.24-.34-.49-.53-.82A1.45,1.45,0,0,1,431,243c.15-.44.5-.71.59-1s-.13-.6-.24-.86a1.44,1.44,0,0,1-.17-.9,4.14,4.14,0,0,0,.29.84,3.55,3.55,0,0,1,.23.4.78.78,0,0,1,.07.57c-.11.4-.47.67-.58,1a1.31,1.31,0,0,0,.15,1.08c.17.31.37.59.49.85a1.49,1.49,0,0,1,.16.66A.42.42,0,0,1,431.94,245.85Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "431.469px 243.045px"
    },
    id: "elaoo5emse4cq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.05,243a6.59,6.59,0,0,1-1,.35,3.93,3.93,0,0,1-1,.31,2.12,2.12,0,0,1,.91-.5A1.77,1.77,0,0,1,431.05,243Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "430.05px 243.317px"
    },
    id: "elg530o21vzoo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.12,227.69a5.41,5.41,0,0,1-.72,1.65c-.33.52-.78.91-1.13,1.37s-.51,1-.85,1.53a3.36,3.36,0,0,1-.6.65,1.5,1.5,0,0,0-.27.34.57.57,0,0,1-.31.3c.15,0,.22-.19.29-.31a1.83,1.83,0,0,1,.26-.36,3.84,3.84,0,0,0,.55-.67c.3-.5.46-1.07.77-1.59s.77-.91,1-1.4a5.21,5.21,0,0,0,.6-1.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "430.18px 230.57px"
    },
    id: "elt3jg7o2avca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.06,225a17.66,17.66,0,0,1-1.32,2.47c-.12.2-.25.39-.39.58a2.16,2.16,0,0,0-.33.56c-.13.4.11.87.08,1.33,0-.46-.34-.85-.27-1.37a2.55,2.55,0,0,1,.28-.67l.3-.61a16.43,16.43,0,0,0,.93-2.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "429.94px 227.345px"
    },
    id: "elf9f7vbad8gn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.85,229.57s-.17,0-.31-.19a1.76,1.76,0,0,1-.28-.82,1.51,1.51,0,0,1,.26-1.17,7.21,7.21,0,0,0-.06,1.15,2.54,2.54,0,0,0,.19.77C429.74,229.49,429.86,229.54,429.85,229.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "429.542px 228.48px"
    },
    id: "el0kga0x3a4kdl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.93,227.08c0-.06.33-.17.61-.49s.43-.66.49-.64,0,.41-.34.77S428.93,227.13,428.93,227.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "429.49px 226.523px"
    },
    id: "elmv09kk89uh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.63,231.14a1.46,1.46,0,0,0,.19-.45,3.89,3.89,0,0,0,0-.53,1.47,1.47,0,0,1,.17-.69,4.77,4.77,0,0,1,.76-1,2.57,2.57,0,0,1,.35-.37s-.05.2-.24.46a8.71,8.71,0,0,0-.69,1c-.23.41-.14.85-.25,1.18S427.64,231.17,427.63,231.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "428.365px 229.623px"
    },
    id: "elcin8ir6o0wi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.06,230.18s.13-.27.42-.45.59-.22.6-.17-.22.17-.49.33S427.1,230.21,427.06,230.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.57px 229.862px"
    },
    id: "elg00vhyxtiw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.76,223.61a4.53,4.53,0,0,0-1.73,2c-.23.42-.45.87-.73,1.29s-.62.8-.88,1.18a4.26,4.26,0,0,0-.51,1.31,3.53,3.53,0,0,1-.73,1.31,11.16,11.16,0,0,1-1.12,1,2.65,2.65,0,0,0-.91,1.11,2.76,2.76,0,0,1,.85-1.18,9,9,0,0,0,1-1,3.15,3.15,0,0,0,.61-1.26c.05-.23.1-.47.16-.72a3.15,3.15,0,0,1,.3-.71c.27-.45.58-.81.8-1.22s.42-.86.62-1.3a7.92,7.92,0,0,1,.72-1.34,3.85,3.85,0,0,1,1.15-1.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "426.455px 227.885px"
    },
    id: "elcfbecd0dkiv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.93,225.32c.06,0-.07.5-.08,1.1s.12,1.08.07,1.1a1.66,1.66,0,0,1-.26-1.1A1.77,1.77,0,0,1,427.93,225.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.797px 226.42px"
    },
    id: "elbo3sryhaa3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.83,225.17c0-.06.35-.13.74-.32s.65-.44.69-.4-.18.36-.61.57A1.06,1.06,0,0,1,426.83,225.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.547px 224.821px"
    },
    id: "elp2fv2fjhu1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.85,232.39s.06-.15,0-.37a2.35,2.35,0,0,0-.35-.83,1.56,1.56,0,0,1-.13-1c0-.24.09-.39.12-.38s0,.15,0,.39a1.86,1.86,0,0,0,.16.88c.08.16.17.31.24.47a1.1,1.1,0,0,1,.08.45C426,232.29,425.86,232.41,425.85,232.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "425.657px 231.101px"
    },
    id: "elfxvkkdv02nq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.93,232.11a3,3,0,0,1,.87-.57,3.17,3.17,0,0,1,1-.41,2.91,2.91,0,0,1-.88.58A2.74,2.74,0,0,1,422.93,232.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "423.865px 231.62px"
    },
    id: "el2sfar99zq73",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474,305.82a10.27,10.27,0,0,1,2.19.28,3.84,3.84,0,0,1,1,.44,4,4,0,0,1,.85.73c.49.55.9,1.13,1.35,1.7l1.31,1.71a17.06,17.06,0,0,0,1.36,1.67,3.21,3.21,0,0,0,.41.34,2.37,2.37,0,0,1,.4.37c.25.26.49.53.73.8.48.54,1,1.07,1.46,1.6.24.26.49.51.76.76l.41.35a1.7,1.7,0,0,0,.22.15.35.35,0,0,0,.26.06.35.35,0,0,1-.26-.06,1.07,1.07,0,0,1-.22-.15,4.46,4.46,0,0,1-.42-.34c-.26-.25-.52-.5-.77-.76-.5-.52-1-1.05-1.47-1.59-.24-.26-.48-.53-.73-.79a3.42,3.42,0,0,0-.4-.36,3.28,3.28,0,0,1-.43-.33,18.22,18.22,0,0,1-1.41-1.64l-1.37-1.67c-.46-.55-.89-1.14-1.38-1.65a3.45,3.45,0,0,0-1.77-1,9.81,9.81,0,0,0-2.11-.2Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "480.34px 311.302px"
    },
    id: "elofponwom8g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.78,327.54a1.37,1.37,0,0,1-1-.56,3.21,3.21,0,0,1-.45-1.38c-.65-4.05-1.19-8.17-1.59-12.25l.38,0c.4,4.07.93,8.18,1.58,12.22a2.92,2.92,0,0,0,.39,1.22.87.87,0,0,0,1,.36,1.17,1.17,0,0,0,.5-.79,7.1,7.1,0,0,0-.18-2.89l-.12-.63a33.1,33.1,0,0,1-.36-5.35,23,23,0,0,0-.83-7.12,2.05,2.05,0,0,0-.86-1.24l.16-.34a2.33,2.33,0,0,1,1.06,1.46,23.25,23.25,0,0,1,.85,7.24,31.11,31.11,0,0,0,.36,5.28q0,.31.12.63a7.44,7.44,0,0,1,.17,3,1.4,1.4,0,0,1-.72,1A.91.91,0,0,1,477.78,327.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "476.89px 318.165px"
    },
    id: "elofcez8ftsmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.21,306.43s0,.26,0,.7.13,1.1.13,1.91a3.27,3.27,0,0,1-.28,1.32,5.74,5.74,0,0,1-.9,1.24,7.45,7.45,0,0,1-2.78,2.12,3.78,3.78,0,0,1-1.82.17,8.21,8.21,0,0,1-1.64-.44,6.37,6.37,0,0,1-1.39-.66,3.23,3.23,0,0,1-.89-1A6.25,6.25,0,0,1,466,310c-.05-.22-.09-.39-.11-.5s0-.18,0-.19.08.24.21.68a6.91,6.91,0,0,0,.72,1.74,3,3,0,0,0,.87.94,5.6,5.6,0,0,0,1.35.62,7.53,7.53,0,0,0,1.6.43,3.58,3.58,0,0,0,1.74-.17,7.21,7.21,0,0,0,2.7-2,5.5,5.5,0,0,0,.89-1.19,3.07,3.07,0,0,0,.29-1.25c0-.8-.08-1.45-.07-1.9,0-.23,0-.41,0-.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "471.111px 310.182px"
    },
    id: "elaw2myqebio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.58,312.7s0,.37-.05,1.05a17.55,17.55,0,0,0,.14,2.87c.15,1.2.42,2.62.73,4.2.15.79.31,1.61.44,2.48a1.26,1.26,0,0,1-.08.71.73.73,0,0,1-.61.42.57.57,0,0,1-.38-.16,1.22,1.22,0,0,1-.2-.32c-.1-.22-.17-.43-.25-.65a29.5,29.5,0,0,1-1.89-9.3,11.13,11.13,0,0,1,.29-2.87,5.88,5.88,0,0,1,.24-.74,2.13,2.13,0,0,1,.11-.25,1.32,1.32,0,0,1-.07.26,6.22,6.22,0,0,0-.2.75,11.48,11.48,0,0,0-.23,2.85,30.75,30.75,0,0,0,1.93,9.23c.08.22.16.44.25.64s.22.36.4.36a.56.56,0,0,0,.44-.31,1.16,1.16,0,0,0,.06-.59c-.13-.86-.29-1.69-.43-2.48-.3-1.58-.56-3-.68-4.22a15.69,15.69,0,0,1-.09-2.88,7.63,7.63,0,0,1,.08-.78C467.56,312.79,467.58,312.7,467.58,312.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "467.142px 317.285px"
    },
    id: "eldi8uuywbf1t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.89,314l0,.32c0,.23,0,.53.06.91,0,.79.11,1.94.23,3.35a33.63,33.63,0,0,0,.78,4.9,23.54,23.54,0,0,0,.87,2.8,3.7,3.7,0,0,1,.21.76,1.41,1.41,0,0,1-.1.83,1.11,1.11,0,0,1-.64.56.69.69,0,0,1-.45,0,.73.73,0,0,1-.38-.25,15.21,15.21,0,0,1-2.38-5.63,44.06,44.06,0,0,1-.71-4.94c-.14-1.41-.21-2.55-.24-3.35,0-.39,0-.7,0-.91a1.57,1.57,0,0,1,0-.32l0,.32c0,.22,0,.53.05.91.06.79.15,1.93.31,3.34s.35,3.09.74,4.91a18.7,18.7,0,0,0,.87,2.8,13.06,13.06,0,0,0,1.49,2.74.56.56,0,0,0,.62.19,1,1,0,0,0,.52-.47,1.89,1.89,0,0,0-.11-1.43,24.4,24.4,0,0,1-.87-2.82,32.6,32.6,0,0,1-.74-4.94c-.11-1.41-.15-2.56-.17-3.35,0-.39,0-.69,0-.92A1.57,1.57,0,0,1,470.89,314Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "470.597px 320.749px"
    },
    id: "elmebwtlncu5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.73,313a.58.58,0,0,1,0,.21c0,.15,0,.35,0,.59.05.51.12,1.25.27,2.16.27,1.82.84,4.3,1.39,7.07a36.08,36.08,0,0,1,.59,3.93,6,6,0,0,1,0,1.75,1.4,1.4,0,0,1-1,1.11,1.48,1.48,0,0,1-1.2-.39,2.5,2.5,0,0,1-.55-.78,4.72,4.72,0,0,1-.22-.56l-.06-.2s.12.27.35.72a2.33,2.33,0,0,0,.55.73,1.32,1.32,0,0,0,1.1.34,1.26,1.26,0,0,0,.89-1,6.06,6.06,0,0,0,0-1.7,39.55,39.55,0,0,0-.61-3.91c-.55-2.75-1.1-5.25-1.33-7.08-.13-.91-.18-1.66-.21-2.18v-.59A1.66,1.66,0,0,1,473.73,313Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "474.497px 321.416px"
    },
    id: "eljsijhezi7h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.17,216.66c-.56-1.85-1.31-3.59-2-5.31-.35-.86-.68-1.72-1-2.59s-.54-1.79-.89-2.68a12.13,12.13,0,0,0-1.37-2.54c-.52-.78-1-1.56-1.48-2.37-.93-1.61-1.77-3.28-2.6-5,.69,1.74,1.38,3.48,2.19,5.18.39.85.84,1.69,1.29,2.5a12.15,12.15,0,0,1,1.09,2.49c.26.86.42,1.77.65,2.7s.48,1.84.76,2.74l0,.09a27.2,27.2,0,0,0-1.78-3.11,10.64,10.64,0,0,0-5.72-4,21,21,0,0,0-6.8-.78,21.64,21.64,0,0,0-5,1,16.06,16.06,0,0,0-5.34,2.63,30.7,30.7,0,0,0-6.26,5.5c-2.79,3.41-4.3,7.73-5.63,11.54l1.44.49c1.35-3.87,2.75-7.87,5.36-11.08a29.51,29.51,0,0,1,6-5.21,15,15,0,0,1,4.88-2.42,20.28,20.28,0,0,1,4.64-.91,19.47,19.47,0,0,1,6.31.71,9.2,9.2,0,0,1,4.92,3.43,37,37,0,0,1,3.05,5.94c.27.62.54,1.24.83,1.88l.82-.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.225px 210.655px"
    },
    id: "els10uond8o5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.34,304.46a8.19,8.19,0,0,0-1.23-3.56c-1.28-2.16-2.59-4.28-3.89-6.42a30.41,30.41,0,0,1-1.77-3.27,11.49,11.49,0,0,1-1-3.5c-.26-2.43.38-4.89.46-7.43a23.35,23.35,0,0,0-1-7.52,21.77,21.77,0,0,0-1.43-3.55c-.14-.28-.28-.57-.44-.84l-.24-.42c-.07-.13-.14-.25-.2-.38a14.08,14.08,0,0,1-.64-1.69c-.36-1.16-.66-2.37-1-3.59-.17-.61-.34-1.22-.57-1.83a6.34,6.34,0,0,0-.41-.95,2.61,2.61,0,0,0-.38-.49,1.09,1.09,0,0,0-.35-.25l-.17,0a22.12,22.12,0,0,0,0-2.82,14.59,14.59,0,0,0-.68-3.64l0,.07-3.8-19.81c0-2.33-.2-4.63-.46-7a43.76,43.76,0,0,0-1.29-6.93,16.32,16.32,0,0,0-1.34-3.37,22.13,22.13,0,0,0-2.07-2.94,26,26,0,0,0-5.24-4.86,18,18,0,0,0-6.64-2.91,15,15,0,0,0-3.67-.26,12,12,0,0,0-3.66.73,7.44,7.44,0,0,0-1.18.55c0-.19,0-.38-.08-.58a7.9,7.9,0,0,0-.84-2.36,10.71,10.71,0,0,0-1.4-2,9.13,9.13,0,0,0-1.83-1.59c-.41-.28-.82-.54-1.22-.8q.29-.93.54-1.89c.3-1.11.54-2.24.75-3.36s.4-2.24.57-3.36a17,17,0,0,0,.35-3.48c0-.19,0-.39-.06-.59l.08,0a3.55,3.55,0,0,1,.53-1.37,11.58,11.58,0,0,0,.93-1.51,4.91,4.91,0,0,0,.3-.89,8.23,8.23,0,0,0,.19-.86,11.53,11.53,0,0,0,.17-1.76,11.64,11.64,0,0,1,.2-3.28,13.36,13.36,0,0,1,.69-1.52,5.23,5.23,0,0,0,.32-.84,4.5,4.5,0,0,0,.15-.88c.06-.59.07-1.13.17-1.68s.22-1.1.33-1.67a9.31,9.31,0,0,0,0-3.45,9.52,9.52,0,0,0-3.41-5.78,9.38,9.38,0,0,1,3.14,5.83,9,9,0,0,1-.16,3.32c-.12.55-.27,1.09-.39,1.66s-.17,1.16-.24,1.7a4.3,4.3,0,0,1-.49,1.52,15.12,15.12,0,0,0-.78,1.56,12.11,12.11,0,0,0-.37,3.48,11.28,11.28,0,0,1-.23,1.62c-.06.27-.12.53-.2.79a3.41,3.41,0,0,1-.29.71,11.21,11.21,0,0,1-.92,1.35,3.13,3.13,0,0,0-.2.3c-.15-.39-.3-.78-.44-1.16a10.89,10.89,0,0,1-.63-3.2c-.07-1.1.14-2.19.16-3.37a4.93,4.93,0,0,0-.25-1.77,3.57,3.57,0,0,0-.45-.81,3.85,3.85,0,0,0-.65-.63c-.47-.37-1-.65-1.36-1a3.85,3.85,0,0,1-1-1.29,7.57,7.57,0,0,1-.64-3.24,27.22,27.22,0,0,1,.21-3.37q.18-1.7.51-3.36c-.25,1.11-.46,2.22-.63,3.34a29.47,29.47,0,0,0-.33,3.39,8.06,8.06,0,0,0,.55,3.39,4.56,4.56,0,0,0,1,1.45c.44.41.93.71,1.35,1.06a2.71,2.71,0,0,1,.89,1.26,4.11,4.11,0,0,1,.17,1.57c-.06,1.09-.32,2.23-.28,3.41a12,12,0,0,0,.55,3.45,21.72,21.72,0,0,1,.69,2.18c0,.05,0,.1,0,.15l.08,0a4.25,4.25,0,0,1,.07.8,16.37,16.37,0,0,1-.45,3.25c-.21,1.11-.43,2.22-.68,3.31S424.28,195,424,196q-.21.69-.45,1.41a6.44,6.44,0,0,1-1-1,8.41,8.41,0,0,1-1.59-3.86,25.74,25.74,0,0,1-.31-4.41c0-1.49,0-3,0-4.48q.09-4.48.43-9-.58,4.45-.9,8.94c-.1,1.49-.19,3-.25,4.49a29,29,0,0,0,.08,4.56,9.41,9.41,0,0,0,1.6,4.43,8.49,8.49,0,0,0,1.54,1.57c-.05.18-.11.35-.17.53a19.21,19.21,0,0,0-.75,3.45,14.35,14.35,0,0,0,1,7,14.54,14.54,0,0,0,1.81,3.15h0c-.38,1.47-.53,2.89-.83,4.26l1.85.41c.25-1.2.4-2.33.63-3.44a18.13,18.13,0,0,1,.92-3.17,8.59,8.59,0,0,1,1.66-2.67,7.16,7.16,0,0,1,2.57-1.73,10.35,10.35,0,0,1,3.16-.67,13.34,13.34,0,0,1,3.28.19,16.19,16.19,0,0,1,6.1,2.58,24.53,24.53,0,0,1,5,4.53,20.48,20.48,0,0,1,2,2.72,14.74,14.74,0,0,1,1.26,3.08,41.75,41.75,0,0,1,1.35,6.71q.12.93.21,1.86a13.63,13.63,0,0,0-.24,1.59c-.05.58-.09,1.15-.17,1.7a5.5,5.5,0,0,1-.16.77l-.24.84c-.16.56-.31,1.13-.43,1.71a11,11,0,0,0-.19,3.57,19.92,19.92,0,0,0,.71,3.45,33.55,33.55,0,0,1,1.56,6.7,28.54,28.54,0,0,1-.11,3.45,6.25,6.25,0,0,0,.61,3.38,6.09,6.09,0,0,1-.46-3.37,33.34,33.34,0,0,0,.26-3.47,34.14,34.14,0,0,0-1.29-6.84,19.46,19.46,0,0,1-.55-3.36,10.25,10.25,0,0,1,.32-3.31c.13-.55.3-1.09.48-1.63l.22-.64c0,.16,0,.32,0,.48v.1l4.08,19.79v.08a10.33,10.33,0,0,1,.44,1.66c.11.57.18,1.15.24,1.74a23.23,23.23,0,0,1,0,3.54,29.69,29.69,0,0,1-.44,3.52l-.3,1.78c-.08.6-.18,1.2-.23,1.8-.14,1.2-.19,2.41-.22,3.61s0,2.41.11,3.62a30.7,30.7,0,0,0,1.34,7.1,18.21,18.21,0,0,0,1.51,3.3c.6,1,1.25,2,1.87,3.07a22.64,22.64,0,0,1,2.93,6.5,16.94,16.94,0,0,1,.48,3.54,33.21,33.21,0,0,1-.21,3.58c-.08,1.2-.15,2.4-.13,3.59q0,.9.12,1.8a8.57,8.57,0,0,0,.18.88,1.41,1.41,0,0,0,.43.77,1.46,1.46,0,0,1-.42-.77,6.78,6.78,0,0,1-.16-.88,15.51,15.51,0,0,1-.1-1.8c0-1.19.08-2.39.18-3.58a30.79,30.79,0,0,0,.26-3.59,17.26,17.26,0,0,0-.43-3.58,23.15,23.15,0,0,0-2.87-6.61c-.61-1-1.25-2-1.83-3.09A17.78,17.78,0,0,1,460,280.8a29.11,29.11,0,0,1-1.23-7c-.08-1.19-.09-2.38-.06-3.57s.11-2.37.26-3.55c.06-.6.17-1.18.25-1.77l.33-1.76A29.27,29.27,0,0,0,460,260a.05.05,0,0,1,0,0,6,6,0,0,1,.36.76c.21.55.39,1.15.56,1.74.35,1.19.66,2.4,1.06,3.61a13.11,13.11,0,0,0,.72,1.81c.08.15.16.3.25.44l.23.4c.16.26.3.53.44.8a20.56,20.56,0,0,1,1.44,3.38,22.49,22.49,0,0,1,1.11,7.24c0,2.45-.62,4.94-.3,7.51a12.09,12.09,0,0,0,1.12,3.65,29.21,29.21,0,0,0,1.86,3.28c1.34,2.12,2.7,4.22,4,6.34a8,8,0,0,1,1.26,3.43,5.33,5.33,0,0,1-1,3.47,4.61,4.61,0,0,1-3.09,1.87,3.44,3.44,0,0,1-3.26-1.42,3.51,3.51,0,0,0,3.27,1.5,4.67,4.67,0,0,0,3.19-1.87A5.43,5.43,0,0,0,474.34,304.46ZM428.08,207a.46.46,0,0,1-.07.07,10.3,10.3,0,0,0-2.06,3.17c-.07.14-.12.29-.18.44a12.49,12.49,0,0,1-1.89-4.69,12.57,12.57,0,0,1-.18-3.18,16.46,16.46,0,0,1,.58-3.2h0c.26.19.52.37.77.57a7.19,7.19,0,0,1,1.48,1.43,8.28,8.28,0,0,1,1.1,1.75A5.21,5.21,0,0,1,428.08,207Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "447.109px 234.955px"
    },
    id: "el1ns0fgkuku8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.82,169.24a2.51,2.51,0,0,1-.11.33,6.44,6.44,0,0,0-.17.92,5.57,5.57,0,0,1-.3,1.38,5.86,5.86,0,0,1-.42.72,2.53,2.53,0,0,0-.28.8,4.46,4.46,0,0,0-.05,1.66,3.93,3.93,0,0,0,.45,1.28,7.53,7.53,0,0,0,.75,1s-.11-.06-.28-.21a3.82,3.82,0,0,1-.59-.75,3.91,3.91,0,0,1-.51-1.32,4.4,4.4,0,0,1,0-1.73,2.87,2.87,0,0,1,.32-.86,6.81,6.81,0,0,0,.42-.7,5.67,5.67,0,0,0,.32-1.33,4.28,4.28,0,0,1,.24-.91A.94.94,0,0,1,428.82,169.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "428.022px 173.285px"
    },
    id: "elw0vq1aodv3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.92,168.93a4.87,4.87,0,0,1,.16.6c.08.37.25.87.39,1.44a4.51,4.51,0,0,1,.16,1.51,1.16,1.16,0,0,1-.16.61,5.68,5.68,0,0,1,0-.62,5.86,5.86,0,0,0-.21-1.45c-.14-.57-.29-1.08-.34-1.47A1.32,1.32,0,0,1,426.92,168.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.261px 171.01px"
    },
    id: "elkyyau0oprb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.73,175.28a3.58,3.58,0,0,1,.31,1,12.39,12.39,0,0,1,.29,2.51,2,2,0,0,0,.3,1.26,2.45,2.45,0,0,0,.89.61c.59.25,1,.3,1,.33a.61.61,0,0,1-.28,0,3,3,0,0,1-.75-.19,2.36,2.36,0,0,1-1-.63,2.06,2.06,0,0,1-.36-1.37,15.66,15.66,0,0,0-.23-2.48C421.8,175.68,421.7,175.29,421.73,175.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "423.122px 178.143px"
    },
    id: "eljulo5f96sfs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.42,182.34a4.28,4.28,0,0,1,.32.87,15.18,15.18,0,0,1,.52,2.21,11.6,11.6,0,0,0,.18,1.21,1.67,1.67,0,0,0,.51.81c.42.36.77.49.75.52a.64.64,0,0,1-.24-.07,2.2,2.2,0,0,1-.6-.35,1.71,1.71,0,0,1-.6-.86,11.14,11.14,0,0,1-.19-1.24c-.13-.86-.33-1.63-.46-2.19A4.33,4.33,0,0,1,423.42,182.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "424.56px 185.15px"
    },
    id: "elkugtosxka8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,180.83a16.47,16.47,0,0,1,.64,2.35,5.39,5.39,0,0,0,.89,1.44,1.83,1.83,0,0,1,.33.64,4.93,4.93,0,0,1-.44-.56c-.14-.18-.31-.37-.5-.6a2.23,2.23,0,0,1-.47-.86A13.49,13.49,0,0,1,422.11,180.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "423.04px 183.045px"
    },
    id: "el617zykpqeae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.51,170.85s-.07.48-.13,1.24a6.67,6.67,0,0,0,0,1.33,5.77,5.77,0,0,0,.42,1.56c.21.55.44,1.06.61,1.54a6,6,0,0,1,.31,1.33,3.11,3.11,0,0,1-.05.92.85.85,0,0,1-.12.32,4.5,4.5,0,0,0,0-1.22,6.36,6.36,0,0,0-.34-1.29c-.18-.47-.41-1-.63-1.53a5.87,5.87,0,0,1-.41-1.61,6.13,6.13,0,0,1,0-1.37,6.91,6.91,0,0,1,.16-.9A1.41,1.41,0,0,1,419.51,170.85Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "419.933px 174.97px"
    },
    id: "elrcb5agvcsb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.37,156.93a1.31,1.31,0,0,1,.39,0,4.45,4.45,0,0,1,1,.26,5.27,5.27,0,0,1,1.36.79,7.06,7.06,0,0,1,1.31,1.4,16.25,16.25,0,0,1,1.65,3,2.3,2.3,0,0,1,.23,1,.94.94,0,0,1-.08.38s0-.14,0-.38a2.7,2.7,0,0,0-.29-1,20.11,20.11,0,0,0-1.68-3,6.39,6.39,0,0,0-2.56-2.17A7.3,7.3,0,0,0,424.37,156.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.34px 160.338px"
    },
    id: "eltxuvkytlu9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.53,261.15a6.5,6.5,0,0,0-5.1-.24,8.25,8.25,0,0,0-2.29,1.4c-.72.58-1.4,1.23-2.14,1.84a10.87,10.87,0,0,1-1.16.86,7.89,7.89,0,0,1-1.3.65,13.32,13.32,0,0,1-2.81.56,6.17,6.17,0,0,0-2.63.84,3.77,3.77,0,0,0-1,.95,2.28,2.28,0,0,0-.4,1.32A2.29,2.29,0,0,1,402,268a3.6,3.6,0,0,1,1-1,5.32,5.32,0,0,1,1.28-.65,13.28,13.28,0,0,1,1.38-.35,13.18,13.18,0,0,0,2.7-.68,7.14,7.14,0,0,0,1.18-.66,11.37,11.37,0,0,0,1.07-.88c.69-.62,1.33-1.3,2-2a9,9,0,0,1,2.44-1.65,7.51,7.51,0,0,1,5.9,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.321px 264.428px"
    },
    id: "el7nnecn1zw7g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.15,297.11l-1.88-.21c.69-6.11,4-10.4,7.48-15,.91-1.18,1.86-2.42,2.76-3.69a31.64,31.64,0,0,0,4.43-9.95,24.6,24.6,0,0,0,.5-5.22c0-.73,0-1.49.08-2.24a63,63,0,0,1,1-7.22L424.31,238l1.87.33L423.39,254a60.74,60.74,0,0,0-1,7c-.05.72-.06,1.46-.08,2.18a26.2,26.2,0,0,1-.56,5.62,33.8,33.8,0,0,1-4.72,10.59c-.92,1.3-1.88,2.55-2.8,3.75C410.93,287.43,407.79,291.53,407.15,297.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "415.725px 267.555px"
    },
    id: "elcjlngqzuqxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.77,266.87a56.61,56.61,0,0,1,7.2,9.58,46.6,46.6,0,0,1,4.73,11,45.81,45.81,0,0,1,1.66,11.86,51.83,51.83,0,0,1-.29,6l-.63,5.86c-.81,7.82-1.37,15.66-1.94,23.5-.14,2-.34,3.93-.44,5.88a27.6,27.6,0,0,0,.16,5.76c0,.23.09.45.14.68l.18.72c.11.49.22,1,.32,1.46l.59,2.89c.19,1,.4,1.91.66,2.84.13.47.27.92.42,1.4s.29,1,.42,1.44c1,3.86,1.35,7.81,2.21,11.61.21.95.45,1.89.75,2.81s.62,1.86.95,2.78a31.08,31.08,0,0,1,2.26,11.63c0,1,0,2,0,3s0,2-.09,3a115.71,115.71,0,0,1-1.23,11.76c-.61,3.89-1.36,7.76-2.16,11.61l-1.24,5.77-.63,2.88a18,18,0,0,0-.48,2.89,4.07,4.07,0,0,0,.73,2.74c.55.83,1,1.72,1.51,2.54s1.24,1.52,1.87,2.27,1.29,1.49,1.95,2.23c1.31,1.46,2.65,2.91,4.05,4.29a34.29,34.29,0,0,0,4.48,3.86,35,35,0,0,1-4.51-3.82c-1.41-1.38-2.77-2.81-4.1-4.27-.66-.73-1.31-1.46-2-2.21s-1.29-1.48-1.9-2.27-1-1.71-1.53-2.52a4.3,4.3,0,0,1-.78-2.84,17.85,17.85,0,0,1,.44-2.93l.6-2.89,1.18-5.78c.77-3.86,1.47-7.73,2-11.62a114.8,114.8,0,0,0,1.11-11.71c0-1,0-2,.06-2.94s0-2,0-2.94a36.48,36.48,0,0,0-.62-5.81c-.74-3.8-2.66-7.33-3.51-11.25s-1.28-7.8-2.32-11.55c-.12-.46-.26-.93-.42-1.39s-.31-.94-.44-1.42c-.28-1-.51-1.93-.71-2.9l-.62-2.88c-.1-.48-.21-.95-.33-1.42l-.19-.71c-.05-.25-.13-.51-.16-.76a29,29,0,0,1-.24-6c.09-2,.26-3.94.38-5.9.49-7.85,1-15.71,1.69-23.56l.57-5.87a49,49,0,0,0,.23-5.81,44.08,44.08,0,0,0-1.71-11.42,44.57,44.57,0,0,0-4.65-10.58,55.12,55.12,0,0,0-7.05-9.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "435.115px 356.14px"
    },
    id: "el09oiu5qe3mxx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.06,257a1.89,1.89,0,0,0,1.65.05,5.5,5.5,0,0,0,1.68-1.14,5.26,5.26,0,0,1,1.94-1.33,1.64,1.64,0,0,1,.7,0,1.36,1.36,0,0,1,.66.29,1.6,1.6,0,0,1,.51,1.22,2.51,2.51,0,0,1-.29,1.18c-.18.35-.4.65-.59,1a3.19,3.19,0,0,0-.43.94,6.15,6.15,0,0,0-.15,1.06,8.39,8.39,0,0,1-.13,1.11,3,3,0,0,1-.45,1,7.49,7.49,0,0,1-1.56,1.57,7.27,7.27,0,0,0,1.44-1.65,3,3,0,0,0,.36-1,9.51,9.51,0,0,0,.06-1.08,5.47,5.47,0,0,1,.08-1.13,3.83,3.83,0,0,1,.41-1.07,3.5,3.5,0,0,0,.68-1.91,1,1,0,0,0-.34-.74.79.79,0,0,0-.75-.06,4.73,4.73,0,0,0-1.56,1.27,6.74,6.74,0,0,1-1.88,1.44,3.76,3.76,0,0,1-1.26.31,2.65,2.65,0,0,1-1.36-.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "425.34px 259.246px"
    },
    id: "elvwpen343am",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.87,256a9.89,9.89,0,0,1,2.75-1.77,3.71,3.71,0,0,1,1.65-.25,3.43,3.43,0,0,1,1.58.54,4.4,4.4,0,0,1,1.87,2.64,6.83,6.83,0,0,1-.07,3.24,11.5,11.5,0,0,1-1.23,3,6.84,6.84,0,0,1-5.25,3.41,20.36,20.36,0,0,1-3.22.13,19.26,19.26,0,0,0,3.22-.18,7.31,7.31,0,0,0,3-1.1,7,7,0,0,0,2.13-2.34,10.51,10.51,0,0,0,1.17-3,6.5,6.5,0,0,0,0-3.13,4.12,4.12,0,0,0-1.8-2.46,3.11,3.11,0,0,0-1.45-.47,3.44,3.44,0,0,0-1.51.25,9.56,9.56,0,0,0-2.61,1.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "431.916px 260.462px"
    },
    id: "elhyhzbui7rxg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.58,261.89a6.1,6.1,0,0,1-.14-.74,2.14,2.14,0,0,0-.28-.73,1.63,1.63,0,0,0-.74-.58,2,2,0,0,1-.84-.62,1.37,1.37,0,0,1-.19-.84,1.57,1.57,0,0,1,.2-.74s0,.29-.06.74a1.32,1.32,0,0,0,.2.74,1.87,1.87,0,0,0,.78.54,1.75,1.75,0,0,1,.8.66,2.21,2.21,0,0,1,.27.81A1.71,1.71,0,0,1,430.58,261.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "429.503px 259.765px"
    },
    id: "elqroh2cy7u8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.36,258.52s-.14.05-.38,0a1.74,1.74,0,0,1-.8-.44,1.63,1.63,0,0,1-.47-.79c-.06-.23,0-.38,0-.38a3.14,3.14,0,0,0,.61,1A3,3,0,0,0,430.36,258.52Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "429.522px 257.726px"
    },
    id: "elg3psxfi8u9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,257.37s-.09,0-.25,0a2.4,2.4,0,0,1-.65-.15,1.73,1.73,0,0,1-.83-.57c-.25-.32-.3-.76-.55-1a1.15,1.15,0,0,0-1-.3,2,2,0,0,0-.86.36,7,7,0,0,1-.71.53,2.37,2.37,0,0,1,.63-.64,2,2,0,0,1,.91-.43,1.27,1.27,0,0,1,1.19.35c.31.36.34.79.56,1.06a1.73,1.73,0,0,0,.73.56C433.62,257.3,434,257.34,434,257.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "431.575px 256.254px"
    },
    id: "elmyfhwk078mm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.78,256.59c-.06,0-.08-.62-.37-1.31s-.69-1.15-.64-1.19a2.21,2.21,0,0,1,.83,1.12A2.18,2.18,0,0,1,434.78,256.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "434.294px 255.34px"
    },
    id: "ellzervys3s68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.84,262s-.36.23-.83.72a4.15,4.15,0,0,0-.68,1,6.92,6.92,0,0,0-.5,1.36,2.33,2.33,0,0,1-.88,1.22,3.33,3.33,0,0,1-1.13.48,5.13,5.13,0,0,1-.81.15c-.19,0-.29,0-.3,0s.42-.1,1.07-.29a3.48,3.48,0,0,0,1.06-.5,2.12,2.12,0,0,0,.8-1.13,6.91,6.91,0,0,1,.52-1.39,4.18,4.18,0,0,1,.75-1,3.93,3.93,0,0,1,.65-.5C433.73,262.05,433.83,262,433.84,262Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "431.275px 264.465px"
    },
    id: "el4svqq8tjazo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,262.45s.09.17.1.47a2.92,2.92,0,0,1-.21,1.14,2.82,2.82,0,0,1-.66.95c-.22.2-.38.29-.4.27a5.59,5.59,0,0,0,.87-1.3A5.65,5.65,0,0,0,435,262.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "434.465px 263.866px"
    },
    id: "elb45xir0t8n6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.88,267.41s-.09.06-.16,0a.12.12,0,0,1-.07-.14.11.11,0,0,1,.16,0C421.87,267.3,421.91,267.36,421.88,267.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "421.768px 267.336px"
    },
    id: "elgr4pmtjf99l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.21,261.25a19.33,19.33,0,0,0,.39,2.79,4.64,4.64,0,0,0,1.15,2.31,49.46,49.46,0,0,1,4.32,4c.65.76,1.22,1.54,1.84,2.26a11.09,11.09,0,0,0,2.11,1.87c.77.57,1.6,1.1,2.35,1.77a6.39,6.39,0,0,1,1.77,2.46,9.53,9.53,0,0,1,.62,2.91,13.21,13.21,0,0,1-.14,2.95,10.77,10.77,0,0,1-2.38,5.34c-1.29,1.54-3.18,2.29-4.53,3.68a11.59,11.59,0,0,0-3,4.91,11.6,11.6,0,0,1,2.86-5c1.34-1.45,3.22-2.25,4.41-3.77a10.4,10.4,0,0,0,2.17-5.21,12.34,12.34,0,0,0,.06-2.85,8.71,8.71,0,0,0-.64-2.73A5.86,5.86,0,0,0,434,276.7c-.72-.61-1.54-1.11-2.35-1.67a11.67,11.67,0,0,1-2.28-1.94c-.67-.73-1.26-1.51-1.9-2.21a49.89,49.89,0,0,0-4.36-3.8,4.07,4.07,0,0,1-1-1.31,7.44,7.44,0,0,1-.54-1.47,18.88,18.88,0,0,1-.48-2.95Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "428.939px 279.875px"
    },
    id: "elq9bki6mece9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.81,302.84a9.41,9.41,0,0,0,2.44-.37,7,7,0,0,0,2.17-1.07,5.23,5.23,0,0,0,1.55-1.79,4.69,4.69,0,0,0,.54-2.29,4.08,4.08,0,0,0-.2-1.15,4.53,4.53,0,0,0-.55-1.07c-.23-.36-.49-.72-.71-1.13a6.2,6.2,0,0,1-.49-1.3,7.28,7.28,0,0,1-.12-2.71,12,12,0,0,1,.68-2.58c.3-.82.71-1.62,1-2.39a3.81,3.81,0,0,0,.27-1.19,6.8,6.8,0,0,0-.09-1.26,7.12,7.12,0,0,1-.08-2.65,6.49,6.49,0,0,1,1.3-2.31,7.57,7.57,0,0,0,1.27-2.22,7,7,0,0,0,.34-2.53,6.76,6.76,0,0,0-2.1-4.59,6.79,6.79,0,0,1,2.24,4.58,7,7,0,0,1-.28,2.61,6.49,6.49,0,0,1-.52,1.21,12.26,12.26,0,0,1-.72,1.1A6.33,6.33,0,0,0,440.6,280a6.52,6.52,0,0,0,.16,2.51,7.34,7.34,0,0,1,.12,1.34,4,4,0,0,1-.27,1.34c-.32.84-.68,1.6-.95,2.42a10.6,10.6,0,0,0-.58,2.46,6.5,6.5,0,0,0,.17,2.45,5,5,0,0,0,.46,1.12c.2.35.45.69.71,1.06a5.76,5.76,0,0,1,.66,1.23,4.64,4.64,0,0,1,.28,1.39,5.48,5.48,0,0,1-.56,2.73,6.23,6.23,0,0,1-1.77,2.17,8.08,8.08,0,0,1-2.46,1.3,11.46,11.46,0,0,1-2.69.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "438.552px 286.125px"
    },
    id: "el5gh068b7558",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.79,285.51a2.55,2.55,0,0,1,0-.35,2.58,2.58,0,0,0-.17-.92,1.33,1.33,0,0,0-.37-.5,2.14,2.14,0,0,0-.64-.33c-.25-.08-.53-.15-.81-.26a2.85,2.85,0,0,1-.79-.5,4.06,4.06,0,0,0-.72-.5,1.21,1.21,0,0,0-.76-.13,2,2,0,0,0-1.14.71,6.88,6.88,0,0,0-.52.79c-.11.2-.17.31-.19.3a1.25,1.25,0,0,1,.12-.33,4.68,4.68,0,0,1,.48-.85,2.07,2.07,0,0,1,1.22-.8,1.51,1.51,0,0,1,.88.13,4.93,4.93,0,0,1,.76.53,2.92,2.92,0,0,0,.73.47c.26.11.54.18.79.27a2.06,2.06,0,0,1,.7.38,1.49,1.49,0,0,1,.39.57,2.46,2.46,0,0,1,.12,1A1.12,1.12,0,0,1,446.79,285.51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "443.78px 283.666px"
    },
    id: "eli3r2pgaqyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.9,285.12a9.93,9.93,0,0,0,.17-1.17,9.64,9.64,0,0,0-.15-1.17,1.66,1.66,0,0,1,.35,1.17A1.73,1.73,0,0,1,443.9,285.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "444.088px 283.95px"
    },
    id: "elqw4ictceie9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,274.88a3,3,0,0,1-.3,1,3.77,3.77,0,0,1-1.57,1.87,4.08,4.08,0,0,1-1.32.38,5,5,0,0,0-1,.24,2.08,2.08,0,0,0-.81.55s.15-.42.75-.68a4.26,4.26,0,0,1,1.07-.29,4.16,4.16,0,0,0,1.25-.37,3.91,3.91,0,0,0,1.54-1.76A10,10,0,0,1,446,274.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "443.5px 276.9px"
    },
    id: "el9f8ayko3lal",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.69,270.58a11.57,11.57,0,0,0,.16,1.19,5.62,5.62,0,0,0,.44,1.21,2.57,2.57,0,0,0,1,1.14,7.78,7.78,0,0,1,.74.42,2,2,0,0,1,.53.61,2.45,2.45,0,0,1,.28,1.31,3.67,3.67,0,0,1-.16.88,1.14,1.14,0,0,1-.12.31s.12-.46.14-1.19a2.52,2.52,0,0,0-.3-1.22,1.68,1.68,0,0,0-.49-.54,6.85,6.85,0,0,0-.72-.4,2.64,2.64,0,0,1-1.07-1.24,4.59,4.59,0,0,1-.41-1.26,3.93,3.93,0,0,1-.07-.89A1.14,1.14,0,0,1,438.69,270.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "440.241px 274.115px"
    },
    id: "el2julg1huftb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.92,304.1a3.11,3.11,0,0,1,2.14-.28,4.07,4.07,0,0,1,1.77.89,5.51,5.51,0,0,1,1.64,3.19,13.42,13.42,0,0,1,.21,1.61q.07.8.09,1.59c0,1,0,2.1,0,3.14-.1,2.08-.31,4.13-.46,6.17s-.26,4.08-.31,6.13-.06,4.09,0,6.14a15.68,15.68,0,0,0,.27,3c.2,1,.6,1.92.87,2.94a11.82,11.82,0,0,1,0,6.19,12,12,0,0,1-.52,1.46,8.54,8.54,0,0,0-.49,1.45,5.26,5.26,0,0,0,.24,3,5.32,5.32,0,0,1-.36-3,9.15,9.15,0,0,1,.44-1.49,13,13,0,0,0,.46-1.46,11.52,11.52,0,0,0-.18-6c-.3-1-.74-1.9-1-2.94a17.45,17.45,0,0,1-.41-3.11c-.13-2-.21-4.12-.23-6.18s0-4.13.07-6.19.21-4.11.23-6.14c0-1,0-2-.09-3a19.4,19.4,0,0,0-.38-2.92,5.2,5.2,0,0,0-.45-1.26,2.59,2.59,0,0,0-.72-.92,2.14,2.14,0,0,0-1-.45,1.27,1.27,0,0,0-.86.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "437.236px 327.231px"
    },
    id: "elnydykmv81w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.36,299.26a4.33,4.33,0,0,1,1.3.77,2.73,2.73,0,0,1,.89,1.5,2.36,2.36,0,0,1,0,.92,4.71,4.71,0,0,1-.22.69,2.63,2.63,0,0,0-.25.82,1.22,1.22,0,0,0,.24.66,7.21,7.21,0,0,0,.67.84,7.2,7.2,0,0,1,.8,1.05,3.94,3.94,0,0,1,.47,1.36,15.87,15.87,0,0,1,0,2.47,12.72,12.72,0,0,0,.19,2.22c.07.38.15.73.25,1.12a5.91,5.91,0,0,1,.21,1.27,3.21,3.21,0,0,1-.24,1.35,7.8,7.8,0,0,1-.56,1.12,7.36,7.36,0,0,0-.87,2.05,9.19,9.19,0,0,0-.25,2.23,28.31,28.31,0,0,0,.57,4.62,56.73,56.73,0,0,1,1,9.37,58.15,58.15,0,0,0-1.44-9.28,26.78,26.78,0,0,1-.82-4.68,9.54,9.54,0,0,1,.14-2.44,8.26,8.26,0,0,1,.85-2.32,3.61,3.61,0,0,0,.57-2,4.91,4.91,0,0,0-.23-1c-.12-.36-.24-.77-.33-1.17a14.32,14.32,0,0,1-.33-2.44,13.93,13.93,0,0,0-.13-2.24,2.51,2.51,0,0,0-.34-.84,5,5,0,0,0-.67-.78,11.07,11.07,0,0,1-.85-1,2.64,2.64,0,0,1-.48-2.34c.06-.25.14-.45.19-.63a1.15,1.15,0,0,0,.11-.68.92.92,0,0,0-.34-.46,2.64,2.64,0,0,0-.75-.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "442.311px 317.475px"
    },
    id: "elvkan82wpwaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.23,301.57a8.23,8.23,0,0,1,3.37.38,3.79,3.79,0,0,1,1.54,1.12,4.11,4.11,0,0,1,.8,1.64,5.59,5.59,0,0,1,.14,1.72,7.29,7.29,0,0,1-.33,1.61c-.15.5-.31,1-.43,1.44a8.32,8.32,0,0,0-.22,1.4,8.14,8.14,0,0,0,.3,2.86,9.34,9.34,0,0,0,.53,1.36c.22.45.48.89.68,1.38a10.34,10.34,0,0,1,.61,3,7.32,7.32,0,0,1-.13,3,7.19,7.19,0,0,0-.11-3,10,10,0,0,0-.8-2.85c-.22-.44-.5-.85-.77-1.3a8.73,8.73,0,0,1-.68-1.41,9.17,9.17,0,0,1-.58-3.11,8.57,8.57,0,0,1,.13-1.6c.09-.53.22-1,.32-1.51a5.58,5.58,0,0,0,.17-1.37,4.18,4.18,0,0,0-.2-1.28,2.47,2.47,0,0,0-.6-1,2,2,0,0,0-1-.57,6.63,6.63,0,0,0-2.65-.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "445.774px 312.006px"
    },
    id: "elhxfn3aofzxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.18,331.6s.14-.19.3-.57a3.54,3.54,0,0,0,.23-1.73,9.52,9.52,0,0,0-.63-2.53,14.14,14.14,0,0,0-1.46-2.87,5.07,5.07,0,0,1-.77-1.52,3.46,3.46,0,0,1,.11-1.58,9.65,9.65,0,0,0,.27-2.6,4.58,4.58,0,0,0-.41-1.7c-.19-.37-.34-.55-.32-.57l.11.13a1.8,1.8,0,0,1,.27.41,4.21,4.21,0,0,1,.49,1.72,9.44,9.44,0,0,1-.23,2.65,3.3,3.3,0,0,0-.1,1.5,4.72,4.72,0,0,0,.75,1.46,13.6,13.6,0,0,1,1.46,2.9,9.37,9.37,0,0,1,.6,2.59,3.54,3.54,0,0,1-.3,1.77,1.87,1.87,0,0,1-.25.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "447.181px 323.765px"
    },
    id: "el772p14xqi6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.48,325.67s-.09.18-.23.48a4.12,4.12,0,0,0-.36,1.22c-.15,1-.12,1.84-.19,1.83a4.89,4.89,0,0,1,0-1.86,3.5,3.5,0,0,1,.43-1.25C447.3,325.79,447.47,325.65,447.48,325.67Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "447.045px 327.434px"
    },
    id: "eltct0hha90jg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.44,312.32s0-.37,0-.95a1.73,1.73,0,0,0-.35-.91c-.23-.28-.67-.4-1-.73a2.37,2.37,0,0,1-.64-1.15,3.37,3.37,0,0,1-.09-1.06,3.47,3.47,0,0,1,.13-.95,6.71,6.71,0,0,1,0,1,3.72,3.72,0,0,0,.12,1,2.32,2.32,0,0,0,.6,1.05c.31.3.76.42,1,.77a1.67,1.67,0,0,1,.36,1,4.37,4.37,0,0,1,0,.71C449.47,312.24,449.45,312.33,449.44,312.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "448.468px 309.445px"
    },
    id: "el3zrrr5pffit",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,336.29a6.45,6.45,0,0,1-.29-1.19l-.27-1.29a12.44,12.44,0,0,0-.35-1.57,4,4,0,0,0-.83-1.34l-.83-1a7.49,7.49,0,0,1-.73-1,7,7,0,0,1,.84.89l.86,1a4.09,4.09,0,0,1,.88,1.4,12,12,0,0,1,.34,1.59l.22,1.31A9.36,9.36,0,0,1,447,336.29Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "445.35px 332.595px"
    },
    id: "elikdq1qwdy7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.9,331.28a10.31,10.31,0,0,0,0-1.32,4.6,4.6,0,0,0-.33-1.37,7.08,7.08,0,0,0-.92-1.49c-.38-.49-.77-1-1.07-1.42a5.22,5.22,0,0,1-.63-1.32,2.77,2.77,0,0,1-.12-1,1.29,1.29,0,0,1,.07-.35,4,4,0,0,0,.18,1.29,5.47,5.47,0,0,0,.65,1.27c.3.44.69.9,1.08,1.4a6.53,6.53,0,0,1,.92,1.54,4.4,4.4,0,0,1,.31,1.43,3.81,3.81,0,0,1-.08,1A1,1,0,0,1,441.9,331.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "440.435px 327.145px"
    },
    id: "elrwunak0amx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,316.41c-.06,0-.16-.74-.53-1.56s-.84-1.4-.79-1.44a3.11,3.11,0,0,1,1,1.36A3.15,3.15,0,0,1,441,316.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "440.343px 314.91px"
    },
    id: "elm8ebxq3gp28",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.5,313.43s0,0,0,0a1.07,1.07,0,0,0-.24.22,4.47,4.47,0,0,0-.55.9,18.41,18.41,0,0,0-.85,2.27c-.25.79-.47,1.6-.7,2.44-.07.21-.13.42-.21.64a3.86,3.86,0,0,1-.14.39l-.16.3-.58,1.12a7.42,7.42,0,0,0-.76,2.17,3.06,3.06,0,0,0,.35,2,2.4,2.4,0,0,0,.71.71c.32.23.7.44,1.08.73a12.11,12.11,0,0,1,1.88,1.92,7.11,7.11,0,0,0,1.73,1.62,2.9,2.9,0,0,0,1,.35,6.63,6.63,0,0,1,1.34.27,6.31,6.31,0,0,1,1.21.64c.36.24.72.47,1.08.75a4,4,0,0,1,.94,1,3.15,3.15,0,0,1,.4,1.34,14.43,14.43,0,0,0,.13,2.51,3.78,3.78,0,0,0,1.56,1.82,5.05,5.05,0,0,1,.95.9,2.25,2.25,0,0,1,.48,1.21,11.54,11.54,0,0,1-.1,2.56,12.67,12.67,0,0,0,0-2.54,2.23,2.23,0,0,0-.51-1.11,5.72,5.72,0,0,0-1-.81,7.62,7.62,0,0,1-1-.79,2.59,2.59,0,0,1-.75-1.13,13.13,13.13,0,0,1-.29-2.56,2.45,2.45,0,0,0-.38-1.08,3,3,0,0,0-.83-.8c-.33-.23-.7-.44-1.06-.66a5.79,5.79,0,0,0-1.08-.5,6.42,6.42,0,0,0-1.19-.17,3.81,3.81,0,0,1-1.38-.39,7.84,7.84,0,0,1-2.1-1.73,10.86,10.86,0,0,0-1.78-1.65c-.31-.21-.69-.4-1.08-.65a3.66,3.66,0,0,1-1.13-1,4.5,4.5,0,0,1-.7-2.9,8.55,8.55,0,0,1,.76-2.7l.54-1.17.12-.28a1,1,0,0,0,.07-.21c.06-.18.11-.38.17-.57.21-.81.42-1.65.66-2.49a19.26,19.26,0,0,1,.89-2.54,6.77,6.77,0,0,1,.76-1.29,3.32,3.32,0,0,1,.69-.64,1.91,1.91,0,0,1,1.19-.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "435.974px 327.872px"
    },
    id: "eldepnlm6ryp9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.43,333.18a1.82,1.82,0,0,1,.29-.14,1.65,1.65,0,0,0,.63-.58,1.57,1.57,0,0,0,.2-.55,2,2,0,0,0,0-.68,1.52,1.52,0,0,1,.06-.81,1.66,1.66,0,0,1,.58-.68,9.13,9.13,0,0,1,1.46-.74,2.7,2.7,0,0,0,1-.75,1.43,1.43,0,0,0,.33-.78,2.67,2.67,0,0,0,0-.32.57.57,0,0,1,.08.32,1.42,1.42,0,0,1-.3.86,2.71,2.71,0,0,1-1.06.84,9.66,9.66,0,0,0-1.43.73,1.51,1.51,0,0,0-.51.59,1.36,1.36,0,0,0-.05.72,2.55,2.55,0,0,1,0,.73,1.51,1.51,0,0,1-.25.59,1.54,1.54,0,0,1-.7.58A.66.66,0,0,1,425.43,333.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.745px 330.165px"
    },
    id: "eltjuhvcfnoo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.31,339.88s.16-.69.26-1.82a11.79,11.79,0,0,0-.45-4.36,8,8,0,0,1-.47-2.43,2.79,2.79,0,0,1,.24-1.06,6.32,6.32,0,0,1,.45-.83,3.66,3.66,0,0,0,.53-1.21c.05-.31,0-.48,0-.49s0,0,0,.13a1.39,1.39,0,0,1,0,.37,3.38,3.38,0,0,1-.49,1.27,3.8,3.8,0,0,0-.63,1.83,7.87,7.87,0,0,0,.48,2.36,11.06,11.06,0,0,1,.4,4.44,10.66,10.66,0,0,1-.24,1.33A1.7,1.7,0,0,1,429.31,339.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "429.271px 333.779px"
    },
    id: "eltycjbki3m7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.57,351.65s0,0,0,0,0,0,0,.05a1.71,1.71,0,0,0-.14.5,8.94,8.94,0,0,0-.07,1.5c0,1.06.1,2.18,0,3.34a7.54,7.54,0,0,1-.3,1.78,4,4,0,0,1-.41.9,3.25,3.25,0,0,1-.31.42l-.31.31a3.34,3.34,0,0,0-.89,1.08,2.22,2.22,0,0,0,0,1.31,7.6,7.6,0,0,0,.53,1.46,3.16,3.16,0,0,1,.34,1.81,2.64,2.64,0,0,1-.34.87,4.16,4.16,0,0,0-.35.7,4.24,4.24,0,0,0,0,3,7.26,7.26,0,0,0,.78,1.41,10.13,10.13,0,0,1,.82,1.44,2.27,2.27,0,0,1,.13,1.62,2.2,2.2,0,0,0-.24-1.57,8.87,8.87,0,0,0-.91-1.35,8.46,8.46,0,0,1-.92-1.4,4.79,4.79,0,0,1-.43-1.66,4.57,4.57,0,0,1,.2-1.72,13.5,13.5,0,0,0,.54-1.47c.09-.86-.77-1.75-1.1-2.92a3.28,3.28,0,0,1,0-1.92,4.52,4.52,0,0,1,1-1.56l.25-.29a1.53,1.53,0,0,0,.16-.25,2.32,2.32,0,0,0,.22-.61,6.24,6.24,0,0,0,.14-1.46c0-1-.15-2.1-.25-3.22a11.49,11.49,0,0,1,0-1.78,3.19,3.19,0,0,1,.26-1.08,2.06,2.06,0,0,1,.42-.62,1.84,1.84,0,0,1,.73-.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "430.808px 362.49px"
    },
    id: "eltx0jvaht22h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.77,343.1,430.15,346c-.26.48-.54,1-.75,1.44a5.25,5.25,0,0,0-.34,1.57c-.05.54,0,1.08-.05,1.63l0,1.64v.82a1.61,1.61,0,0,1-.18.81,2,2,0,0,1-.61.55c-.22.16-.46.36-.45.65a.86.86,0,0,1,.43-.66,2.11,2.11,0,0,0,.59-.56,1.64,1.64,0,0,0,.15-.79v-.82l0-1.64c0-.54,0-1.09,0-1.65a5.06,5.06,0,0,1,.31-1.63,14.8,14.8,0,0,1,.72-1.5l1.53-2.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "429.77px 349.035px"
    },
    id: "eldpxn9uc4pur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.13,367.9a.93.93,0,0,0-.32.29,5.54,5.54,0,0,0-.5.82,14.65,14.65,0,0,0-.8,2c-.47,1.41-.84,2.89-1.2,4.37-.7,3-1.3,6-2,9-.32,1.5-.69,3-1.07,4.5a15.36,15.36,0,0,0-.34,4.4c.13,3,.8,6,1.22,9.08a44.21,44.21,0,0,1,.17,9.27,90.6,90.6,0,0,1-1.24,9.15l-.86,4.52a14.51,14.51,0,0,1-.56,2.25,10.52,10.52,0,0,1-1,2.07,7.48,7.48,0,0,0-.49,1,10.7,10.7,0,0,0-.3,1.11,10.92,10.92,0,0,0-.26,2.28,6.4,6.4,0,0,0,.37,2.25,3.94,3.94,0,0,0,1.34,1.83,4,4,0,0,1-1.36-1.82,6.25,6.25,0,0,1-.39-2.26,10.36,10.36,0,0,1,.24-2.29,10.83,10.83,0,0,1,.29-1.12,6.7,6.7,0,0,1,.47-1.06,11.08,11.08,0,0,0,1-2.07,15.41,15.41,0,0,0,.49-2.24l.73-4.54a90.93,90.93,0,0,0,1-9.13,43.2,43.2,0,0,0-.42-9.1c-.49-3-1.25-6-1.48-9.14a16.92,16.92,0,0,1,.25-4.75c.35-1.51.66-3,.95-4.49.57-3,1.09-6,1.72-9.06.31-1.52.65-3,1.1-4.55a16.62,16.62,0,0,1,.84-2.28,6.64,6.64,0,0,1,.67-1.16,3.06,3.06,0,0,1,.56-.59,2.15,2.15,0,0,1,.95-.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "431.335px 402.045px"
    },
    id: "elab73dwyapd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.52,367.53c.55,3.7,1,7.41,1.32,11.16a48.51,48.51,0,0,1,.15,5.66c-.06,1.89-.24,3.76-.44,5.62-.87,7.41-1.69,14.82-3.12,22.17-.36,1.83-.76,3.66-1.2,5.47s-.92,3.61-1.27,5.42a26.11,26.11,0,0,0-.57,5.49,22.42,22.42,0,0,0,.78,5.46c.24.89.53,1.77.86,2.64a13.24,13.24,0,0,0,1.21,2.48,21,21,0,0,0,3.7,4.13c.7.62,1.42,1.22,2.15,1.79.36.3.75.56,1.1.87s.67.66,1,1c.65.67,1.3,1.34,2,2,.34.33.68.64,1,.94.18.15.36.3.55.43a3.07,3.07,0,0,0,.31.17.49.49,0,0,0,.33.07.54.54,0,0,1-.33-.06,1.92,1.92,0,0,1-.31-.18c-.19-.13-.38-.27-.56-.42-.36-.3-.7-.61-1-.93-.68-.64-1.33-1.31-2-2-.33-.33-.65-.67-1-1s-.75-.55-1.12-.84c-.74-.56-1.48-1.14-2.19-1.74a21.6,21.6,0,0,1-3.83-4.1,13.19,13.19,0,0,1-1.28-2.51,24.51,24.51,0,0,1-.94-2.65,23.6,23.6,0,0,1-.93-5.55,27.71,27.71,0,0,1,.45-5.61c.32-1.85.76-3.67,1.16-5.48s.75-3.64,1.06-5.47c1.25-7.31,1.89-14.73,2.59-22.14.16-1.84.29-3.68.31-5.52a48,48,0,0,0-.27-5.48c-.35-3.68-.91-7.34-1.52-11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "438.632px 409.018px"
    },
    id: "el0ez9bu5mmh9d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.86,397.31s.07-.3.12-.84a10.21,10.21,0,0,0-.1-2.31,16.48,16.48,0,0,1-.3-3.44,6.33,6.33,0,0,1,.47-2c.24-.67.55-1.33.75-2a7.16,7.16,0,0,0,.25-2.14c0-.7-.06-1.38-.09-2-.06-1.29-.11-2.46-.16-3.44s-.07-1.75-.09-2.32v-.86a.86.86,0,0,1,0,.22c0,.17,0,.38.05.63,0,.58.09,1.36.15,2.32s.13,2.15.2,3.44c0,.64.08,1.32.1,2a7.51,7.51,0,0,1-.24,2.19c-.21.73-.52,1.4-.77,2.05a6.45,6.45,0,0,0-.47,1.95,18.4,18.4,0,0,0,.25,3.41,9.26,9.26,0,0,1,.05,2.32,3.54,3.54,0,0,1-.13.63A.8.8,0,0,1,431.86,397.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "432.396px 386.635px"
    },
    id: "elo8q9oakyad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,393.22a4.74,4.74,0,0,1-.16-.91c-.1-.63-.21-1.36-.33-2.18s-.26-1.54-.37-2.17a4.3,4.3,0,0,1-.13-.91,4,4,0,0,1,.27.88c.13.55.29,1.32.43,2.17s.22,1.63.27,2.2A3.9,3.9,0,0,1,434,393.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "433.514px 390.135px"
    },
    id: "el7fftueqx8vk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,401.14a2.57,2.57,0,0,1,.07-.49c.06-.32.13-.77.21-1.34a25,25,0,0,0,.18-4.46,24.43,24.43,0,0,0-.64-4.42c-.14-.56-.26-1-.35-1.31a2.79,2.79,0,0,1-.12-.49,1.81,1.81,0,0,1,.19.46,13.06,13.06,0,0,1,.41,1.3,21,21,0,0,1,.71,4.45,21.39,21.39,0,0,1-.24,4.49c-.1.57-.19,1-.28,1.34A2.49,2.49,0,0,1,438,401.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "438.019px 394.885px"
    },
    id: "elm3qkyha4mva",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.77,393.9a139.14,139.14,0,0,1-1.26-2.94,4.27,4.27,0,0,1,.81,1.4A4.57,4.57,0,0,1,439.77,393.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "439.14px 392.43px"
    },
    id: "el0qzfs19hpeai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.24,357.9s0,.08.07.22.1.36.17.63a18.61,18.61,0,0,1,.39,2.38,19,19,0,0,1,0,3.57,23.9,23.9,0,0,1-.78,4.3,28.28,28.28,0,0,0-.84,4.26,14,14,0,0,0,.18,3.52c.17,1,.37,1.8.49,2.35l.15.63c0,.15,0,.23,0,.23a1,1,0,0,1-.08-.22c-.05-.16-.11-.37-.18-.62-.15-.55-.37-1.34-.55-2.34a13.25,13.25,0,0,1-.23-3.57,26.91,26.91,0,0,1,.83-4.29,25.73,25.73,0,0,0,.79-4.27,20.92,20.92,0,0,0,0-3.54,20.42,20.42,0,0,0-.33-2.37C440.3,358.21,440.22,357.91,440.24,357.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "439.975px 368.945px"
    },
    id: "elbhvpqlyq9j8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.78,359s0,.12,0,.35,0,.54-.05.94a13.57,13.57,0,0,1-.54,3.09,21.88,21.88,0,0,1-1.33,2.85c-.34.71-.46,1.19-.49,1.19a1.12,1.12,0,0,1,.05-.35,6.8,6.8,0,0,1,.32-.9c.3-.75.89-1.7,1.26-2.85a17,17,0,0,0,.59-3A10.38,10.38,0,0,1,442.78,359Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "441.575px 363.21px"
    },
    id: "elu8vbxoa38k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.2,420.49a3.53,3.53,0,0,1,.2-.67c.14-.43.34-1.05.54-1.83a19.65,19.65,0,0,0,.56-2.76,21.36,21.36,0,0,0,.1-3.44c-.06-1.22-.16-2.39-.24-3.45s-.14-2-.15-2.83a18.38,18.38,0,0,1,.08-1.91l.06-.52a.65.65,0,0,1,0-.18v.19q0,.21,0,.51c0,.45,0,1.1,0,1.91s.09,1.75.19,2.81.2,2.23.25,3.46a20.58,20.58,0,0,1-.11,3.47,18,18,0,0,1-.6,2.78c-.23.77-.45,1.39-.61,1.81-.08.21-.14.37-.19.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "435.009px 411.695px"
    },
    id: "elljmgryhmfn8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.8,422.27a1.64,1.64,0,0,1-.16-.36,5.49,5.49,0,0,1-.26-1.05,6.77,6.77,0,0,1,.38-3.52,14.44,14.44,0,0,1,.87-1.76,15.53,15.53,0,0,0,.71-1.41,9.71,9.71,0,0,0,.46-1.38s0,.14,0,.39a5.11,5.11,0,0,1-.3,1,12.8,12.8,0,0,1-.68,1.44,15.83,15.83,0,0,0-.84,1.75,7.05,7.05,0,0,0-.43,3.43C433.63,421.73,433.84,422.26,433.8,422.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "434.548px 417.53px"
    },
    id: "elaz55lbgthth",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,397.13c-.06,0-.13-.86-.46-1.85s-.79-1.73-.74-1.76a4.34,4.34,0,0,1,.92,1.7A4.22,4.22,0,0,1,433,397.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "432.406px 395.325px"
    },
    id: "elyctcprqp72",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.54,353a.72.72,0,0,1-.07-.49,1.47,1.47,0,0,1,.59-1c.19-.14.39-.22.52-.34a.89.89,0,0,0,.24-.4,2.7,2.7,0,0,0,.05-.46s.14.17.09.49a1,1,0,0,1-.26.5,3.34,3.34,0,0,1-.53.37,1.49,1.49,0,0,0-.56.9C427.55,352.84,427.58,353,427.54,353Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "428.213px 351.655px"
    },
    id: "el7kir9i182o5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.85,351.66a2.1,2.1,0,0,1,0-.5c0-.32.07-.78.09-1.36a9.68,9.68,0,0,0-.13-2c-.14-.74-.45-1.51-.68-2.37a4.87,4.87,0,0,1-.2-1.29,6.64,6.64,0,0,1,.11-1.21,14.82,14.82,0,0,0,.31-2,3.43,3.43,0,0,0-.17-1.33c-.11-.3-.21-.45-.19-.46s0,0,.08.1a1.57,1.57,0,0,1,.18.33,3.38,3.38,0,0,1,.24,1.36,14.12,14.12,0,0,1-.27,2,6.37,6.37,0,0,0-.1,1.17,5,5,0,0,0,.2,1.25c.22.84.54,1.63.66,2.39a8.13,8.13,0,0,1,.1,2,12.65,12.65,0,0,1-.15,1.36A2.7,2.7,0,0,1,442.85,351.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "442.516px 345.398px"
    },
    id: "elwxh22p1svri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.17,227.47c-.15-1.43-.27-7.82-.49-9.2a16.73,16.73,0,0,0-1.08-4,9.91,9.91,0,0,0-1-1.75,7.91,7.91,0,0,0-1.31-1.46,9.74,9.74,0,0,0-3.44-1.93,12.6,12.6,0,0,0-4-.6,18.31,18.31,0,0,0-4.05.4,12.64,12.64,0,0,0-1.93.58c-.31.12-.61.26-.92.41s-.62.31-.92.48a31.24,31.24,0,0,0-3.55,2.18,16.92,16.92,0,0,0-5.48,6.08,26.09,26.09,0,0,0-2.18,8.12c-.77,5.69-1.53,11.4-2.33,17.09l-1.22,8.54-.62,4.26c-.22,1.43-.41,2.85-.66,4.27a21.24,21.24,0,0,1-1.11,4.21,11.61,11.61,0,0,1-1,2,10.18,10.18,0,0,1-1.34,1.72c-1,1-2.16,1.88-3.17,2.85a10.71,10.71,0,0,0-1.36,1.58,7.27,7.27,0,0,0-.89,1.89,13.46,13.46,0,0,0-.47,4.21c0,1.42.12,2.86.15,4.3.09,2.88.05,5.76-.09,8.64s-.39,5.74-.75,8.59c-.09.72-.19,1.43-.29,2.14a7,7,0,0,1-.59,2.07,3.2,3.2,0,0,1-.62.87,2.29,2.29,0,0,1-.92.52,2,2,0,0,1-1.05.06,1.43,1.43,0,0,1-.87-.55,1.46,1.46,0,0,0,.88.54,2,2,0,0,0,1-.07,2.26,2.26,0,0,0,.9-.52,3.11,3.11,0,0,0,.61-.87,7.23,7.23,0,0,0,.56-2.06c.09-.71.18-1.42.26-2.14.34-2.85.55-5.72.67-8.59s.11-5.75,0-8.62c-.05-1.43-.16-2.86-.21-4.31a14.13,14.13,0,0,1,.45-4.33,7.32,7.32,0,0,1,.91-2,9.82,9.82,0,0,1,1.41-1.66c1-1,2.16-1.87,3.12-2.88a9.68,9.68,0,0,0,1.26-1.66,11.35,11.35,0,0,0,.91-1.89,21.91,21.91,0,0,0,1-4.11c.23-1.41.41-2.84.6-4.26l.58-4.28,1.12-8.54c.75-5.71,1.45-11.4,2.15-17.12a27.45,27.45,0,0,1,2.19-8.46,18.07,18.07,0,0,1,5.75-6.54,30.93,30.93,0,0,1,3.65-2.29c.31-.18.63-.34.94-.51s.67-.33,1-.47a14.53,14.53,0,0,1,2.1-.65,19.63,19.63,0,0,1,4.31-.48,14.27,14.27,0,0,1,4.34.61,11.16,11.16,0,0,1,3.92,2.15,9.21,9.21,0,0,1,1.55,1.69,11.76,11.76,0,0,1,1.13,2,18.53,18.53,0,0,1,1.23,4.31c.25,1.45.38,7.86.55,9.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "394.04px 256.951px"
    },
    id: "el52x5ksib768",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.54,209.67c1-3.79,1.51-8.89.29-12.65-.6-1.88-1.5-3.73-2.07-5.74a23,23,0,0,1-.87-6.12,12.23,12.23,0,0,1,1.43-6c.92-1.83,2.09-3.5,3-5.29a11.49,11.49,0,0,0,1.05-2.81,4.66,4.66,0,0,0,.13-.73,4.74,4.74,0,0,0,.06-.75,6.75,6.75,0,0,0-.09-1.49c-.31-2-1.21-3.89-1.28-5.93.14,2,1.08,3.88,1.47,5.9a7.09,7.09,0,0,1,.14,1.53,5,5,0,0,1,0,.77,5,5,0,0,1-.11.76,11.9,11.9,0,0,1-1,2.91c-.88,1.85-2,3.56-2.84,5.38a13.84,13.84,0,0,0-1,2.8,12.68,12.68,0,0,0-.22,3,22,22,0,0,0,1,5.86c.59,1.89,1.54,3.68,2.24,5.64,1.41,3.93,1,9.27.1,13.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "413.851px 186.12px"
    },
    id: "elkhkf74dtsw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.86,165.28a8.36,8.36,0,0,0-2.14,4.55,2.25,2.25,0,0,1,0-.76,5.64,5.64,0,0,1,.52-1.76,6.22,6.22,0,0,1,1-1.53A2,2,0,0,1,418.86,165.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "417.774px 167.555px"
    },
    id: "elw5c5djsddxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,157.85h.13a2.12,2.12,0,0,1,.38,0,3.19,3.19,0,0,1,1.26.57,4.2,4.2,0,0,1,1.27,1.62,5.9,5.9,0,0,1,.45,2.46,15.31,15.31,0,0,1-.3,2.48c-.15.75-.29,1.42-.38,2a12.08,12.08,0,0,0-.16,1.35,3,3,0,0,1-.05.5,2.22,2.22,0,0,1,0-.5,9.92,9.92,0,0,1,.1-1.37c.07-.58.2-1.25.34-2a15.27,15.27,0,0,0,.28-2.45,5.89,5.89,0,0,0-.42-2.39,4.14,4.14,0,0,0-1.19-1.58,3.27,3.27,0,0,0-1.19-.61A5,5,0,0,1,414,157.85Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "415.747px 163.336px"
    },
    id: "elyuadj468v1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.24,164.53s0-.1.12-.23a1.2,1.2,0,0,1,.61-.37,2.37,2.37,0,0,1,1.06,0,4.11,4.11,0,0,1,1.21.46,4.19,4.19,0,0,1,1.62,1.64,3.23,3.23,0,0,1,.27.65.62.62,0,0,1,.05.26s-.13-.35-.44-.84a4.48,4.48,0,0,0-1.6-1.54,4,4,0,0,0-1.14-.45,2.46,2.46,0,0,0-1-.06A1.4,1.4,0,0,0,411.24,164.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "413.71px 165.405px"
    },
    id: "elfjwrxo3j63w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.32,176.44a5.63,5.63,0,0,0-.57-.35,2,2,0,0,0-.69-.16,2.2,2.2,0,0,0-.85.16,4.83,4.83,0,0,0-1.4.81c-.3.28-.41.52-.44.51a1.18,1.18,0,0,1,.34-.61,4,4,0,0,1,1.43-.89,1.93,1.93,0,0,1,.93-.16,1.74,1.74,0,0,1,.74.22C417.2,176.18,417.34,176.43,417.32,176.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "415.346px 176.577px"
    },
    id: "eleofrtkn2k7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.07,181.75s-.61.26-1.52.8a3.87,3.87,0,0,0-1.31,1.23,6.14,6.14,0,0,0-.43,1,2.19,2.19,0,0,1-.67,1,1.14,1.14,0,0,1-.61.23,2,2,0,0,1-.61-.08,2.28,2.28,0,0,0-1-.14,1.91,1.91,0,0,0-1.33,1.08,3.37,3.37,0,0,0-.31,1.19,2.21,2.21,0,0,1,0,.46,1.43,1.43,0,0,1,0-.46,3,3,0,0,1,.25-1.25,2,2,0,0,1,1.43-1.2,2.51,2.51,0,0,1,1.12.13,1.09,1.09,0,0,0,1-.12c.62-.48.66-1.34,1.06-1.94a3.8,3.8,0,0,1,1.4-1.26,8.24,8.24,0,0,1,1.15-.54C418.91,181.78,419.06,181.73,419.07,181.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "415.166px 185.133px"
    },
    id: "elvcfz1oz3xgm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.16,179.82a4.28,4.28,0,0,1-.59.77,14.72,14.72,0,0,0-1.42,1.82,6.67,6.67,0,0,0-.66,2.19,2.74,2.74,0,0,1-.27.93s.06-.37.13-1a5.76,5.76,0,0,1,.63-2.26,10.88,10.88,0,0,1,1.49-1.81A4.57,4.57,0,0,1,418.16,179.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "416.69px 182.675px"
    },
    id: "el12wvthswzyyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.28,184.42s-.09-.13-.22-.32a1.53,1.53,0,0,0-1.52-.64,3.69,3.69,0,0,1-.38.07s.11-.13.35-.21a1.44,1.44,0,0,1,1.67.71C418.3,184.25,418.3,184.41,418.28,184.42Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "417.225px 183.842px"
    },
    id: "elmvd8bmgqclc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.43,188.87s-.06.29-.45.48a3.94,3.94,0,0,1-.67.25,1.42,1.42,0,0,0-.7.38c-.78.91-1.21,1.83-1.26,1.79s0-.25.24-.61a6.22,6.22,0,0,1,.88-1.31,1.55,1.55,0,0,1,.79-.43,6.26,6.26,0,0,0,.66-.19A1.64,1.64,0,0,0,415.43,188.87Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "413.881px 190.321px"
    },
    id: "elnzrqioshakf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.24,190.62s-.27-.06-.72-.05-1.09.06-1.78.09a17.79,17.79,0,0,1-2.53,0,14.79,14.79,0,0,1,2.52-.2c.7,0,1.32-.06,1.79,0A1.27,1.27,0,0,1,418.24,190.62Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "415.725px 190.569px"
    },
    id: "elg0vfq6eto8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.17,192.18s-.15.07-.4.09a1.85,1.85,0,0,1-.46,0,1.07,1.07,0,0,1-.52-.26,1,1,0,0,1-.27-.51,1.94,1.94,0,0,0-.12-.4c-.1-.22-.25-.27-.24-.3s.2,0,.36.23.17.61.41.84a1.35,1.35,0,0,0,.84.28C418,192.15,418.17,192.15,418.17,192.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "417.165px 191.537px"
    },
    id: "elkeddwrqnqgk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.66,221.79a.51.51,0,0,1-.07-.1,3.09,3.09,0,0,1-.15-.31,4.42,4.42,0,0,1-.22-1.26,9.78,9.78,0,0,0-.17-1.85,4.5,4.5,0,0,0-1.12-1.93,7.79,7.79,0,0,0-1.81-1.37c-.61-.36-1.19-.63-1.67-.87l-1.13-.58a1.7,1.7,0,0,1-.39-.26,2.51,2.51,0,0,1,.43.19l1.15.52c.49.23,1.08.49,1.7.84a7.21,7.21,0,0,1,1.86,1.4,4.37,4.37,0,0,1,1.15,2,8.67,8.67,0,0,1,.14,1.88,5.14,5.14,0,0,0,.15,1.24A4,4,0,0,1,457.66,221.79Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "454.295px 217.525px"
    },
    id: "elg1zc608nzsv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.86,220.57s-.53-.52-1.29-1-1.45-.75-1.43-.81a3.37,3.37,0,0,1,1.54.64A3.42,3.42,0,0,1,459.86,220.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "458.5px 219.665px"
    },
    id: "elx1wuqh4l4t8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.88,247.22a3.36,3.36,0,0,0-.35-1.13c-.16-.34-.4-.71-.61-1.17a2.28,2.28,0,0,1-.19-1.62c.16-.57.42-1.05.52-1.52a4.48,4.48,0,0,0,.09-1.28,7.44,7.44,0,0,0-.23-1.17s.08.09.15.29a3.61,3.61,0,0,1,.22.87,4.11,4.11,0,0,1-.06,1.33c-.09.5-.35,1-.5,1.53a2.19,2.19,0,0,0,.16,1.5c.2.44.43.83.58,1.18a2.63,2.63,0,0,1,.24.86A.68.68,0,0,1,453.88,247.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "453.286px 243.275px"
    },
    id: "el1wjdaszfwk2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.33,259a1,1,0,0,1-.2-.29,3.07,3.07,0,0,1-.32-.89,6.38,6.38,0,0,1-.13-1.39c0-.53,0-1.1,0-1.7a11.66,11.66,0,0,0-.47-3,9.59,9.59,0,0,1-.32-1.24s.07.11.14.31.19.51.31.89a10,10,0,0,1,.53,3.05c0,.61,0,1.18,0,1.7a7,7,0,0,0,.08,1.36A5.67,5.67,0,0,0,457.33,259Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "456.61px 254.745px"
    },
    id: "elrnyffzzfl98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.18,259.26a2.24,2.24,0,0,1-.06-.51c0-.34,0-.83,0-1.43s0-1.31-.05-2.09a6.63,6.63,0,0,0-.63-2.45c-.41-.79-1.14-1.34-1.56-2a5.82,5.82,0,0,1-.74-2,5.74,5.74,0,0,1-.07-1.43,2.53,2.53,0,0,1,.05-.38.42.42,0,0,1,0-.13,9.6,9.6,0,0,0,.13,1.91,5.76,5.76,0,0,0,.76,1.93c.4.66,1.13,1.2,1.57,2a6.39,6.39,0,0,1,.64,2.52c.06.8,0,1.52,0,2.12s0,1.08,0,1.41S458.19,259.26,458.18,259.26Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "456.65px 253.05px"
    },
    id: "el10fptkgbtx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.31,258.75a6.54,6.54,0,0,0-5.1-.23,8.27,8.27,0,0,0-2.29,1.39c-.71.59-1.39,1.24-2.13,1.85a13.8,13.8,0,0,1-1.16.85,7.26,7.26,0,0,1-1.31.65,13.92,13.92,0,0,1-2.8.57,6.17,6.17,0,0,0-2.63.84,3.24,3.24,0,0,0-1,.95,2.26,2.26,0,0,0-.41,1.31,2.23,2.23,0,0,1,.35-1.35,3.44,3.44,0,0,1,1-1,4.62,4.62,0,0,1,1.27-.65,11.31,11.31,0,0,1,1.39-.35,12.93,12.93,0,0,0,2.69-.68,7,7,0,0,0,1.19-.67c.37-.27.72-.56,1.07-.87.68-.63,1.33-1.31,2-1.95a9,9,0,0,1,2.43-1.65,7.51,7.51,0,0,1,5.9,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.123px 262.043px"
    },
    id: "el17e8zp3oi33",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.93,276.47c0-.15,0-.31.05-.46.1-1.11.12-2.18.13-3.26a100.82,100.82,0,0,0-.89-12.76,50.69,50.69,0,0,0-1.21-6.35l-.19-.75c-.07-.23-.11-.48-.17-.72-.1-.49-.18-1-.26-1.48-.14-1-.23-2-.28-3a55.5,55.5,0,0,1,.08-6.18c.13-2.05.35-4.14.66-6.15l-2.05-2.24c-.3,2.16-1.07,6.1-1.18,8.25a55.7,55.7,0,0,0,0,6.46c.07,1.08.17,2.17.34,3.26.09.54.19,1.08.31,1.63.07.27.12.54.2.81l.21.78a49.85,49.85,0,0,1,1.23,6,96.16,96.16,0,0,1,1,12.44c0,1,0,2.07-.07,3.07a8.47,8.47,0,0,1-.19,1.33,2.48,2.48,0,0,1-.25.47c-.12.2-.26.4-.4.61-1.19,1.67-2.52,3.38-3.71,5.15a59.2,59.2,0,0,0-6.1,11.3A51.74,51.74,0,0,0,405,307.1a53,53,0,0,0-.45,6.4l-.12,6.32-.2,12.65q-.35,25.29-.47,50.59v12.65l0,6.32c0,2.11,0,4.22.09,6.33,0,1.06,0,2.11.09,3.16s.08,2.12.16,3.17c.14,2.1.28,4.2.38,6.31s.16,4.21,0,6.3a21.84,21.84,0,0,1-.41,3.12,16.44,16.44,0,0,1-1,3c-.69.86-1.44,1.69-2.2,2.5s-1.57,1.59-2.41,2.33a24.06,24.06,0,0,1-2.64,2.07,12.14,12.14,0,0,1-3,1.52,12.24,12.24,0,0,0,3-1.49,25,25,0,0,0,2.67-2c.85-.74,1.65-1.51,2.44-2.31s1.53-1.63,2.25-2.5h0a16.64,16.64,0,0,0,1-3,22.19,22.19,0,0,0,.45-3.14,61,61,0,0,0,0-6.34c-.08-2.11-.19-4.21-.31-6.32-.06-1.05-.08-2.1-.12-3.15s0-2.1,0-3.16c0-2.1,0-4.21,0-6.32l0-6.32.17-12.64q.4-25.29,1.09-50.57l.35-12.64.2-6.32a51.15,51.15,0,0,1,.51-6.2,49.58,49.58,0,0,1,3.29-12,56.56,56.56,0,0,1,6-10.86c.59-.86,1.21-1.7,1.84-2.53s1.27-1.67,1.91-2.56c.16-.22.32-.45.48-.7l.08-.13c4.76,5.65,8.07,14.68,8.82,20.66L431,299C430.15,292.28,426.42,282.38,420.93,276.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.91px 337.48px"
    },
    id: "elzwbptew7fnl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.79,425.19a3,3,0,0,0-.41,1c-.09.38-.17.76-.24,1.15-.13.78-.24,1.56-.33,2.35s-.17,1.57-.23,2.36l0,.59,0,.3a1.65,1.65,0,0,1,0,.31,4.82,4.82,0,0,1-.44,1.13,27.78,27.78,0,0,1-2.66,4c-1,1.26-2,2.48-3,3.68s-2.11,2.38-3.21,3.52c-.56.57-1.12,1.13-1.7,1.67a7.52,7.52,0,0,1-.93.76,1.81,1.81,0,0,1-1.18.2,4.52,4.52,0,0,1-2.09-1.14,11.69,11.69,0,0,1-1.6-1.77,8.58,8.58,0,0,1-1.21-2,2.45,2.45,0,0,1,.18-2.29,2.46,2.46,0,0,0-.16,2.28,9.12,9.12,0,0,0,1.22,2,12.08,12.08,0,0,0,1.61,1.74,4.43,4.43,0,0,0,2.06,1.11,1.67,1.67,0,0,0,1.12-.19,7.33,7.33,0,0,0,.91-.76c.58-.54,1.14-1.1,1.69-1.68q1.63-1.72,3.19-3.53c1-1.21,2-2.44,3-3.7a27.82,27.82,0,0,0,2.61-3.95,4.47,4.47,0,0,0,.42-1.08,3.52,3.52,0,0,0,0-.58l0-.59c.05-.8.12-1.59.21-2.38s.18-1.58.31-2.36c.07-.39.14-.79.24-1.18.05-.19.1-.39.17-.58a1.75,1.75,0,0,1,.29-.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.074px 436.618px"
    },
    id: "ela1ewmkxhiqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.47,379.6a11.78,11.78,0,0,1,1.31,1.34,14.29,14.29,0,0,1,1.1,1.49,11.89,11.89,0,0,1,1.49,3.38c.08.3.13.61.2.91s.07.62.11.92c0,.62,0,1.26,0,1.81,0,1.17.05,2.36.08,3.54.15,4.72.33,9.45.51,14.18l1.12,28.37-1.69-28.34c-.27-4.73-.55-9.45-.79-14.18-.06-1.18-.12-2.36-.16-3.56,0-.62,0-1.17-.06-1.73,0-.28-.07-.56-.12-.84s-.12-.55-.19-.82A10.56,10.56,0,0,0,406,383a11.28,11.28,0,0,0-1-1.35,9.37,9.37,0,0,0-1.19-1.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "407.1px 407.57px"
    },
    id: "elrt6hjv9fgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.9,357.22a.65.65,0,0,1,.1.26v.19l0,.13,0,.21-.09.38-.19.73-.39,1.44-.79,2.87q-.78,2.86-1.5,5.75a100.56,100.56,0,0,0-2.26,11.62c-.11,1-.2,2-.24,2.94s0,1.95,0,2.94.11,2,.16,3,.16,2,.25,3c.4,3.93,1,7.86,1.66,11.76.34,1.95.72,3.9,1.12,5.84l.59,2.91c.2,1,.41,1.95.55,2.95a44.13,44.13,0,0,1,.21,6,45.36,45.36,0,0,1-.53,5.94,20.6,20.6,0,0,1-.67,2.92,10,10,0,0,1-.56,1.4,5.92,5.92,0,0,1-.85,1.24,54.46,54.46,0,0,1-4.23,4.23c-1.46,1.35-2.94,2.67-4.43,4l-2.24,2-1.11,1c-.37.34-.75.66-1.08,1a13,13,0,0,1,1.06-1l1.11-1,2.21-2c1.47-1.34,2.94-2.68,4.39-4.05a55.44,55.44,0,0,0,4.15-4.25,6.8,6.8,0,0,0,1.35-2.58,21.54,21.54,0,0,0,.63-2.89,44.83,44.83,0,0,0,.45-5.91,41.63,41.63,0,0,0-.27-5.91c-.15-1-.36-1.94-.57-2.9l-.63-2.91c-.42-1.95-.83-3.89-1.19-5.84-.75-3.91-1.37-7.84-1.81-11.79-.1-1-.21-2-.29-3s-.17-2-.2-3-.12-2-.08-3,.1-2,.2-3A101.32,101.32,0,0,1,401,369q.68-2.91,1.43-5.79l.75-2.88.38-1.44.17-.71.08-.35,0-.16v-.05h0v0a.41.41,0,0,0,.08.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "396.69px 401.545px"
    },
    id: "ell0iln251hs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.33,355a14.69,14.69,0,0,0-1,1.32A7.88,7.88,0,0,0,410,360a1.6,1.6,0,0,0,.18,1.05,2.64,2.64,0,0,0,.37.38,1.54,1.54,0,0,1,.33.44,2.81,2.81,0,0,1,.24,1c0,.31,0,.59,0,.85,0,.48,0,.9,0,1.23a1.59,1.59,0,0,1,0,.45,2.87,2.87,0,0,1-.06-.45c0-.33-.05-.74-.08-1.23a4.48,4.48,0,0,0-.29-1.74,1.27,1.27,0,0,0-.3-.4,2.52,2.52,0,0,1-.4-.4,1.73,1.73,0,0,1-.22-1.18,7.63,7.63,0,0,1,1.37-3.81,6.42,6.42,0,0,1,.79-.95A1.57,1.57,0,0,1,412.33,355Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.038px 360.2px"
    },
    id: "elupzryygdqmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.94,365a12.63,12.63,0,0,1-.13-2.15,10.48,10.48,0,0,1,.06-2.16,12.63,12.63,0,0,1,.13,2.15A10.54,10.54,0,0,1,409.94,365Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "409.905px 362.845px"
    },
    id: "el730jgkw0twa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.62,372.28a2.46,2.46,0,0,1-.07-.49,10.75,10.75,0,0,1,0-1.36c0-.57.12-1.25.18-2a9,9,0,0,0,0-2.42,11,11,0,0,0-.76-2.31,16.32,16.32,0,0,1-.7-1.89,5,5,0,0,1-.2-1.35c0-.16,0-.28,0-.37s0-.13,0-.12a6.51,6.51,0,0,0,.27,1.8,15.85,15.85,0,0,0,.74,1.86,10.71,10.71,0,0,1,.78,2.34,9,9,0,0,1,0,2.48c-.09.74-.17,1.41-.23,2a12.94,12.94,0,0,0-.08,1.34A2.44,2.44,0,0,1,413.62,372.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "413.008px 366.124px"
    },
    id: "el6m68asp0544",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.22,299.09a15.54,15.54,0,0,1-2.64,1.39,23.6,23.6,0,0,1-2.78,1c-.48.13-1,.24-1.45.33-.25,0-.47.09-.75.12a1.67,1.67,0,0,1-.91-.16,2,2,0,0,1-.95-1.41,3.79,3.79,0,0,1,.14-1.55,11.14,11.14,0,0,0,.33-1.36,2,2,0,0,0-.2-1.26,1.91,1.91,0,0,0-1-.81,3.61,3.61,0,0,0-1.35-.27,5.12,5.12,0,0,0-2.7.7,2.58,2.58,0,0,0-1.25,2.39,2.64,2.64,0,0,1,1.17-2.51,4.34,4.34,0,0,1,1.32-.63,6,6,0,0,1,1.46-.23,4,4,0,0,1,1.48.21,2.32,2.32,0,0,1,1.23.93,2.38,2.38,0,0,1,.33,1.53,10.22,10.22,0,0,1-.27,1.44,3.41,3.41,0,0,0-.06,1.3,1.3,1.3,0,0,0,.64.88.82.82,0,0,0,.5.06l.67-.14q.69-.16,1.35-.39a20.51,20.51,0,0,0,2.62-1.06,14.87,14.87,0,0,0,2.39-1.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "400.456px 298.383px"
    },
    id: "els8vtrwmauhd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.1,291.52a6.28,6.28,0,0,1,5,1.56,5.42,5.42,0,0,1,1.69,4.78,4.87,4.87,0,0,0-.1,1.17,1.17,1.17,0,0,0,.49.88c.6.43,1.51.47,2.25,1a2.09,2.09,0,0,1,.76,1,6.24,6.24,0,0,0,.5,1.11,1.65,1.65,0,0,0,2.15.52,1.73,1.73,0,0,1-2.27-.44A7.18,7.18,0,0,1,421,302a1.9,1.9,0,0,0-.73-.89c-.66-.41-1.54-.38-2.33-.85a1.59,1.59,0,0,1-.75-1.17,6.08,6.08,0,0,1,0-1.29,4.7,4.7,0,0,0-1.69-4.08,5.29,5.29,0,0,0-4.25-1.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "417.47px 297.628px"
    },
    id: "elk0s42gswehm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.92,296.59a3.68,3.68,0,0,1-1.47-.18,3.53,3.53,0,0,1-1.27-.75,5.83,5.83,0,0,1-1.48-2.3,7.72,7.72,0,0,1-.51-2.61,9.8,9.8,0,0,1,.32-2.6,17.09,17.09,0,0,1,.83-2.44,12.27,12.27,0,0,1,1.23-2.28c1-1.43,2.32-2.51,3.35-3.79a8.21,8.21,0,0,0,1.28-2.07c.32-.76.59-1.56.89-2.34a29.81,29.81,0,0,1,2.12-4.59,14,14,0,0,1,3.24-3.87,10.84,10.84,0,0,1,2.13-1.36,9,9,0,0,1,2.41-.74,8.84,8.84,0,0,0-2.37.8,11,11,0,0,0-2.08,1.4,13.92,13.92,0,0,0-3.08,3.91,29.11,29.11,0,0,0-2,4.59c-.28.79-.52,1.59-.84,2.38a9,9,0,0,1-1.28,2.24c-1.05,1.36-2.33,2.48-3.22,3.83a12.33,12.33,0,0,0-1.09,2.18,15.42,15.42,0,0,0-.73,2.34,7.48,7.48,0,0,0,.29,4.66,4.87,4.87,0,0,0,1.26,1.87,2.49,2.49,0,0,0,1.93.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "413.09px 280.636px"
    },
    id: "el9bvmyttfv7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,304.67s-.25-.07-.47-.39a2.47,2.47,0,0,1-.33-1.42c0-.56.1-1.06.08-1.41s-.06-.58,0-.59a1.07,1.07,0,0,1,.17.58,10,10,0,0,1,0,1.43,2.72,2.72,0,0,0,.25,1.34C420.79,304.52,421,304.64,421,304.67Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "420.597px 302.765px"
    },
    id: "elzb8xv2b5aji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.82,302.65a4.69,4.69,0,0,0,.14-1.11,5,5,0,0,0-.32-1.08s.13.07.25.25a1.8,1.8,0,0,1,.26.81,1.73,1.73,0,0,1-.13.84C418.94,302.56,418.84,302.66,418.82,302.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "418.899px 301.555px"
    },
    id: "el8eujzg3m829",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.43,312.92s0-.54,0-1.4a5.41,5.41,0,0,0-.27-1.48,3.58,3.58,0,0,0-1.06-1.47c-.49-.43-1-.82-1.43-1.21s-.82-.73-1.13-1-.56-.55-.73-.73a1.48,1.48,0,0,1-.24-.29,10.76,10.76,0,0,1,1.06.92l1.16,1c.44.38.94.76,1.45,1.2a3.77,3.77,0,0,1,1.09,1.56,5,5,0,0,1,.24,1.53,8.69,8.69,0,0,1-.06,1C416.47,312.79,416.45,312.92,416.43,312.92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "414.07px 309.13px"
    },
    id: "eleb9eatlsu9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.62,311.35c-.06,0,.11-.65,0-1.43a13.54,13.54,0,0,0-.32-1.4,2.94,2.94,0,0,1,.29,2.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "415.563px 309.935px"
    },
    id: "el18edd85g4o1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.68,320.79s0-.31,0-.81a4.19,4.19,0,0,0-.54-1.84c-.38-.66-.82-1.22-1-1.7a1.53,1.53,0,0,1-.18-.81s.08.3.31.75.66,1,1.06,1.66a3.82,3.82,0,0,1,.51,1.93A1.84,1.84,0,0,1,398.68,320.79Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "397.899px 318.21px"
    },
    id: "elbjpaak43chu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.84,319.89s-.33-.32-.72-.72a4.92,4.92,0,0,1-.69-.73c0-.05.44.18.84.6S399.89,319.86,399.84,319.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "399.139px 319.162px"
    },
    id: "elqm7f7upp7or",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,329.12a4,4,0,0,1-.15-.9c0-.27-.1-.6-.17-1,0-.19-.07-.37-.1-.59a2.88,2.88,0,0,1,0-.65,5.47,5.47,0,0,1,.13-.61,2.32,2.32,0,0,1,.19-.58,4,4,0,0,1,.58-.82,5.12,5.12,0,0,0,.54-.72,1.63,1.63,0,0,1-.43.81,4.37,4.37,0,0,0-.53.81,2.64,2.64,0,0,0-.16.54c0,.2-.09.4-.13.61a2.42,2.42,0,0,0,0,.6c0,.18.06.38.08.57a8.05,8.05,0,0,1,.13,1A4,4,0,0,1,397,329.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "397.291px 326.185px"
    },
    id: "elo9x8hoz65jl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.57,305.07A6.44,6.44,0,0,0,403,305a4.91,4.91,0,0,0-2.32,1.11,8.68,8.68,0,0,0-2.56,4.68c-.42,1.8-.54,3.75-1.12,5.62a5.91,5.91,0,0,0-.33,2.67c.13.89.5,1.78.68,2.76a4.76,4.76,0,0,1,.06,1.51,10.89,10.89,0,0,1-.34,1.42,8.52,8.52,0,0,0-.3,1.36,5.24,5.24,0,0,0,.08,1.36c.17.91.48,1.82.72,2.74a20.68,20.68,0,0,1,.61,2.81,10,10,0,0,1,0,2.89c-.14,1-.51,1.85-.66,2.78a4.11,4.11,0,0,0,0,1.4,5.3,5.3,0,0,1,.13,1.43,5.56,5.56,0,0,1-1.27,2.54,5.53,5.53,0,0,0,1.2-2.54,4.82,4.82,0,0,0-.17-1.41,4.63,4.63,0,0,1,0-1.44c.14-1,.48-1.86.59-2.79a9.8,9.8,0,0,0-.08-2.81,21.73,21.73,0,0,0-.66-2.76c-.27-.92-.6-1.8-.81-2.76a5.23,5.23,0,0,1-.11-1.48,8.45,8.45,0,0,1,.27-1.45,9.72,9.72,0,0,0,.29-1.36,4.26,4.26,0,0,0-.08-1.33c-.19-.9-.59-1.78-.76-2.77a4.85,4.85,0,0,1,0-1.52,12.63,12.63,0,0,1,.31-1.44c.52-1.8.58-3.69,1-5.61a12.38,12.38,0,0,1,.94-2.81,7.77,7.77,0,0,1,1.8-2.44,6,6,0,0,1,2.76-1.4,7.26,7.26,0,0,1,3.08,0Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "400.975px 323.937px"
    },
    id: "elrtfgdsy1my",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.88,341.07a3.2,3.2,0,0,1-.06-.47c0-.35-.05-.79-.09-1.31-.07-1.1-.16-2.62-.24-4.3a6.68,6.68,0,0,1,.13-2.38,12.73,12.73,0,0,1,.84-1.76,3.62,3.62,0,0,0,.4-1.22c0-.3,0-.47,0-.47s0,0,0,.12a1.17,1.17,0,0,1,0,.36,3.34,3.34,0,0,1-.34,1.27,13.91,13.91,0,0,0-.79,1.75,6.76,6.76,0,0,0-.12,2.32c.09,1.68.15,3.21.19,4.31l0,1.3A1.81,1.81,0,0,1,395.88,341.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "396.156px 335.115px"
    },
    id: "elzpalgtmrbuf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.4,320.7a1.32,1.32,0,0,1,.08.42,4.71,4.71,0,0,1-.07,1.18,7.78,7.78,0,0,1-.5,1.68c-.26.61-.59,1.25-.92,1.93a11.32,11.32,0,0,0-.78,1.95,8.73,8.73,0,0,0-.3,1.7c-.06,1,0,1.58,0,1.59a1,1,0,0,1-.09-.42,7.48,7.48,0,0,1-.06-1.18,8,8,0,0,1,.26-1.73,11.13,11.13,0,0,1,.78-2c.34-.68.67-1.32.93-1.91a8.59,8.59,0,0,0,.54-1.63A7.66,7.66,0,0,0,396.4,320.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "395.124px 325.925px"
    },
    id: "elxf0yny3q7qj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,342.14a1.19,1.19,0,0,1-.19-.29c-.12-.2-.27-.49-.45-.85a6.47,6.47,0,0,1-.78-3.08c0-.63.18-1.2.16-1.72a4.54,4.54,0,0,0-.24-1.37,7.66,7.66,0,0,0-.58-1.16,1.17,1.17,0,0,1,.24.27,4.09,4.09,0,0,1,.47.85,4,4,0,0,1,.29,1.41,15.37,15.37,0,0,1-.15,1.73,7.21,7.21,0,0,0,.71,3A11.15,11.15,0,0,1,400,342.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "398.96px 337.905px"
    },
    id: "el5mxuhjqm6sq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.9,337.46a1.2,1.2,0,0,1,0-.37c0-.24,0-.59-.06-1s0-.95-.06-1.5a9.44,9.44,0,0,0-.15-1.8,5.09,5.09,0,0,0-.82-1.59,13.35,13.35,0,0,0-.92-1.17c-.56-.65-.95-1-.93-1s.12.06.3.22a8.5,8.5,0,0,1,.73.7,11.6,11.6,0,0,1,1,1.17,4.75,4.75,0,0,1,.87,1.64,8.7,8.7,0,0,1,.14,1.85c0,.55,0,1.05,0,1.49s0,.78,0,1A1.67,1.67,0,0,1,399.9,337.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "398.482px 333.245px"
    },
    id: "elxhoeeo5cf3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,268.84s.52-.51,1-1.22.77-1.39.82-1.37a3,3,0,0,1-.66,1.48A3.27,3.27,0,0,1,403,268.84Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.91px 267.545px"
    },
    id: "elfs2lwr6gggk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.81,271.54a.62.62,0,0,1-.2-.19,1.42,1.42,0,0,1,.14-1.74,6.72,6.72,0,0,1,1.09-.74,4.12,4.12,0,0,0,1.41-1.8c.22-.55.26-.93.29-.92a.58.58,0,0,1,0,.26,3.36,3.36,0,0,1-.16.71A4,4,0,0,1,404,269a8.62,8.62,0,0,0-1.07.71,1.26,1.26,0,0,0-.36.9A1.74,1.74,0,0,0,402.81,271.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.966px 268.845px"
    },
    id: "eloo74xyf98uk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.75,271.11c0,.05-.43-.19-.65-.7a1.11,1.11,0,0,1-.07-.94c.06,0,.05.41.25.86S403.79,271.07,403.75,271.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.355px 270.293px"
    },
    id: "elajlrsnpuu0u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.22,266.17s0-.09.1-.19a.88.88,0,0,1,.51-.28,1.47,1.47,0,0,1,.86.1c.3.11.6.29.92.42a3.28,3.28,0,0,0,1.77.07,1.88,1.88,0,0,1,.77,0s-.29.05-.75.15c-.23,0-.51.1-.83.13a2.29,2.29,0,0,1-1-.16c-.34-.14-.63-.32-.91-.43a1.51,1.51,0,0,0-.77-.14A1.07,1.07,0,0,0,400.22,266.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.685px 266.125px"
    },
    id: "el7tng9fofnj5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,267.38c0-.05.3-.2.73-.13s.69.31.66.35-.31-.1-.69-.16A6.76,6.76,0,0,1,401,267.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "401.696px 267.419px"
    },
    id: "el7i1ezaobvnw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,263.24s.2.12.37.44a1.92,1.92,0,0,1,.19.6,2.86,2.86,0,0,1,0,.77.82.82,0,0,0,.15.63,2.44,2.44,0,0,0,.45.37c.29.2.43.38.41.4s-.18-.12-.49-.28a2.13,2.13,0,0,1-.5-.38.7.7,0,0,1-.19-.35,1.14,1.14,0,0,1,0-.41,2.72,2.72,0,0,0,.05-.73,2.2,2.2,0,0,0-.13-.56C403.15,263.43,403,263.27,403,263.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.786px 264.846px"
    },
    id: "el7nj0dz8ujcn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.51,263.81c0-.05.36-.07.68.22s.35.64.3.64-.16-.27-.43-.5S402.5,263.87,402.51,263.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.01px 264.225px"
    },
    id: "elu7pxioas2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.18,272.74a6.16,6.16,0,0,1-2.16,1.81,23.07,23.07,0,0,0-2.33,1.43,16,16,0,0,0-3.82,3.88,9.86,9.86,0,0,0-1.3,2.38,4.51,4.51,0,0,0,.1,2.67,7.4,7.4,0,0,1,.41,2.72,7.26,7.26,0,0,1-1,2.54,7.17,7.17,0,0,0,.95-2.55,7.06,7.06,0,0,0-.45-2.68,4.74,4.74,0,0,1-.15-2.74,10.21,10.21,0,0,1,1.28-2.45,16.27,16.27,0,0,1,3.81-4,23.09,23.09,0,0,1,2.34-1.49,6.11,6.11,0,0,0,2-1.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.13px 281.355px"
    },
    id: "eldumejw6kbkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.69,278.24A10.53,10.53,0,0,1,414,279.6a8,8,0,0,1-.94.55l-1,.46a5,5,0,0,0-1.66,1.28,4.08,4.08,0,0,0-.71,2,4.23,4.23,0,0,1,.62-2,5.05,5.05,0,0,1,1.65-1.4c.31-.19.64-.35.95-.51s.6-.37.89-.57a9.58,9.58,0,0,0,1.6-1.36Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "412.69px 280.97px"
    },
    id: "elvinmtq1teya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,279.4a12.94,12.94,0,0,0-.06,4.56,12.27,12.27,0,0,0,.57,2.22c.25.72.59,1.42.91,2.12a13.33,13.33,0,0,1,1.33,4.44,12.34,12.34,0,0,1-.38,4.61,12.09,12.09,0,0,0,.28-4.6,13.08,13.08,0,0,0-1.4-4.37c-.34-.7-.69-1.39-1-2.12a12.76,12.76,0,0,1-.63-2.25,13.14,13.14,0,0,1,0-4.68Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "417.115px 288.34px"
    },
    id: "elwg42xyjaets",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.07,273c.72,2.92,2.23,5.63,3.24,8.55a17.17,17.17,0,0,1,.63,2.23,6.52,6.52,0,0,1,.06,2.33,10.85,10.85,0,0,1-2.05,4.1,10.78,10.78,0,0,0,1.86-4.13,9.24,9.24,0,0,0-.85-4.4c-1.11-2.83-2.74-5.47-3.62-8.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "431.709px 281.605px"
    },
    id: "elth9719tam6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.32,279.88s.16.1.44.2a4.17,4.17,0,0,0,1.1.31,2.68,2.68,0,0,0,1.13-.07c.28-.09.44-.19.45-.16s-.12.16-.41.29a2.28,2.28,0,0,1-1.19.14C404.89,280.45,404.25,280,404.32,279.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "405.878px 280.248px"
    },
    id: "elupzl1g4e9ss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.79,277.94a4,4,0,0,0,1.16.85,3.81,3.81,0,0,0,1.44.16.88.88,0,0,1-.43.15,2.28,2.28,0,0,1-1.08-.12,2.16,2.16,0,0,1-.88-.64C405.83,278.12,405.77,278,405.79,277.94Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "407.088px 278.53px"
    },
    id: "el2xup5hgs2m6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.87,276.78s.13-.21.48-.25.79,0,1.28-.09a4.45,4.45,0,0,0,1.23-.24c.3-.12.46-.24.48-.22s-.12.18-.42.34a3.23,3.23,0,0,1-1.27.32c-.51,0-1,0-1.28,0A1.49,1.49,0,0,0,407.87,276.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "409.606px 276.379px"
    },
    id: "el2j76hblldqz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.4,286.84s-.17-.24-.14-.69a4.23,4.23,0,0,1,.16-.75,2.84,2.84,0,0,1,.39-.86,4.07,4.07,0,0,1,.7-.64,3.24,3.24,0,0,0,.53-.5,2.07,2.07,0,0,0,.27-.61.8.8,0,0,1-.16.69,2.5,2.5,0,0,1-.53.56,4.71,4.71,0,0,0-.65.62,2.93,2.93,0,0,0-.38.8,4,4,0,0,0-.19.71A3,3,0,0,0,404.4,286.84Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "405.294px 284.815px"
    },
    id: "elt3tckslqpmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.59,293.81a2.63,2.63,0,0,1-1.28-.71,2.42,2.42,0,0,1-.84-1.19s.39.53,1,1S420.62,293.75,420.59,293.81Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "419.531px 292.86px"
    },
    id: "el8leq1qpa8va",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.73,262a8.74,8.74,0,0,0,1.41,1,4.21,4.21,0,0,0,1.14.38,3,3,0,0,0,.49,0s-.16.17-.5.16a3.13,3.13,0,0,1-1.22-.35A2.8,2.8,0,0,1,402.73,262Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.25px 262.77px"
    },
    id: "el7chm61bs7m4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.46,262c.06,0,.11.39.36.8s.58.65.54.69-.43-.13-.71-.59A1.08,1.08,0,0,1,404.46,262Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.897px 262.748px"
    },
    id: "el8omw8acduw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.17,262.15a6.89,6.89,0,0,0-.61-2.15c-.31-.68-.65-1.31-1-2a9.08,9.08,0,0,0-1.27-1.81,4.07,4.07,0,0,0-1.88-1.19,3.15,3.15,0,0,0-1.06-.13,1.87,1.87,0,0,1,.35-1.56,4.71,4.71,0,0,1,1.38-1.2,8.51,8.51,0,0,0,1.53-1.15,2.44,2.44,0,0,0,.76-1.69,2.38,2.38,0,0,1-.83,1.63A8.52,8.52,0,0,1,413,252a4.83,4.83,0,0,0-1.51,1.2A2.2,2.2,0,0,0,411,255a4.65,4.65,0,0,0-.76.15A5.69,5.69,0,0,0,407,258a5.64,5.64,0,0,1,3.24-2.71,3.58,3.58,0,0,1,2.1,0,3.89,3.89,0,0,1,1.73,1.18,8.59,8.59,0,0,1,1.16,1.79c.33.64.65,1.3.92,2a6.12,6.12,0,0,1,.51,2,15.4,15.4,0,0,1-.05,2.14,153.23,153.23,0,0,1-2.12,17.23l1.13.18a158.2,158.2,0,0,0,1.56-17.39A18.16,18.16,0,0,0,417.17,262.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "412.105px 265.54px"
    },
    id: "ell9zrec3pgy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.38,252.52a1.13,1.13,0,0,1,.59-.09,2.35,2.35,0,0,1,2.15,1.68c.1.36.08.59.05.59s-.05-.22-.18-.54a2.6,2.6,0,0,0-.8-1.08,2.67,2.67,0,0,0-1.23-.51A4.75,4.75,0,0,1,408.38,252.52Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "409.787px 253.561px"
    },
    id: "elzzjz0kob9ng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,259.73s0-.07-.07-.21a2.47,2.47,0,0,1-.05-.61,1.9,1.9,0,0,1,.29-.88,8.66,8.66,0,0,1,.69-.86c.53-.58,1-1.09,1.3-1.49a6.77,6.77,0,0,1,.47-.67,2.33,2.33,0,0,1-.35.75A13.71,13.71,0,0,1,409,257.3a6.73,6.73,0,0,0-.68.83,1.88,1.88,0,0,0-.31.79C408,259.41,408.05,259.73,408,259.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "409.254px 257.37px"
    },
    id: "elfv90tyri5dk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.81,260.12s-.1-.13-.19-.38a3.61,3.61,0,0,1-.23-1,2.1,2.1,0,0,1,.17-1c.11-.24.24-.36.26-.34s-.06.15-.13.39a2.56,2.56,0,0,0-.1,1,6.3,6.3,0,0,0,.16,1C408.81,260,408.84,260.11,408.81,260.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "408.604px 258.759px"
    },
    id: "elpe2vkzui7p9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,255.37s-.07,0-.16.1a.85.85,0,0,0-.24.46,1.34,1.34,0,0,1-.18.36,1.32,1.32,0,0,1-.35.31c-.27.17-.56.32-.85.53a4.64,4.64,0,0,0-1.22,1.29c-.24.39-.33.67-.36.66a1.66,1.66,0,0,1,.24-.73,4.12,4.12,0,0,1,1.23-1.38c.29-.21.61-.37.86-.52a1,1,0,0,0,.5-.57.82.82,0,0,1,.32-.47C413,255.34,413,255.36,413,255.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.32px 257.22px"
    },
    id: "elv9qeqj9flwf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.6,258.14a4.23,4.23,0,0,1,.79-1.1.74.74,0,0,1,.52-.24,2.75,2.75,0,0,1,.43,0c.23,0,.36-.05.38,0s-.12.14-.38.16-.59,0-.81.22A4.92,4.92,0,0,1,409.6,258.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.661px 257.459px"
    },
    id: "el3wy7iozami",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.88,259.28s.21-.36.4-.81.25-.86.31-.85a1.3,1.3,0,0,1-.13.92C410.26,259,409.92,259.32,409.88,259.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.251px 258.452px"
    },
    id: "elcfancjc85zv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.56,255.12a1,1,0,0,0,.55.28,1.2,1.2,0,0,0,.64-.2,3.35,3.35,0,0,1,.88-.26,3.1,3.1,0,0,1,1.62.18c.38.16.63.19.63.21a1.1,1.1,0,0,1-.67-.08,3.58,3.58,0,0,0-1.55-.12,3.7,3.7,0,0,0-.83.23,1.26,1.26,0,0,1-.73.18.73.73,0,0,1-.45-.25C405.57,255.2,405.55,255.13,405.56,255.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "407.719px 255.223px"
    },
    id: "elzpdbt6y9ko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,253.78s.08-.15.33-.2a1,1,0,0,1,.87.3,2.56,2.56,0,0,1,.5.75c.09.21.13.35.11.36s-.11-.11-.23-.29a5,5,0,0,0-.52-.68,1,1,0,0,0-.72-.3C407.13,253.72,407,253.81,407,253.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "407.908px 254.28px"
    },
    id: "elifahzdbeqg7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.26,251.23s.15.07.26.29a2.3,2.3,0,0,1,.16.9,3.39,3.39,0,0,0,.08.86c.05.21.13.33.1.35s-.14-.08-.24-.3a2.58,2.58,0,0,1-.14-.9,3.33,3.33,0,0,0-.09-.86C410.32,251.37,410.23,251.26,410.26,251.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.56px 252.431px"
    },
    id: "eluldq91kxyv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.26,260l.36,7.59c.06,1.27.15,2.53.13,3.81a9.6,9.6,0,0,1-.74,3.77,18.92,18.92,0,0,1-2.24,3.09,4.29,4.29,0,0,0-.72,1.69,9,9,0,0,0-.11,1.87,12.4,12.4,0,0,1-.09,1.92,5.84,5.84,0,0,1-.61,1.82c-.29.57-.63,1.11-.95,1.66l-.44.83-.41.86a26.67,26.67,0,0,0-2,7.3c-.18,1.25-.32,2.51-.45,3.77a10.79,10.79,0,0,1-.34,1.87c-.08.31-.17.62-.28.92s-.26.58-.36.88a16.45,16.45,0,0,0-.59,1.8,2.8,2.8,0,0,0,0,1.85,22.38,22.38,0,0,1,.79,3.72,17.81,17.81,0,0,1,.11,3.79,8.49,8.49,0,0,1-1,3.63,8.52,8.52,0,0,0,1-3.63,18.5,18.5,0,0,0-.13-3.79,23.49,23.49,0,0,0-.81-3.7c0-.16-.1-.3-.14-.46a2.58,2.58,0,0,1,0-.48,5.77,5.77,0,0,1,.17-.94,16,16,0,0,1,.57-1.82c1.12-2.32,1-4.94,1.38-7.43a27.13,27.13,0,0,1,1.93-7.35l.41-.87.45-.84c.31-.56.64-1.1.92-1.66a5.38,5.38,0,0,0,.59-1.76,13.17,13.17,0,0,0,.07-1.89,9.45,9.45,0,0,1,.1-1.91,4.59,4.59,0,0,1,.75-1.79,18.58,18.58,0,0,0,2.19-3.07,9.05,9.05,0,0,0,.69-3.65c0-1.26-.09-2.52-.15-3.79l-.41-7.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "378.491px 289.22px"
    },
    id: "el79vjh29g29g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.18,255.55a2.48,2.48,0,0,1,.09-.46c.06-.3.16-.72.25-1.26a8,8,0,0,0-.27-4.13c-.27-.77-.6-1.49-.88-2.15a12.25,12.25,0,0,1-.63-1.8,6.24,6.24,0,0,1-.17-1.29,2.65,2.65,0,0,1,.05-.47,8.15,8.15,0,0,0,.25,1.72,14,14,0,0,0,.67,1.77c.28.66.63,1.37.9,2.16a7,7,0,0,1,.41,2.31,9.49,9.49,0,0,1-.2,1.91,11.3,11.3,0,0,1-.31,1.25C387.25,255.4,387.2,255.56,387.18,255.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "386.71px 249.77px"
    },
    id: "elabu8981z0so",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.12,299.8l.06-.19c.05-.12.11-.3.21-.53.19-.45.47-1.11.86-1.9s.87-1.72,1.46-2.72c.3-.5.62-1,1-1.55a11,11,0,0,0,1-1.67,4.91,4.91,0,0,0,.33-1.88c0-.63,0-1.24.06-1.83a13.21,13.21,0,0,1,.63-3,11.87,11.87,0,0,1,.82-1.92c.11-.21.21-.38.28-.49l.11-.16s-.12.24-.33.69a16.16,16.16,0,0,0-.75,1.92,13.87,13.87,0,0,0-.58,3c-.05.57,0,1.18-.05,1.81a5,5,0,0,1-.33,1.95,10,10,0,0,1-1,1.7c-.35.53-.67,1.05-1,1.54-.6,1-1.1,1.91-1.5,2.69s-.7,1.43-.91,1.87l-.24.51A.76.76,0,0,1,367.12,299.8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "370.53px 290.88px"
    },
    id: "elizxpq74lwl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.77,319.06a.73.73,0,0,1-.22.09c-.15.06-.38.13-.67.21a8.39,8.39,0,0,1-2.56.2,8.31,8.31,0,0,1-3.63-1.1,7.68,7.68,0,0,1-1.77-1.4,6.1,6.1,0,0,1-1.25-2.07,8.42,8.42,0,0,1-.18-4.62,4.62,4.62,0,0,1,.87-1.84,15.09,15.09,0,0,1,1.13-1.36c.73-.79,1.33-1.43,1.7-1.9s.53-.76.55-.75a.85.85,0,0,1-.11.22,4.92,4.92,0,0,1-.38.58c-.35.49-.94,1.14-1.66,1.94a16.6,16.6,0,0,0-1.1,1.36,4.6,4.6,0,0,0-.82,1.79,8.31,8.31,0,0,0,.19,4.51,6.45,6.45,0,0,0,2.92,3.38,8.73,8.73,0,0,0,6.08,1C371.45,319.16,371.77,319,371.77,319.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "366.51px 312.052px"
    },
    id: "elyh56v14tk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.42,313.59a.68.68,0,0,1-.18.13l-.53.34-2,1.23-3,1.79a1.5,1.5,0,0,1-1,.31.83.83,0,0,1-.51-.27.55.55,0,0,1-.09-.59,1.47,1.47,0,0,1,.37-.44l.41-.36.84-.72,1.66-1.44a5.5,5.5,0,0,0,1.32-1.51,4.88,4.88,0,0,1,.54-.8c.21-.24.43-.44.64-.64a9.57,9.57,0,0,1,1.29-1c.82-.55,1.48-1,1.9-1.34s.62-.59.63-.57a1.1,1.1,0,0,1-.13.18,4.65,4.65,0,0,1-.45.45,22.16,22.16,0,0,1-1.87,1.39,10.43,10.43,0,0,0-1.26,1c-.21.2-.42.41-.62.63a4.77,4.77,0,0,0-.51.78,5.52,5.52,0,0,1-1.35,1.56l-1.66,1.44-.84.73-.41.36a1.11,1.11,0,0,0-.32.37c-.14.27.15.56.44.6a1.46,1.46,0,0,0,.88-.28l3-1.76,2-1.18c.22-.12.41-.22.55-.31S360.42,313.58,360.42,313.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "357.886px 312.551px"
    },
    id: "el3u3a23p1q1t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.14,318.25a9.34,9.34,0,0,0-.18,1,22.1,22.1,0,0,0,0,2.75,27.35,27.35,0,0,1-.29,4.08c-.1.76-.25,1.56-.44,2.38l-.15.62a1.46,1.46,0,0,1-.32.6.53.53,0,0,1-.33.2.42.42,0,0,1-.38-.14,1.11,1.11,0,0,1-.17-.32l-.12-.32a9,9,0,0,1-.39-2.58c0-.84,0-1.64,0-2.41,0-1.54,0-2.92.07-4.09s.1-2.1.14-2.75c0-.31,0-.55,0-.74a1,1,0,0,1,0-.26,1.71,1.71,0,0,1,0,.26c0,.19,0,.44,0,.75,0,.67,0,1.6-.07,2.75s0,2.54,0,4.08c0,.77,0,1.57,0,2.41a8.82,8.82,0,0,0,.39,2.52c0,.1.07.2.11.3a.86.86,0,0,0,.14.27c.12.13.29.09.42-.06a2.6,2.6,0,0,0,.42-1.14c.19-.81.34-1.6.45-2.35a30.59,30.59,0,0,0,.33-4.06,18.78,18.78,0,0,1,.07-2.76,4,4,0,0,1,.17-.73A1.25,1.25,0,0,1,363.14,318.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "361.755px 323.077px"
    },
    id: "elp6yjim0lq3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.94,319.68a.72.72,0,0,1,0,.25c0,.19,0,.43,0,.73,0,.65,0,1.56,0,2.67s0,2.48,0,4c0,.75,0,1.52,0,2.35a2.31,2.31,0,0,1-.41,1.2,1.31,1.31,0,0,1-1.19.57,1.42,1.42,0,0,1-1-.82,2.61,2.61,0,0,1-.22-1.25q.07-1.21.15-2.34c.08-1.48.1-2.83.1-3.95s0-2,0-2.67c0-.3,0-.54,0-.73a1,1,0,0,1,0-.25.87.87,0,0,1,0,.25c0,.17,0,.41.06.73,0,.63.08,1.54.09,2.67s0,2.47-.06,4c0,.75-.1,1.53-.14,2.33a2.59,2.59,0,0,0,.21,1.17,1.24,1.24,0,0,0,.88.71,1.14,1.14,0,0,0,1-.49,2.1,2.1,0,0,0,.37-1.11c.06-.79,0-1.59.05-2.33,0-1.48,0-2.83.05-4s0-2,0-2.67c0-.3,0-.54,0-.73S365.94,319.68,365.94,319.68Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "364.532px 325.447px"
    },
    id: "elvoktvfsv479",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.32,319.78a.68.68,0,0,1,0,.23c0,.17,0,.39-.06.65-.06.59-.14,1.4-.24,2.38s-.25,2.21-.39,3.53a10.53,10.53,0,0,1-.41,2.07,4.8,4.8,0,0,1-.48,1,2.65,2.65,0,0,1-.81.86,1.42,1.42,0,0,1-.58.19.73.73,0,0,1-.6-.23,1,1,0,0,1-.21-.57c0-.2,0-.38,0-.56q0-1.1,0-2.1c0-1.33.08-2.54.13-3.55s.1-1.82.15-2.39c0-.26,0-.48,0-.65l0-.22a.82.82,0,0,1,0,.23c0,.17,0,.38,0,.65,0,.59,0,1.4-.08,2.39s-.06,2.21-.08,3.55c0,.66,0,1.37,0,2.09,0,.36,0,.76.17,1s.63.18.93,0a2.3,2.3,0,0,0,.75-.8,4.88,4.88,0,0,0,.46-1,11.6,11.6,0,0,0,.41-2c.16-1.32.3-2.51.43-3.52s.23-1.79.3-2.38l.1-.64A2.32,2.32,0,0,1,370.32,319.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "368.435px 325.236px"
    },
    id: "el21d743q5fv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.45,318.82a1.54,1.54,0,0,1,0,.44c0,.29,0,.71-.05,1.22a39.19,39.19,0,0,1-.49,4c-.14.77-.3,1.5-.46,2.16a4.34,4.34,0,0,1-.64,1.7,1.07,1.07,0,0,1-.62.37,1,1,0,0,1-.54-.06.51.51,0,0,1-.31-.32s.08.16.34.25a.92.92,0,0,0,1-.33,4.43,4.43,0,0,0,.57-1.65c.15-.66.3-1.39.44-2.16.28-1.53.45-2.93.55-3.94,0-.48.08-.88.11-1.21A2.84,2.84,0,0,1,372.45,318.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "370.903px 323.772px"
    },
    id: "el6nfciyj0cbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.56,306.45a.91.91,0,0,1-.12.32,4.68,4.68,0,0,1-.53.77,25,25,0,0,1-2.19,2.17,8.25,8.25,0,0,0-1.17,1.21l-.45.57a2,2,0,0,0-.27.55,4.72,4.72,0,0,1-.28.89.84.84,0,0,1-.2.29,2.66,2.66,0,0,1,.13-.32,7.39,7.39,0,0,0,.22-.9,1.77,1.77,0,0,1,.27-.6l.44-.6a9,9,0,0,1,1.17-1.24c.89-.8,1.7-1.53,2.22-2.11A10.09,10.09,0,0,0,366.56,306.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "363.955px 309.835px"
    },
    id: "el3zfhwk20tz9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.06,317.9a1.38,1.38,0,0,1,.07-.36c.05-.23.14-.56.25-1s.23-.9.43-1.44a4.92,4.92,0,0,1,.38-.81c.17-.27.36-.52.53-.79a7.39,7.39,0,0,0,.72-1.65c.18-.51.34-1,.49-1.41s.26-.72.34-.94a2.3,2.3,0,0,1,.15-.34s0,.13-.08.36-.16.56-.28,1-.29.9-.45,1.42a7,7,0,0,1-.72,1.7c-.18.28-.37.53-.53.78a4.58,4.58,0,0,0-.38.77c-.2.52-.33,1-.47,1.41s-.23.74-.31,1A1.26,1.26,0,0,1,364.06,317.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "365.74px 313.53px"
    },
    id: "el0boai50utgpc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.41,319.4a1.42,1.42,0,0,1-.14-.38,5.68,5.68,0,0,1-.17-1.1,30.12,30.12,0,0,1,.1-3.66c.1-1.42.19-2.71.27-3.64,0-.47.07-.84.1-1.1a2.23,2.23,0,0,1,.06-.4,1.25,1.25,0,0,1,0,.4c0,.27,0,.64,0,1.11-.05.93-.12,2.22-.21,3.64s-.21,2.71-.16,3.64S368.45,319.39,368.41,319.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "368.365px 314.26px"
    },
    id: "el5kw6wbmben4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.49,319.31a1.37,1.37,0,0,1-.07-.42l-.13-1.17c-.1-1-.25-2.35-.45-3.84s-.41-2.85-.57-3.83c-.08-.46-.14-.84-.19-1.16a2.62,2.62,0,0,1-.05-.43,1.58,1.58,0,0,1,.13.42c.06.27.15.66.24,1.14.2,1,.43,2.33.64,3.83s.32,2.87.39,3.86c0,.49.06.89.07,1.17A2.85,2.85,0,0,1,371.49,319.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "370.767px 313.885px"
    },
    id: "el4qoub0fhft",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.26,307.88s0,0,0,.13a3.1,3.1,0,0,1,0,.39,4.48,4.48,0,0,1-.27,1.41,21.22,21.22,0,0,1-2.3,4.12,19.68,19.68,0,0,1-3,3.67c-.43.42-.8.74-1.06.95a1.8,1.8,0,0,1-.43.31,4.3,4.3,0,0,1,.38-.37c.24-.23.6-.56,1-1a22.46,22.46,0,0,0,2.9-3.68,24.23,24.23,0,0,0,2.33-4.06,4.77,4.77,0,0,0,.32-1.36C373.27,308.06,373.24,307.88,373.26,307.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "369.733px 313.37px"
    },
    id: "elkvubwjpc7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.32,172.53s.13,0,.31.1a1.21,1.21,0,0,1,.48.75,7,7,0,0,1,0,1.3,1.58,1.58,0,0,0,.15.7.77.77,0,0,0,.54.45,3,3,0,0,0,.79,0l.76,0a1.46,1.46,0,0,1,.72.12,1,1,0,0,1,.45.45,2.12,2.12,0,0,1,.22.86.9.9,0,0,1,0,.32s0-.11-.07-.31a2.34,2.34,0,0,0-.27-.8.9.9,0,0,0-.4-.37,1.31,1.31,0,0,0-.64-.09l-.77,0a3,3,0,0,1-.84,0,1,1,0,0,1-.67-.57,1.83,1.83,0,0,1-.15-.78,8,8,0,0,0,0-1.27,1.19,1.19,0,0,0-.38-.72C408.43,172.57,408.31,172.55,408.32,172.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.537px 175.055px"
    },
    id: "elwhjl0prmur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.14,174s.29,0,.54.23.34.49.29.51-.2-.17-.42-.36S408.12,174.06,408.14,174Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "408.561px 174.371px"
    },
    id: "eln5m838z58kn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.39,172.26s.09.24.26.58a1.34,1.34,0,0,0,1.08.86,1.12,1.12,0,0,1,.8.39,1.16,1.16,0,0,1,.3.66.7.7,0,0,1-.14.63,2.19,2.19,0,0,0,0-.61,1.09,1.09,0,0,0-1-.88,1.29,1.29,0,0,1-.81-.38,1.75,1.75,0,0,1-.37-.61A1.38,1.38,0,0,1,412.39,172.26Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "413.621px 173.82px"
    },
    id: "elmmd2yepcqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.17,175.33s-.13-.09-.3-.25a1.71,1.71,0,0,0-.74-.43,1,1,0,0,0-.79.21c-.16.14-.19.29-.22.28s-.05-.17.12-.38a1,1,0,0,1,.93-.3,1.44,1.44,0,0,1,.8.53C417.13,175.18,417.19,175.32,417.17,175.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "416.137px 174.885px"
    },
    id: "eles8o9z5tnq4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.51,156.94a1.28,1.28,0,0,1,.67.26,2.76,2.76,0,0,1,1.07,1.35,4.84,4.84,0,0,1,.19,1.71,3,3,0,0,1,0,.71,1.9,1.9,0,0,1-.1-.7,6,6,0,0,0-.23-1.65,2.92,2.92,0,0,0-1-1.3C415.76,157.06,415.5,157,415.51,156.94Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "416.485px 158.955px"
    },
    id: "el8200oubuvr5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.63,161s0-.08.11-.21a1.22,1.22,0,0,1,.55-.36,2.89,2.89,0,0,1,2.08.26,3.6,3.6,0,0,1,1.54,1.43,1.87,1.87,0,0,1,.3.82s-.13-.31-.42-.74a3.83,3.83,0,0,0-1.5-1.33,3,3,0,0,0-2-.3A1.59,1.59,0,0,0,410.63,161Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "412.92px 161.641px"
    },
    id: "elxdcneas7sek",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.11,299.32a2.27,2.27,0,0,1,1-.43,1.43,1.43,0,0,1,.92.19Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "430.07px 299.099px"
    },
    id: "elznbew5tdpfp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhh5jxqv4wu"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "406.21px 296.873px"
    },
    className: "animable",
    id: "el6c0cniprjdi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.27,296.9a1.92,1.92,0,0,1,1.1-.26,1,1,0,0,1,.78.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "406.21px 296.873px"
    },
    id: "el0ncn1cgg8uvk",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el798yxmmy81p"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "385.005px 224.787px"
    },
    className: "animable",
    id: "eludr2xnfpdrs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.31,224.63s1.07-.51,1.39.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "385.005px 224.787px"
    },
    id: "el9x3lvef3gfg",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M435.46,237.73c-.44-1.19-1.16-4.29-1.53-5.52a11.49,11.49,0,0,0-3.29-5.11c-.17-.07-2.73-1.79-7.12-.63-.51-1-1.7-3.68-1.1-6,.29-1.1.66-1.49.84-1.54a1.05,1.05,0,0,1,.79.33,8.3,8.3,0,0,1,1.32,2.45l2.49-.93a10.41,10.41,0,0,0-2-3.49,3.58,3.58,0,0,0-3.34-.89c-1.26.38-2.15,1.53-2.64,3.41-.86,3.31.76,6.82,1.38,8a2.41,2.41,0,0,0-1,1.52,17.83,17.83,0,0,0-.52,3.77,11.28,11.28,0,0,0,.58,3.35,8.83,8.83,0,0,0,2.6,4,9.48,9.48,0,0,0,4.66,1.86,13.65,13.65,0,0,0,2.57.18c1.73,0,5.11-.24,5.74-2.25A4,4,0,0,0,435.46,237.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.786px 229.394px"
    },
    id: "elpbewzogf16",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.46,237.73a1.42,1.42,0,0,1,.07.14c0,.09.09.23.16.41A3.72,3.72,0,0,1,436,240a2.2,2.2,0,0,1-.55,1.14,3.44,3.44,0,0,1-1.25.84,10.64,10.64,0,0,1-3.63.66,15,15,0,0,1-4.5-.44,9.5,9.5,0,0,1-2.38-1,6.9,6.9,0,0,1-2-1.83,10.58,10.58,0,0,1-2.06-5.51,12.63,12.63,0,0,1,.21-3.17c.1-.53.2-1.05.34-1.6a2.64,2.64,0,0,1,1-1.37l-.05.2a14,14,0,0,1-1.63-5.45,8.4,8.4,0,0,1,.31-3,5.28,5.28,0,0,1,1.58-2.64,3.13,3.13,0,0,1,2.23-.7,4,4,0,0,1,2.13.86,5.62,5.62,0,0,1,1.4,1.76,17.58,17.58,0,0,1,.91,2l.06.16-.16,0-2.49.93-.15.05-.06-.15a12.64,12.64,0,0,0-.63-1.41,2.82,2.82,0,0,0-.87-1.14.86.86,0,0,0-.3-.12.19.19,0,0,0-.21,0,2,2,0,0,0-.37.58,5.15,5.15,0,0,0-.38,1.38,9.78,9.78,0,0,0,1.18,5.29l-.16-.07a9.68,9.68,0,0,1,7.21.65l0,0h0a11.81,11.81,0,0,1,2.89,4.06,14,14,0,0,1,.63,1.94c.15.61.29,1.16.41,1.66.25,1,.44,1.76.59,2.28.07.24.12.43.17.58a1.47,1.47,0,0,1,0,.2s0-.06-.09-.19-.11-.32-.2-.58c-.16-.51-.38-1.27-.64-2.26-.14-.5-.28-1-.44-1.65a13.08,13.08,0,0,0-.65-1.91,11.65,11.65,0,0,0-2.87-3.95l0,0a9.42,9.42,0,0,0-7-.6l-.11,0-.06-.11a13.74,13.74,0,0,1-1-2.56,7.55,7.55,0,0,1-.24-2.89,5.54,5.54,0,0,1,.4-1.47,2.32,2.32,0,0,1,.44-.68.58.58,0,0,1,.22-.13.61.61,0,0,1,.27,0,1.23,1.23,0,0,1,.39.16,1.67,1.67,0,0,1,.59.59,5.77,5.77,0,0,1,.4.68,11.76,11.76,0,0,1,.66,1.44l-.21-.09,2.49-.93-.1.21a16.12,16.12,0,0,0-.89-1.94,5.6,5.6,0,0,0-1.31-1.66,3.69,3.69,0,0,0-1.95-.79,2.86,2.86,0,0,0-2,.63,5,5,0,0,0-1.47,2.47,8.22,8.22,0,0,0-.3,2.87,13.84,13.84,0,0,0,1.59,5.32l.06.12-.11.08a2.32,2.32,0,0,0-.92,1.21c-.14.51-.25,1.05-.34,1.57a12.52,12.52,0,0,0-.22,3.09,10.4,10.4,0,0,0,2,5.36,7.53,7.53,0,0,0,4.25,2.74,14.94,14.94,0,0,0,4.43.48,10.84,10.84,0,0,0,3.58-.6,3.31,3.31,0,0,0,1.21-.79,2.11,2.11,0,0,0,.54-1.06,3.77,3.77,0,0,0-.21-1.66l-.13-.42A1.1,1.1,0,0,1,435.46,237.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "427.741px 229.391px"
    },
    id: "elckxjeazxsq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.61,226.57a3.54,3.54,0,0,1-1.68-.53,6.73,6.73,0,0,1-1.28-1.07c-.38-.4-.75-.75-1.13-1.16s-.69-.83-1-1.24a6.79,6.79,0,0,0-1.11-1.1,3.27,3.27,0,0,0-1.4-.65c-.51-.1-1,.07-1.59,0a1.09,1.09,0,0,1-.74-.34.65.65,0,0,1-.17-.74.64.64,0,0,0,.2.71,1.06,1.06,0,0,0,.71.28,13.92,13.92,0,0,1,1.61-.1,3.35,3.35,0,0,1,1.53.6,7.5,7.5,0,0,1,1.23,1.08c.37.4.71.81,1.09,1.17s.79.72,1.18,1.07a6.11,6.11,0,0,0,1.22.92,2.91,2.91,0,0,0,1.38.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.56px 223.155px"
    },
    id: "elks0joziked",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.29,218.64a11,11,0,0,0,.21,1.21c.19.65.55,1.09.5,1.13a2.31,2.31,0,0,1-.71-2.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "401.608px 219.81px"
    },
    id: "el1sdrgpijkfh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.26,224.09a2,2,0,0,1,1.19-.54,2.13,2.13,0,0,1,1.31.12c0,.06-.58,0-1.28.07S402.28,224.14,402.26,224.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.51px 223.796px"
    },
    id: "elw0p0f9ponb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.06,227a5.52,5.52,0,0,1-2.13.82,15,15,0,0,1-2.19.2,18.56,18.56,0,0,0-2.12.14,6.44,6.44,0,0,0-2,.58,3.73,3.73,0,0,0-.83.6c-.24.24-.45.53-.69.8a2.51,2.51,0,0,1-.88.7,2.78,2.78,0,0,1-1.1.19,9.48,9.48,0,0,0-2.13,0,1.57,1.57,0,0,0-.9.51,1.1,1.1,0,0,0-.28,1,1.14,1.14,0,0,1,.24-1,1.64,1.64,0,0,1,.91-.57,9.83,9.83,0,0,1,2.16-.09,2.75,2.75,0,0,0,1-.22,2.12,2.12,0,0,0,.76-.67c.22-.27.42-.57.68-.84a3.93,3.93,0,0,1,.88-.7,9.83,9.83,0,0,1,4.26-1,14.21,14.21,0,0,0,2.09-.28,4.85,4.85,0,0,0,1.83-.79Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.42px 229.46px"
    },
    id: "elcajumtq9kec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.64,227s.25-.06.49.2a1.6,1.6,0,0,1,.32.49,1.72,1.72,0,0,0,.33.55,1.53,1.53,0,0,0,1.08.38,2.9,2.9,0,0,1,.51,0s-.17.11-.5.15a1.54,1.54,0,0,1-1.23-.38,1.81,1.81,0,0,1-.36-.62,1.38,1.38,0,0,0-.25-.47A1.08,1.08,0,0,0,398.64,227Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "400.005px 227.889px"
    },
    id: "ely9wnhqjsf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.84,229.06s0-.09,0-.22a.89.89,0,0,1,.4-.36.87.87,0,0,1,.53-.07c.14,0,.21.09.2.11s-.33,0-.65.13S398.89,229.08,398.84,229.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "399.405px 228.728px"
    },
    id: "elavidv4p5ytl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.67,228.23a2.58,2.58,0,0,0,1,2.68s-.19,0-.42-.22a2,2,0,0,1-.65-.91,2,2,0,0,1-.08-1.13C397.55,228.37,397.65,228.22,397.67,228.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "398.072px 229.57px"
    },
    id: "ell6atb2uh5t9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.62,226.21s.05-.16.24-.32a1.64,1.64,0,0,1,.91-.4,1.66,1.66,0,0,1,1,.17c.23.12.34.24.32.26a2.82,2.82,0,0,0-1.27-.24A2.69,2.69,0,0,0,398.62,226.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "399.856px 225.842px"
    },
    id: "elqcrnilvab6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,223.8a6.4,6.4,0,0,1,0,1.06,5.78,5.78,0,0,1,0,1.06,2,2,0,0,1-.2-1.06A2,2,0,0,1,401.07,223.8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "400.978px 224.86px"
    },
    id: "elbzvse1eltvf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.5,226a2.23,2.23,0,0,1-1.08-1.67,3.06,3.06,0,0,1,.39-1.85,16.22,16.22,0,0,1,2.29-2.67,2.22,2.22,0,0,0,.63-1.46,2.75,2.75,0,0,0-.63-1.51,12.48,12.48,0,0,0-2.42-2.45,12.69,12.69,0,0,1,2.57,2.34,3,3,0,0,1,.76,1.61,2.54,2.54,0,0,1-.62,1.7,16.35,16.35,0,0,0-2.08,2.69,2.42,2.42,0,0,0-.25,1.5,1.52,1.52,0,0,0,.78,1.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "409.207px 220.195px"
    },
    id: "el28d21ma1owo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.33,214.71a2.72,2.72,0,0,1-.17,1,2.42,2.42,0,0,1-.35.92,2.72,2.72,0,0,1,.17-1A2.42,2.42,0,0,1,410.33,214.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.07px 215.67px"
    },
    id: "el8ijv6b6kf66",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.26,215.72c0,.05-.24.28-.49.66s-.46.69-.51.66.08-.38.35-.77S411.23,215.67,411.26,215.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.755px 216.377px"
    },
    id: "elkffoj7plzhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.16,218.65a5.19,5.19,0,0,1-.7.25c-.38.14-.65.33-.69.29s.21-.31.62-.47S412.16,218.59,412.16,218.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.463px 218.899px"
    },
    id: "elb9u5f7nhoms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.36,222.42s-.12.28-.55.45a2.16,2.16,0,0,1-.77.14,4.4,4.4,0,0,1-.93-.1,6.63,6.63,0,0,0-.91-.13,2.65,2.65,0,0,0-.72.06,3.72,3.72,0,0,0-.62.28s.15-.26.58-.41a2.51,2.51,0,0,1,.77-.11,6.41,6.41,0,0,1,.93.12,5.23,5.23,0,0,0,.91.11,2.25,2.25,0,0,0,.72-.09A2.08,2.08,0,0,0,412.36,222.42Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.11px 222.77px"
    },
    id: "elgoqwo8enob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.7,216.31s-.22.26-.45.76a2.94,2.94,0,0,0-.15,2.05c.12.4.28.77.39,1.13a3,3,0,0,1,.16,1,1.25,1.25,0,0,1-.28.86,2.78,2.78,0,0,0,.14-.86,3.2,3.2,0,0,0-.19-.93c-.12-.34-.28-.71-.4-1.12a2.89,2.89,0,0,1,.21-2.17,2.56,2.56,0,0,1,.38-.55C408.62,216.35,408.69,216.3,408.7,216.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "408.25px 219.209px"
    },
    id: "elikmnvqt2tj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.36,218.6c.05,0-.06.43-.45.76a1.07,1.07,0,0,1-.82.34s.35-.18.69-.48S409.31,218.58,409.36,218.6Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "408.731px 219.15px"
    },
    id: "elcxmgjq1lmh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.54,217.69a1.74,1.74,0,0,1,.67.1,2.76,2.76,0,0,1,.7.28,1.8,1.8,0,0,1,.64.67,4.52,4.52,0,0,1,.32.85,4.55,4.55,0,0,0,.25.67,4.47,4.47,0,0,0,.38.54s-.27-.1-.5-.47a3.63,3.63,0,0,1-.3-.68,5.44,5.44,0,0,0-.32-.81,2,2,0,0,0-1.21-.92A3.93,3.93,0,0,1,402.54,217.69Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.02px 219.244px"
    },
    id: "el2puaksm0i8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.69,217.74s.12.13.11.4a1.67,1.67,0,0,1-.4.89,1.58,1.58,0,0,1-.31.43,1.61,1.61,0,0,0-.23.35c-.12.21-.17.35-.2.34s0-.16.07-.4a1.41,1.41,0,0,1,.22-.39,2.69,2.69,0,0,0,.29-.43l.16-.22.12-.21a1.15,1.15,0,0,0,.15-.38C406.71,217.89,406.66,217.75,406.69,217.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "406.224px 218.945px"
    },
    id: "elauszut3j1ua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.12,233.45a8.72,8.72,0,0,0-1.62,2.19,8.1,8.1,0,0,1-1.77,2.28,3.45,3.45,0,0,1-1.3.71,3.14,3.14,0,0,1-1.46,0,11.68,11.68,0,0,0-1.39-.26,2,2,0,0,0-1.35.3,2,2,0,0,1,1.35-.39,13.41,13.41,0,0,1,1.42.16,2.93,2.93,0,0,0,1.35-.1,3.3,3.3,0,0,0,1.13-.72,8,8,0,0,0,1.54-2.28,9,9,0,0,1,1.6-2.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.675px 235.798px"
    },
    id: "el4ujm18391za",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.13,235.78a5.53,5.53,0,0,1-.79,2.31,3.11,3.11,0,0,1-.89.88,4.21,4.21,0,0,1-1.12.48,4.76,4.76,0,0,0-2.05.89,2.22,2.22,0,0,0-.58,2.09,2.29,2.29,0,0,1,.44-2.21,4.83,4.83,0,0,1,2.07-1.12,4,4,0,0,0,1-.5,2.61,2.61,0,0,0,.68-.8,4.79,4.79,0,0,0,.53-2.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "405.358px 239.07px"
    },
    id: "ell1dg2j4xt3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.24,235.55a30.31,30.31,0,0,1,1.27,3.92c.37,1.31.71,2.62,1.19,3.89-.6-1.22-1.06-2.51-1.54-3.78a29.86,29.86,0,0,0-1.59-3.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "409.135px 239.455px"
    },
    id: "el5jn04po4ymk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,236.6c.06,0,.08.4.31.82s.52.68.49.73-.42-.17-.67-.64A1.11,1.11,0,0,1,399,236.6Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "399.379px 237.378px"
    },
    id: "el1j8xp9g93xt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.27,234.3s.12-.33.48-.52.71-.15.71-.1-.3.1-.62.27S396.31,234.33,396.27,234.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "396.865px 233.971px"
    },
    id: "elhsq187p6rls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.76,237.13a4.63,4.63,0,0,0,.81.82,4.25,4.25,0,0,0,1.07.45s-.14,0-.36,0a2,2,0,0,1-.82-.32,2,2,0,0,1-.59-.63C395.76,237.28,395.74,237.14,395.76,237.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "396.697px 237.765px"
    },
    id: "el8mu8tjzwvv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.19,225.67l-.73-1,.59-.28s-.09.84,1.51.59,8.86-.73,8.86-.73l-.3,2.29-11.25,1.2-1.44-.86,2.23-.49",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.925px 225.995px"
    },
    id: "eli8jcmq9h49p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.38,225.38a16.93,16.93,0,0,0-4.15,3.59c-1,1.52-2.59,3.89-2.59,3.89l-1.84,1.77,1.57.22.09.87.85-1.49.07,1.67,1.55-.19a3.3,3.3,0,0,1,0-2.3c.44-1.32.36-1.51.36-1.51l.67,1.71a4.43,4.43,0,0,1,0-2.1,4.9,4.9,0,0,1,1.09-1.61l.68,1.73a4.79,4.79,0,0,1,.13-2,1.09,1.09,0,0,1,.71-.62,5.66,5.66,0,0,1,2.36-1.23l3.68.1-.16-1.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.705px 230.64px"
    },
    id: "elc52auo8z3rm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.25,225.91a15.55,15.55,0,0,1-2-2.85,7.15,7.15,0,0,1-.66-1.43,5.19,5.19,0,0,1-.26-1.55c0-.52,0-1,.07-1.54a2.66,2.66,0,0,1,.42-1.51,7,7,0,0,1,.55-.54,2.65,2.65,0,0,0,.44-.6,2.46,2.46,0,0,0,.23-.71.92.92,0,0,0,0-.37.37.37,0,0,0-.23-.28.36.36,0,0,1,.25.27.86.86,0,0,1,0,.39,2.45,2.45,0,0,1-.19.74,2.55,2.55,0,0,1-.42.66,6.47,6.47,0,0,0-.5.56,2.43,2.43,0,0,0-.29,1.4,14.93,14.93,0,0,0,0,1.5,5.49,5.49,0,0,0,1,2.72c.55.82,1.23,1.58,1.82,2.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "406.905px 220.22px"
    },
    id: "el8wtoc8dmoie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.75,222.08s-.28.15-.59.33-.59.35-.62.3.19-.26.52-.47S410.74,222,410.75,222.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.144px 222.379px"
    },
    id: "el2sgfqi5rhtd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.76,220.08s-.1-.08-.23-.23a4.23,4.23,0,0,0-.52-.54,1.44,1.44,0,0,0-.65-.3c-.19,0-.31,0-.32,0s.11-.1.33-.1a1.3,1.3,0,0,1,.76.29,2.08,2.08,0,0,1,.51.62C412.74,220,412.79,220.07,412.76,220.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.904px 219.495px"
    },
    id: "el2f6n36ca6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.61,219s-.07-.07-.2-.12a.8.8,0,0,0-.52,0,8.21,8.21,0,0,1-.78.27s.26-.33.73-.45a.74.74,0,0,1,.64,0C407.63,218.91,407.64,219,407.61,219Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "406.867px 218.889px"
    },
    id: "el6kg7nsgrok8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.57,227.14a8.41,8.41,0,0,1-3.15.29,6.47,6.47,0,0,1-3-1,2.12,2.12,0,0,1-.6-.56,3.61,3.61,0,0,1-.38-.69,2.23,2.23,0,0,0-.84-1.15c-.2-.12-.46-.17-.7-.3a1.05,1.05,0,0,1-.45-.65,15.15,15.15,0,0,1-.42-1.46c.35.91.46,2.15,1.66,2.22a1.69,1.69,0,0,1,.62.53,5.91,5.91,0,0,1,.4.67,3.74,3.74,0,0,0,.39.61,1.77,1.77,0,0,0,.54.44,5.9,5.9,0,0,0,2.8.76,11.54,11.54,0,0,0,3.54-.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.005px 224.545px"
    },
    id: "ellmhx2yi6a9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.51,221.08s.17,0,.31.21a2.21,2.21,0,0,1,.32.83.91.91,0,0,1-.08.52,1.91,1.91,0,0,1-.2.33c-.13.18-.16.3-.19.3s0-.16.07-.36a1.24,1.24,0,0,0,.21-.76,3.55,3.55,0,0,0-.24-.79C404.61,221.18,404.5,221.11,404.51,221.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.829px 222.175px"
    },
    id: "elwtevdmqqw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,219.49s.08.13.23.34a1.23,1.23,0,0,1,.2.43,1.26,1.26,0,0,1-.07.58,1.92,1.92,0,0,0,0,.94c.06.23.14.37.11.39s-.14-.1-.24-.35a1.61,1.61,0,0,1-.09-1,1.66,1.66,0,0,0,.08-.5,2,2,0,0,0-.15-.39C403,219.67,403,219.49,403,219.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.238px 220.831px"
    },
    id: "elbwy91e59heq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.38,222.46s.12,0,.28,0a.47.47,0,0,0,.49-.18,2.86,2.86,0,0,1,.22-.3.52.52,0,0,1,.29-.17c.19,0,.3,0,.29.06s-.12,0-.25.07a.49.49,0,0,0-.2.16c-.06.07-.11.18-.19.29a.51.51,0,0,1-.35.23.68.68,0,0,1-.33,0C401.46,222.55,401.38,222.49,401.38,222.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.165px 222.225px"
    },
    id: "elrlgm9l30tr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.19,218.89c.06,0-.18.39-.32.85a3,3,0,0,0-.05.88s-.09-.07-.15-.24a1.25,1.25,0,0,1,0-.69,2,2,0,0,1,.31-.6C402.09,219,402.17,218.88,402.19,218.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "401.91px 219.755px"
    },
    id: "el2ejmen0h26s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.77,218.14s-.19.33-.62.4-.76-.12-.73-.17.33,0,.69,0S403.73,218.1,403.77,218.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.094px 218.346px"
    },
    id: "elb20obetork",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.87,217.31s.1,0,.18.14a1.47,1.47,0,0,1,.2.47c.1.38.13.69.08.7s-.17-.28-.26-.65S403.84,217.35,403.87,217.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.11px 217.965px"
    },
    id: "elebn2klym5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.91,222.09s0,.13.13.28.32.37.5.62a2.53,2.53,0,0,1,.45.69c.08.21,0,.35,0,.35s-.05-.13-.14-.3a5.32,5.32,0,0,0-.48-.62,7.15,7.15,0,0,1-.47-.67C398.82,222.23,398.89,222.07,398.91,222.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "399.444px 223.059px"
    },
    id: "elnikwkwps4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.16,224a2.32,2.32,0,0,1,.33.54,3.2,3.2,0,0,0,.94,1.1,1.9,1.9,0,0,0,.75.28,1,1,0,0,1,.58.4,1.24,1.24,0,0,1,.27.58s-.13-.21-.37-.49a.87.87,0,0,0-.53-.32,1.9,1.9,0,0,1-.81-.29,2.85,2.85,0,0,1-.95-1.2A2,2,0,0,1,402.16,224Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.595px 225.45px"
    },
    id: "elktncnf98c1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.6,228.29a1.53,1.53,0,0,0-.49.85,1.4,1.4,0,0,0,0,.5.45.45,0,0,0,.23.35c.27.17.68.13,1.05.35a4.35,4.35,0,0,1,.78.84,1,1,0,0,0,.42.28.55.55,0,0,0,.47-.07,1.79,1.79,0,0,0,.29-.43.71.71,0,0,1,.19-.23.55.55,0,0,1,.28-.11,2.36,2.36,0,0,0,.55-.07.61.61,0,0,0,.3-.41c.06-.18.07-.37.14-.54a.58.58,0,0,1,.36-.41.56.56,0,0,0-.34.41c-.06.18-.06.37-.11.55a.66.66,0,0,1-.32.46,2.37,2.37,0,0,1-.56.1.5.5,0,0,0-.39.3,1.31,1.31,0,0,1-.31.49.66.66,0,0,1-.59.11,1.08,1.08,0,0,1-.52-.3,3.71,3.71,0,0,0-.76-.77c-.28-.17-.68-.11-1.07-.31a.78.78,0,0,1-.38-.54,1.79,1.79,0,0,1,0-.61,2,2,0,0,1,.56-1.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.482px 229.824px"
    },
    id: "eluw3tku435xr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.28,232.36s.07,0,.18,0a1.3,1.3,0,0,0,.45.08,1.07,1.07,0,0,0,.9-1c.06-.59-.08-1.16-.05-1.58a1.07,1.07,0,0,1,.16-.65s0,.25,0,.65a9.91,9.91,0,0,1,.1,1.6,1.41,1.41,0,0,1-.39.84.94.94,0,0,1-.7.3,1.29,1.29,0,0,1-.48-.15C400.33,232.41,400.28,232.37,400.28,232.36Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "401.151px 230.905px"
    },
    id: "elkqiiknig0v8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.52,228.71s-.13.14-.39.23a1.72,1.72,0,0,0-.83.53,3,3,0,0,0-.29.49.83.83,0,0,1-.36.36.45.45,0,0,1-.35,0c-.08,0-.11-.07-.1-.08s.17.06.38-.08a.71.71,0,0,0,.27-.33,3.24,3.24,0,0,1,.3-.52,1.42,1.42,0,0,1,.48-.38,2.31,2.31,0,0,1,.46-.16A2.45,2.45,0,0,1,405.52,228.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.359px 229.533px"
    },
    id: "elkcgco5fd4qa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.21,230.09s.23.17.26.5-.1.56-.14.54,0-.25-.05-.52S405.17,230.12,405.21,230.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "405.336px 230.611px"
    },
    id: "elucynvrrpcvl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.73,229.11s0,.13,0,.3a3.65,3.65,0,0,0,.27.68,1.47,1.47,0,0,0,.5.52c.16.11.26.19.24.21s-.13,0-.31-.09a1.36,1.36,0,0,1-.6-.54,1.85,1.85,0,0,1-.23-.76C395.6,229.2,395.71,229.09,395.73,229.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "396.171px 229.967px"
    },
    id: "elvlel3wrjdl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,234.71a5.27,5.27,0,0,1-3.06.95,10.05,10.05,0,0,1-1.56-.12,5.4,5.4,0,0,0-.73-.11.84.84,0,0,0-.59.19,11.48,11.48,0,0,0-2,2.23,5.19,5.19,0,0,0-.42.62,2.78,2.78,0,0,0-.28.69,6.06,6.06,0,0,0-.15.74,1.15,1.15,0,0,0,0,.37.41.41,0,0,0,.23.28.4.4,0,0,1-.25-.27,1.28,1.28,0,0,1,0-.38c0-.26.07-.51.11-.76a3.67,3.67,0,0,1,.24-.73,7.41,7.41,0,0,1,.4-.67,11.7,11.7,0,0,1,1.9-2.42,1.29,1.29,0,0,1,.81-.31c.3,0,.54.05.79.07a8,8,0,0,0,1.47,0,4.49,4.49,0,0,0,2.62-1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "401.588px 237.315px"
    },
    id: "el3gd4fa75kmx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.3,235.25s-.32,0-.69-.3-.75-.84-1.45-1a2.63,2.63,0,0,1-1.54-1,1.38,1.38,0,0,1-.33-.68s.14.25.44.59a2.69,2.69,0,0,0,1.49.87,2.34,2.34,0,0,1,.5.19,1.79,1.79,0,0,1,.4.29c.23.22.41.43.57.58A2.52,2.52,0,0,0,400.3,235.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "398.295px 233.76px"
    },
    id: "elwwllz768lyo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.05,235.38a1,1,0,0,1-.39.18.79.79,0,0,0-.35.23,1.05,1.05,0,0,0-.14.49,1.54,1.54,0,0,1-.48.95c-.2.18-.37.23-.38.21s.12-.11.29-.31a1.63,1.63,0,0,0,.38-.88,1.17,1.17,0,0,1,.19-.57.89.89,0,0,1,.45-.25C402.88,235.38,403,235.35,403.05,235.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.18px 236.406px"
    },
    id: "el4rs0nmad0li",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.37,237.3s0-.14.11-.33a1.48,1.48,0,0,0,.09-.35c0-.14,0-.29.07-.46a1.67,1.67,0,0,1,.51-.7c.17-.14.29-.2.3-.18s-.06.12-.2.28a1.92,1.92,0,0,0-.42.66c0,.15-.06.31-.09.44a1.08,1.08,0,0,1-.13.36C403.5,237.22,403.39,237.31,403.37,237.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.91px 236.288px"
    },
    id: "el3zryxfrxhdc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.86,233s.2-.07.5.05a1.4,1.4,0,0,1,.46.34,1.49,1.49,0,0,1,.27.63,2.25,2.25,0,0,0,.17.6.74.74,0,0,0,.35.31c.26.13.45.15.45.19a1,1,0,0,1-.95-.41,2.07,2.07,0,0,1-.21-.65,1.15,1.15,0,0,0-.6-.88C402.05,233,401.86,233,401.86,233Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.96px 234.054px"
    },
    id: "el92penhxtgmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.89,232.89c.05,0,.24.22.29.6s-.09.68-.14.66,0-.3-.06-.63S402.84,232.92,402.89,232.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.032px 233.52px"
    },
    id: "elbz11nkyerzn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.34,236.49a3.27,3.27,0,0,0-.06.85c0,.31,0,.63.06.95a17.77,17.77,0,0,1,.13,2,2.44,2.44,0,0,1-.05.53c0,.18-.1.34-.14.48a9.38,9.38,0,0,0-.16.93,6.12,6.12,0,0,1-.32,1,4.21,4.21,0,0,1-.49.88,2.66,2.66,0,0,1-1.69,1.12,2,2,0,0,1-1-.09c-.32-.11-.61-.26-.91-.33a1.44,1.44,0,0,0-1.61.61,1.1,1.1,0,0,0-.15.44,1.16,1.16,0,0,1-.06.48.59.59,0,0,1-.41.26,1.89,1.89,0,0,0-.45.17,1.39,1.39,0,0,1,.45-.19.57.57,0,0,0,.37-.26,1.77,1.77,0,0,0,0-.47,1.15,1.15,0,0,1,.13-.48,1.37,1.37,0,0,1,.74-.66,1.79,1.79,0,0,1,1-.09,8,8,0,0,1,.94.28,1.69,1.69,0,0,0,.89,0,2.3,2.3,0,0,0,1.41-1,4.68,4.68,0,0,0,.65-1.72c.05-.28,0-.62.12-1,0-.16.09-.31.11-.45a3,3,0,0,0,0-.43c0-.61-.12-1.25-.2-1.89,0-.32-.08-.65-.11-1a4.38,4.38,0,0,1,.05-1.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.75px 241.555px"
    },
    id: "el4eh5ghkktrn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.41,238.7s-.07.17-.13.45a1.54,1.54,0,0,0,0,.49,2,2,0,0,0,.15.59,5.53,5.53,0,0,1,.21.61,1,1,0,0,1,.05.29.39.39,0,0,1-.11.26c-.17.22-.14.42-.18.42s-.1-.2.06-.5c.05-.07.08-.11.07-.17a1.29,1.29,0,0,0-.06-.25c-.05-.18-.14-.38-.22-.59a2.26,2.26,0,0,1-.15-.65,1.46,1.46,0,0,1,.08-.54C406.25,238.82,406.4,238.68,406.41,238.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "406.394px 240.254px"
    },
    id: "elte3ad360lqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.67,243.57s-.07,0-.08-.18a.6.6,0,0,1,.21-.47,4.87,4.87,0,0,0,.53-.5.77.77,0,0,0,.09-.76,10,10,0,0,1-.47-1.57,2.5,2.5,0,0,1-.1-.68c.06,0,.3,1,.75,2.19a1.21,1.21,0,0,1,.06.5.85.85,0,0,1-.19.43,4.32,4.32,0,0,1-.57.49.61.61,0,0,0-.24.38A1.54,1.54,0,0,0,404.67,243.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "405.127px 241.49px"
    },
    id: "elqojdxqdtb1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.87,243.1c-.06,0-.08-.27-.15-.56a1.23,1.23,0,0,0-.14-.36c-.05-.1-.06-.17,0-.18s.08,0,.15.1a.75.75,0,0,1,.13.16.92.92,0,0,1,.09.23C406,242.84,405.91,243.1,405.87,243.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "405.752px 242.548px"
    },
    id: "eldp70xexapfs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.64,242.25s-.09-.06-.14-.21a.9.9,0,0,1,.07-.63A1.55,1.55,0,0,1,405,241c.1-.1.13-.18.16-.18s0,.12-.05.26-.26.27-.35.44A1.84,1.84,0,0,0,404.64,242.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.822px 241.535px"
    },
    id: "elbpori6xyfxa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,241.23s-.05-.09-.09-.24,0-.37-.17-.47-.38-.18-.51-.26-.21-.13-.2-.16.11,0,.25,0a2.47,2.47,0,0,1,.58.24.43.43,0,0,1,.18.34c0,.11,0,.19,0,.27S406,241.23,406,241.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "405.535px 240.658px"
    },
    id: "elvdpeiacnq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,240.66a2.59,2.59,0,0,0-.5-.1,3,3,0,0,0-1.19.36,5.76,5.76,0,0,0-.61.33,1.58,1.58,0,0,1-.56.24.7.7,0,0,1-.41-.06c-.09-.05-.12-.1-.11-.11a.86.86,0,0,0,.49,0,10.58,10.58,0,0,0,1.12-.61,2.45,2.45,0,0,1,1.28-.31C402.84,240.46,403,240.65,403,240.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "401.309px 240.948px"
    },
    id: "el8otjlikfbvy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.94,242.41s.11-.34.33-.68.45-.6.49-.57-.1.33-.32.68S400,242.44,399.94,242.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "400.353px 241.785px"
    },
    id: "elstcvyz71awk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.59,239.6s.24-.12.52,0,.45.26.42.3-.23-.05-.48-.12S402.6,239.65,402.59,239.6Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.062px 239.728px"
    },
    id: "elu0onp2cqfsp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.6,243s0-.14-.05-.37.07-.58-.13-.79a3.73,3.73,0,0,0-.36-.32.63.63,0,0,1-.21-.39c0-.24,0-.38,0-.38s0,.15.08.36a.64.64,0,0,0,.2.28,2.51,2.51,0,0,1,.39.32.73.73,0,0,1,.16.52c0,.16,0,.29,0,.41S403.63,243,403.6,243Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.266px 241.875px"
    },
    id: "el48t0d7666e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.09,245.44s0,.11-.19.22a1.09,1.09,0,0,1-.67.22,1.12,1.12,0,0,1-.85-.46s.39.2.86.27a1.42,1.42,0,0,0,.59-.15C402,245.47,402.07,245.42,402.09,245.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "401.235px 245.65px"
    },
    id: "el10h19umbbd6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,243.79c.06,0,.13.25.35.48s.47.32.46.37-.34.05-.6-.24S401.92,243.78,402,243.79Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "402.386px 244.227px"
    },
    id: "eld3g0z7gc7mr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.73,244.88s-.17.05-.43.11a2.4,2.4,0,0,0-.94.46,1.94,1.94,0,0,0-.59.84c-.08.26-.09.43-.12.43a.68.68,0,0,1,0-.46,1.77,1.77,0,0,1,.6-1,2.18,2.18,0,0,1,1-.44C404.56,244.82,404.73,244.86,404.73,244.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.67px 245.77px"
    },
    id: "el0aw5lau58jub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,247.7s.15-.15.41-.32a5.26,5.26,0,0,0,1-.7,3.1,3.1,0,0,0,.6-1.05,1.45,1.45,0,0,1,.2-.48,1.52,1.52,0,0,1-.07.52,2.65,2.65,0,0,1-.59,1.14,3.8,3.8,0,0,1-1.07.69A1.78,1.78,0,0,1,403,247.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.106px 246.425px"
    },
    id: "el43nwp2lmxae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.55,248c-.05,0,.09-.33.11-.72s-.06-.71,0-.73.23.3.2.74S404.59,248.07,404.55,248Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.701px 247.279px"
    },
    id: "elqrdsqayg6w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.12,249.13a.45.45,0,0,1,0-.24,1.41,1.41,0,0,1,.31-.59c.17-.22.43-.43.67-.68a1.32,1.32,0,0,0,.41-1c0-.38-.29-.72-.3-1.13a.78.78,0,0,1,.2-.52c.11-.13.22-.23.31-.32a5.48,5.48,0,0,0,.49-.72,1.48,1.48,0,0,1-.38.81c-.17.21-.46.42-.44.75s.27.66.31,1.12a1.45,1.45,0,0,1-.47,1.12c-.26.26-.52.45-.7.65A1.81,1.81,0,0,0,405.12,249.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "406.157px 246.53px"
    },
    id: "eleiqx2gpn4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.65,246.66c0-.06.48.07.94.4a2.21,2.21,0,0,1,.75.69,3.7,3.7,0,0,1-.86-.53C407,246.9,406.64,246.7,406.65,246.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "407.495px 247.198px"
    },
    id: "elzjubt7r80m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.32,245.09s0-.13,0-.31a1,1,0,0,0-.23-.65,2.27,2.27,0,0,1-.51-.59c-.09-.21,0-.35,0-.34s0,.12.12.27a4.48,4.48,0,0,0,.54.54,1,1,0,0,1,.22.78C408.43,245,408.34,245.1,408.32,245.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "408.005px 244.145px"
    },
    id: "el2ugdvgiovj2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.84,245.29s-.12,0-.19-.16-.13-.31-.2-.51a.39.39,0,1,1,.18-.06,5.07,5.07,0,0,1,.15.52C407.81,245.2,407.86,245.26,407.84,245.29Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "407.437px 244.566px"
    },
    id: "elx1lio4tgj5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.9,242.55s0-.06,0-.14.11-.18.17-.29a.49.49,0,0,0,0-.43.75.75,0,0,1-.09-.32.67.67,0,0,1,.13-.35,1.24,1.24,0,0,0,.25-1c0-.27-.14-.42-.12-.44s.17.12.26.41a1.29,1.29,0,0,1-.23,1.14.47.47,0,0,0-.1.24.88.88,0,0,0,.06.26.9.9,0,0,1,.08.28.54.54,0,0,1-.07.27c-.09.13-.18.21-.22.27S408.92,242.55,408.9,242.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "409.223px 241.064px"
    },
    id: "elzl6mcg9ztfo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.75,235.13a2.92,2.92,0,0,0,.35.93,3.7,3.7,0,0,0,.66.79,2.88,2.88,0,0,1,.71,1c.15.4.15.77.35,1a1.17,1.17,0,0,0,.41.27,5,5,0,0,1,.5.29,2.77,2.77,0,0,0,.94.5,2.3,2.3,0,0,0,1.06-.11l1.08-.28-1.05.36a2.49,2.49,0,0,1-1.12.22,3.26,3.26,0,0,1-1.06-.45,3,3,0,0,0-.48-.23,1.81,1.81,0,0,1-.55-.31,3,3,0,0,1-.5-1.05,2.59,2.59,0,0,0-.67-.75,4.47,4.47,0,0,1-.83-.85,3.76,3.76,0,0,1-.52-1.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.42px 237.616px"
    },
    id: "elrjs1odqaf4c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.63,238.69s.05.15.15.37.12.24.19.4a1,1,0,0,1,.08.57.56.56,0,0,1-.14.29c-.06.07-.14.13-.18.19a.64.64,0,0,0-.15.35c0,.24,0,.39,0,.4s-.11-.13-.11-.4a.65.65,0,0,1,.14-.46,1.63,1.63,0,0,1,.17-.2.35.35,0,0,0,.1-.2,2.09,2.09,0,0,0-.21-.9C410.57,238.86,410.6,238.68,410.63,238.69Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.765px 239.975px"
    },
    id: "elvtuqwe81oxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.26,241.25s-.1-.09-.05-.24.05-.15.06-.22a.82.82,0,0,0,0-.26,6.65,6.65,0,0,1-.26-.72s.32.22.44.66a.66.66,0,0,1,0,.34.76.76,0,0,1-.1.25C411.27,241.17,411.28,241.24,411.26,241.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.241px 240.53px"
    },
    id: "elxr5jzm9tmm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.54,242s-.16,0-.35-.15a2.1,2.1,0,0,1-.56-.75.51.51,0,0,1,0-.29,1.5,1.5,0,0,0,0-.22,1.6,1.6,0,0,0-.12-.35c-.1-.2-.18-.33-.15-.35s.13.08.26.28a1.29,1.29,0,0,1,.19.39c.05.16,0,.35.06.47a3.09,3.09,0,0,0,.47.72C413.43,241.93,413.56,242,413.54,242Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "412.948px 240.944px"
    },
    id: "elj2p42yya9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.78,241.49a4.14,4.14,0,0,0-.48-.3c-.3-.13-.53-.27-.51-.31s.29,0,.59.13a.87.87,0,0,1,.35.29C413.8,241.4,413.81,241.48,413.78,241.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "413.292px 241.178px"
    },
    id: "elv7cnd8fezac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.23,240.53c-.05,0-.13-.15-.27-.31s-.27-.28-.25-.33.24,0,.4.21S414.28,240.52,414.23,240.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "413.982px 240.201px"
    },
    id: "elo1vc97wh0o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.06,231.26a8.45,8.45,0,0,0,.09,2.19c.14.53.44,1,.64,1.58s.19,1.14.35,1.68a3.18,3.18,0,0,0,.36.77,1.52,1.52,0,0,1,.16.4.49.49,0,0,0,.2.37.53.53,0,0,1-.22-.36,1.66,1.66,0,0,0-.18-.38,3.55,3.55,0,0,1-.41-.77c-.19-.55-.24-1.13-.43-1.65a16.07,16.07,0,0,1-.74-1.56,5.42,5.42,0,0,1-.28-1.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.73px 234.755px"
    },
    id: "ellqym27tnh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.52,237.1s-.25-.43-.74-.74c-.23-.15-.5-.23-.68-.34s-.19-.31-.16-.3.07.1.23.18l.32.11a1.6,1.6,0,0,1,.4.19,1.52,1.52,0,0,1,.54.58C412.53,237,412.55,237.09,412.52,237.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.73px 236.41px"
    },
    id: "elztew4u5965b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.61,236.86c-.05,0,.09-.28.14-.61s0-.61.05-.62.2.26.14.65S410.64,236.89,410.61,236.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.777px 236.246px"
    },
    id: "elfuw5pgl0our",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.77,229.51a16.63,16.63,0,0,0,.27,2.62c0,.22.08.44.13.65a2.28,2.28,0,0,1,.1.7c0,.51-.44.81-.58,1.23.08-.44.42-.82.4-1.24a2.2,2.2,0,0,0-.18-.61c-.08-.21-.16-.42-.23-.64a16.81,16.81,0,0,1-.65-2.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.65px 232.11px"
    },
    id: "elbqgdabk4oul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.06,234.22s.12-.05.25-.2a2.46,2.46,0,0,0,.37-.68,8.17,8.17,0,0,0,.22-1.1,1.52,1.52,0,0,1,0,1.17,1.75,1.75,0,0,1-.46.71C411.22,234.27,411.05,234.25,411.06,234.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.538px 233.241px"
    },
    id: "elec7xtul86r8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.54,232.08c0,.06-.42-.09-.64-.52a1,1,0,0,1-.13-.81c.05,0,.11.35.3.72A4.09,4.09,0,0,0,412.54,232.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "412.138px 231.421px"
    },
    id: "eln0wykdihexo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.78,236.24s-.2-.13-.21-.47a4.79,4.79,0,0,0,.06-1.17,7.76,7.76,0,0,0-.42-1.1,1.18,1.18,0,0,1-.12-.49s.1.16.25.43a4.89,4.89,0,0,1,.47,1.12,1.5,1.5,0,0,1,0,.7,4.64,4.64,0,0,0-.1.52A1.13,1.13,0,0,0,412.78,236.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "412.471px 234.625px"
    },
    id: "eliljzrcjmjg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.55,235.47c-.05,0-.21-.18-.43-.4s-.41-.39-.39-.43.29.06.53.3S413.6,235.44,413.55,235.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "413.146px 235.051px"
    },
    id: "elinem52hv0w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.29,227.86a2.59,2.59,0,0,1,.28,1.14,5.65,5.65,0,0,1-.07,1.1,9.65,9.65,0,0,0-.12,1.05c0,.34,0,.68,0,1.06a1.77,1.77,0,0,1-.09.56c-.05.18-.12.34-.18.51a2.3,2.3,0,0,0-.11,1,5.52,5.52,0,0,0,.25,1,2,2,0,0,1,.06,1.06,2.06,2.06,0,0,0-.13-1,7.23,7.23,0,0,1-.32-1,2.51,2.51,0,0,1,.06-1.09,3.45,3.45,0,0,0,.19-1c0-.34-.09-.7-.09-1.07s0-.73.05-1.08a3.23,3.23,0,0,0-.27-1.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "414.187px 232.1px"
    },
    id: "elljjd59ac5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.28,229.89a1.46,1.46,0,0,1-.26.78,1.27,1.27,0,0,1-.59.59s.24-.28.47-.66S414.24,229.88,414.28,229.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "413.855px 230.575px"
    },
    id: "el6l5n3k6idxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,230.22s-.28-.11-.46-.41-.19-.58-.15-.59.11.25.28.52S415,230.18,415,230.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "414.685px 229.72px"
    },
    id: "elraofi1tadlc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.82,235.07s-.07-.12,0-.3a.82.82,0,0,1,.22-.25l.33-.2a1.3,1.3,0,0,0,.44-.48c.09-.15.15-.24.17-.23s0,.11-.08.28a1.19,1.19,0,0,1-.45.56,1.91,1.91,0,0,0-.55.37C412.83,235,412.84,235.07,412.82,235.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "413.388px 234.34px"
    },
    id: "elqk3lmcywk6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.73,236a4.36,4.36,0,0,1-.76-1.32s.24.26.44.62A2.18,2.18,0,0,1,414.73,236Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "414.35px 235.34px"
    },
    id: "elytkrp2f0h8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.22,223.38a10.24,10.24,0,0,0,3.63,1.27v-.83a8.76,8.76,0,0,1-3-2.35c-.72-1.13-3.76-1.78-4-1.82a24.45,24.45,0,0,0-2.37.71l-.48,1.2a8,8,0,0,0,1.18.84h-.05a40.9,40.9,0,0,1,4.65,5.35l.34-1.68a29.48,29.48,0,0,0-2-3C432.06,222.9,432.26,222.65,433.22,223.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "431.925px 223.7px"
    },
    id: "elrpqx5b4tumg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.78,226.4a20.21,20.21,0,0,1,.16-4.12c.3-1,.61-3.31,3.71-3.86s5.68,2.69,5.68,2.69-3.82-1.91-5.32-.05c-.88,1.08-1.06,3-.78,5A16.41,16.41,0,0,0,423.78,226.4Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "428.535px 222.379px"
    },
    id: "elakfjkzk1t9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.93,446.6a1.42,1.42,0,0,1-.24-.33,6.49,6.49,0,0,1-.46-1,15.87,15.87,0,0,1-.69-3.59c-.08-.71-.14-1.38-.24-2a6.63,6.63,0,0,0-.42-1.56,9.5,9.5,0,0,0-.77-1.29s.12.09.29.29a4.25,4.25,0,0,1,.6.95,6,6,0,0,1,.48,1.58c.11.62.17,1.29.26,2a18,18,0,0,0,.63,3.57A11.62,11.62,0,0,0,400.93,446.6Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "399.52px 441.715px"
    },
    id: "el39a1jsatajm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.58,449a.69.69,0,0,1-.07-.3,2.22,2.22,0,0,1,.08-.84,3.13,3.13,0,0,1,.57-1.12,5.36,5.36,0,0,1,1.13-1c.87-.65,1.68-1.18,2.28-1.55a5.26,5.26,0,0,1,1-.54,10.82,10.82,0,0,1-.93.66c-.58.4-1.38.95-2.24,1.59a5.67,5.67,0,0,0-1.11,1,3.26,3.26,0,0,0-.58,1.05A3.41,3.41,0,0,0,388.58,449Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "391.035px 446.325px"
    },
    id: "el5b3jmndaw4u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.65,451.33s-.09-.08-.15-.29a1.4,1.4,0,0,1,.1-.89,7,7,0,0,1,2-2.17,19.55,19.55,0,0,1,2.38-1.69,4.7,4.7,0,0,1,1.07-.55s-.39.25-1,.67-1.45,1-2.33,1.72a8,8,0,0,0-1.95,2.08,1.39,1.39,0,0,0-.15.81C389.61,451.22,389.67,451.32,389.65,451.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "392.259px 448.535px"
    },
    id: "elgmuht0104zc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.85,454.51a1.76,1.76,0,0,1,0-.35,3.52,3.52,0,0,1,.32-.9,9.88,9.88,0,0,1,1.88-2.53,21.1,21.1,0,0,1,2.38-2.08c.32-.24.59-.42.78-.55a1.54,1.54,0,0,1,.3-.17,12.19,12.19,0,0,1-1,.83,28.74,28.74,0,0,0-2.32,2.1,11.27,11.27,0,0,0-1.9,2.46A11.45,11.45,0,0,0,391.85,454.51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "394.676px 451.22px"
    },
    id: "elp6ck0ex2vl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.91,453.56a3.53,3.53,0,0,1-.67-.61c-.39-.4-.91-1-1.45-1.63s-1-1.29-1.3-1.75a3.6,3.6,0,0,1-.46-.78,6,6,0,0,1,.57.7c.34.44.81,1.05,1.34,1.71l1.4,1.66A4.3,4.3,0,0,1,444.91,453.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "442.97px 451.175px"
    },
    id: "elrhqnqjblazm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.1,454.51a7.8,7.8,0,0,1-.68-.95c-.41-.6-1-1.4-1.71-2.24s-1.42-1.55-1.94-2.05a9.37,9.37,0,0,1-.83-.82,5.33,5.33,0,0,1,.92.72,20.16,20.16,0,0,1,2,2,20.49,20.49,0,0,1,1.68,2.29A6,6,0,0,1,449.1,454.51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "446.52px 451.48px"
    },
    id: "elrscakhfx38h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.12,452.71a37.67,37.67,0,0,1-2.83-2.59c-1.52-1.48-2.73-2.7-2.69-2.74a37.67,37.67,0,0,1,2.83,2.59C451,451.45,452.16,452.67,452.12,452.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "449.36px 450.045px"
    },
    id: "elaoa9s5195c8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.23,449.17a4.18,4.18,0,0,1-.85-.53c-.51-.34-1.21-.82-2-1.32s-1.52-.95-2.05-1.27a4.63,4.63,0,0,1-.83-.55,5.12,5.12,0,0,1,.9.43c.55.29,1.29.71,2.08,1.22s1.49,1,2,1.38A4.15,4.15,0,0,1,453.23,449.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "450.365px 447.335px"
    },
    id: "ellnprjqxsksa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.62,447.32a9.73,9.73,0,0,1-.78-.62,15.2,15.2,0,0,0-2-1.37,16.55,16.55,0,0,0-2.18-1,7.93,7.93,0,0,1-.94-.36,3.85,3.85,0,0,1,1,.23,11.61,11.61,0,0,1,2.23,1,11.74,11.74,0,0,1,2,1.43A3.93,3.93,0,0,1,453.62,447.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "450.67px 445.645px"
    },
    id: "elxbykv3qdcfa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,443.68a9.12,9.12,0,0,1-1.8,1.77,8.9,8.9,0,0,1-2.11,1.38c0-.05.91-.67,2-1.54S399.93,443.64,400,443.68Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "398.045px 445.254px"
    },
    id: "el9gpqh1m4pcw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.53,441a1.89,1.89,0,0,1-.56.76,10.62,10.62,0,0,1-1.84,1.32c-.75.47-1.43.89-1.93,1.18a3.89,3.89,0,0,1-.83.43,5.25,5.25,0,0,1,.76-.55c.48-.32,1.15-.76,1.89-1.22a17.22,17.22,0,0,0,1.86-1.26A6.94,6.94,0,0,0,399.53,441Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "396.95px 442.845px"
    },
    id: "eln4586evjsdj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.14,450.94a4.25,4.25,0,0,1,.6-.69c.39-.4,1-.94,1.61-1.5s1.27-1,1.73-1.35a3.54,3.54,0,0,1,.78-.48,4.48,4.48,0,0,1-.69.59c-.44.35-1,.84-1.69,1.39s-1.23,1.07-1.64,1.45A4.59,4.59,0,0,1,391.14,450.94Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "393.5px 448.93px"
    },
    id: "elo8gqkczsghd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.41,442.94a1.34,1.34,0,0,1-.06.33,5.21,5.21,0,0,1-.33.84,5.45,5.45,0,0,1-2,2.17,5.35,5.35,0,0,1-2.87.75,4.28,4.28,0,0,1-.9-.11.87.87,0,0,1-.32-.1,12.21,12.21,0,0,0,1.22.07A5.55,5.55,0,0,0,446.9,444C447.26,443.39,447.37,442.93,447.41,442.94Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "444.17px 444.986px"
    },
    id: "elaj8vt36q33",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.12,227a3.93,3.93,0,0,0-1.06.47,3.24,3.24,0,0,0-.59.44,5,5,0,0,0-1.11,5.44,6.23,6.23,0,0,0,.68,1.3h0a2.92,2.92,0,0,0,.45.63,3.59,3.59,0,0,0,.68.54,2.08,2.08,0,0,0,1.94.24,1.07,1.07,0,0,0,.63-.94c.16-.88,0-1.84.12-2.74s.37-1.87.58-2.81a3.91,3.91,0,0,0,.19-2.08C421.26,226.68,419.83,226.82,419.12,227Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "418.841px 231.53px"
    },
    id: "elcjj86444uqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.12,227a1,1,0,0,1,.23-.09,3.77,3.77,0,0,1,.72-.12,2.32,2.32,0,0,1,1.16.17,1,1,0,0,1,.52.56,1.78,1.78,0,0,1,.07.83c-.17,1.13-.57,2.38-.78,3.83a21,21,0,0,0-.07,2.29,3,3,0,0,1-.25,1.26,1.43,1.43,0,0,1-1.21.64,2.65,2.65,0,0,1-1.57-.5,3.21,3.21,0,0,1-1.05-1.15v0a5.94,5.94,0,0,1-1-3.58,5,5,0,0,1,1-2.78,3.82,3.82,0,0,1,.83-.76,3.17,3.17,0,0,1,.73-.42,2,2,0,0,1,.68-.2,6.87,6.87,0,0,1-.63.3,4.72,4.72,0,0,0-1.44,1.21,4.76,4.76,0,0,0-.9,2.66,5.63,5.63,0,0,0,1,3.38h0a2.8,2.8,0,0,0,2.32,1.47,1.11,1.11,0,0,0,.93-.47,3.06,3.06,0,0,0,.22-1.12,17.57,17.57,0,0,1,.09-2.31c.23-1.47.66-2.75.85-3.82a1.75,1.75,0,0,0,0-.73.91.91,0,0,0-.41-.47,2.25,2.25,0,0,0-1.06-.2C419.46,227,419.12,227.05,419.12,227Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "418.862px 231.573px"
    },
    id: "el7c5o36z4oa7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.08,
    y: 179.98,
    width: 23.48,
    height: 1.63,
    rx: 0.47,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "459.82px 180.795px"
    },
    id: "elh6yljows1cr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.08,
    y: 183.96,
    width: 23.48,
    height: 1.63,
    rx: 0.47,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "459.82px 184.775px"
    },
    id: "elv89eh6nqq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.08,
    y: 187.95,
    width: 13.24,
    height: 1.63,
    rx: 0.47,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "454.7px 188.765px"
    },
    id: "eljnn7tl4u11",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.74 74.41 63.82 92.42 62.92 93.56 40.85 75.42 40.74 74.41",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "52.28px 83.985px"
    },
    id: "el26gecnidvwn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.58 110.93 84.4 113.14 83.08 120.05 169.25 187.75 180.62 173.28 94.01 105.23 88.3 108.4 85.37 106.11 81.58 110.93",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "131.1px 146.49px"
    },
    id: "el3dwpx4e9ry9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,110.93a2.3,2.3,0,0,1,.21-.31l.69-.92L85.27,106l.08-.1.11.08,2.94,2.27-.19,0,5.7-3.2L94,105l.11.08c16.6,12.88,49.08,38.28,86.75,67.86l.35.28-.27.35-3.73,4.74L169.6,188l-.28.35-.35-.27c-39-30.67-71.63-56.44-86-67.91l-.08-.07,0-.1c.58-2.9,1-5.2,1.39-6.9l0,.1-2.11-1.73-.65-.56s.27.17.74.53,1.21.9,2.14,1.6l.05,0v.07c-.31,1.71-.73,4-1.25,6.92l-.06-.17c14.55,11.24,47.31,36.85,86.33,67.49l-.62.07,7.64-9.73c1.28-1.62,2.54-3.24,3.72-4.74l.08.63c-37.66-29.6-70-55.15-86.46-68.23l.23,0-5.73,3.13-.1,0-.09-.07-2.9-2.32.19,0-2.87,3.52-.75.91A2.05,2.05,0,0,1,81.58,110.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "131.365px 146.675px"
    },
    id: "eldt7f2l7uxor",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcsyzub4ukk"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.72,
    y: 169.89,
    width: 64.5,
    height: 16.75,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "171.97px 178.265px",
      transform: "rotate(-141.875deg)"
    },
    className: "animable",
    id: "elb3lcfybpnzw"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0i6h0pmphi1l"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.28,
    y: 185.13,
    width: 4.01,
    height: 25.02,
    rx: 0.81,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "196.285px 197.64px",
      transform: "rotate(-141.84deg)"
    },
    className: "animable",
    id: "elich695cwq3c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.34,186.7a2.25,2.25,0,0,1,2.71,0l1,.77a2.24,2.24,0,0,1,.37,3.15l-13.75,17.5a2.24,2.24,0,0,1-3.14.38l-1-.77a2.25,2.25,0,0,1-.38-3.15l13.75-17.5A2.49,2.49,0,0,1,201.34,186.7Zm1.65,1.4a.53.53,0,0,0-.74.08l-13.75,17.5a.54.54,0,0,0,.09.74l1,.77a.53.53,0,0,0,.74-.09l13.74-17.5a.53.53,0,0,0-.08-.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "196.289px 197.611px"
    },
    id: "elen5g6uifnf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3y4emymjyoc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.56,
    y: 174.06,
    width: 67.13,
    height: 4.49,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "169.125px 176.305px",
      transform: "rotate(-141.84deg)"
    },
    className: "animable",
    id: "el7tmbnca0lp"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144,152.6l54.14,42.53L194.27,200l-54.13-42.53Zm51.73,42.82L144.26,155l-1.71,2.18L194,197.6Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "169.14px 176.3px"
    },
    id: "elw6hqbbqvqak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.11 106.44 150.64 150.86 140.52 163.73 84.18 119.51 85.69 113.1 82.28 110.41 85.02 107.1 87.92 109.51 94.11 106.44",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "116.46px 135.085px"
    },
    id: "elbgj2jeks7pl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.43 166.5 139.89 163.72 140.79 158.03 144.77 152.96 149.97 150.34 153.78 153.33 143.43 166.5",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "146.835px 158.42px"
    },
    id: "el4d6vi4yuf8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.21,152.28l5.87-3,4.91,3.86L143.58,167.7,139,164.08l1-6.41Zm5.66-.93-4.54,2.29-3.72,4.74-.79,5,2.47,1.94,9.28-11.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "146.995px 158.49px"
    },
    id: "elf3alksyhpre",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxh2m0c2op6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.85,92h3.55a.77.77,0,0,1,.77.77v2.29a.77.77,0,0,1-.77.77H62.85a0,0,0,0,1,0,0V92a0,0,0,0,1,0,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "65.01px 93.915px",
      transform: "rotate(-141.85deg)"
    },
    className: "animable",
    id: "elar887ukuwd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7mnht2h3c0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174,164.38H176a.66.66,0,0,1,.66.66v30.78a.65.65,0,0,1-.65.65H174a.65.65,0,0,1-.65-.65V165a.65.65,0,0,1,.65-.65Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "175.005px 180.41px",
      transform: "rotate(-141.85deg)"
    },
    className: "animable",
    id: "elr2y0g88q75p"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.65,166.78a1.94,1.94,0,0,1,.94-.37,2,2,0,0,1,1.46.41l.79.62a2,2,0,0,1,.33,2.78l-18.43,23.47A2,2,0,0,1,165,194l-.79-.62a2,2,0,0,1-.33-2.79l18.44-23.47A1.9,1.9,0,0,1,182.65,166.78Zm-16.32,25.9.06-.05,18.43-23.47a.27.27,0,0,0,0-.37l-.79-.62a.31.31,0,0,0-.2-.06.28.28,0,0,0-.17.1l-18.44,23.47a.29.29,0,0,0,0,.37l.79.63A.27.27,0,0,0,166.33,192.68Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "175.023px 180.401px"
    },
    id: "elewpbgc0p51o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.32,150.08c.19.15-1.29,2.36-3.32,4.94s-3.82,4.54-4,4.39,1.29-2.37,3.32-4.94S151.12,149.92,151.32,150.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "147.661px 154.745px"
    },
    id: "elxj1qwzkqoui",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,156.14c.2.15-.79,1.74-2.21,3.54s-2.72,3.14-2.92,3,.8-1.74,2.22-3.54S158.84,156,159,156.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "156.435px 159.41px"
    },
    id: "elqadbzgw92n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.45,161.18c.19.15-1.29,2.37-3.31,4.94s-3.83,4.55-4,4.39,1.29-2.36,3.31-4.94S165.26,161,165.45,161.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "161.796px 165.844px"
    },
    id: "elr81ggwfujgm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.17,167.24c.19.16-.8,1.74-2.22,3.55s-2.72,3.14-2.91,3,.79-1.74,2.21-3.55S173,167.09,173.17,167.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "170.605px 170.514px"
    },
    id: "el22rcrqoehr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.34,138.31c.19.15-1.29,2.37-3.31,4.94s-3.83,4.55-4,4.39,1.29-2.36,3.31-4.94S136.15,138.16,136.34,138.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "132.686px 142.975px"
    },
    id: "ell5oc16sdv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.06,144.37c.19.16-.8,1.74-2.22,3.55s-2.72,3.14-2.91,3,.79-1.73,2.21-3.54S143.86,144.22,144.06,144.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "141.495px 147.644px"
    },
    id: "elrww4ycqwofl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.67,126c.2.15-1.29,2.37-3.31,4.94s-3.83,4.54-4,4.39,1.29-2.36,3.31-4.94S120.48,125.85,120.67,126Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "117.017px 130.665px"
    },
    id: "el47g4u4oggm6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.39,132.06c.19.16-.8,1.74-2.22,3.54s-2.72,3.15-2.91,3,.79-1.73,2.21-3.54S128.19,131.91,128.39,132.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "125.825px 135.33px"
    },
    id: "elx0rwi673069",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.24,113.88c.2.15-1.28,2.37-3.31,4.94s-3.82,4.54-4,4.39,1.29-2.36,3.32-4.94S105.05,113.73,105.24,113.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "101.587px 118.545px"
    },
    id: "elsd8em4txq7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,119.94c.2.16-.8,1.74-2.21,3.54s-2.72,3.15-2.92,3,.8-1.73,2.22-3.54S112.77,119.79,113,119.94Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "110.435px 123.21px"
    },
    id: "elnlm17en51ya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1lgy3318k08"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.93,
    y: 102.89,
    width: 2.19,
    height: 10.44,
    rx: 0.44,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "83.025px 108.11px",
      transform: "rotate(-141.84deg)"
    },
    className: "animable",
    id: "elh9odpreiukq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.4,111.46,64.93,97.93A1.4,1.4,0,0,1,64.75,96l2.15-2.73A1.41,1.41,0,0,1,68.81,93L85.3,104.51Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "74.873px 102.102px"
    },
    id: "el311jja3qvbx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.83,104.15c.2.15-.8,1.75-2.23,3.56s-2.75,3.17-2.94,3,.81-1.75,2.23-3.57S84.64,104,84.83,104.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "82.2462px 107.431px"
    },
    id: "elwx7183lu3jr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.25,105.78c.2.16-.74,1.68-2.1,3.41s-2.62,3-2.81,2.85.75-1.68,2.11-3.41S86.06,105.63,86.25,105.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "83.7962px 108.91px"
    },
    id: "elljutyzem2id",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.22,38.37C369.79,32.05,360,29.05,351,29.61c-8.58,0-17.33,3.8-22.33,10.77-3.14,4.37-4.06,8.59-4.07,14s.86,11.93,3.35,16.7a27.56,27.56,0,0,0,8.58,10.2c4.41,3,9.81,4.27,15.13,4.72,6.48.55,12.57-2,18.41-4.88,8.11-3.95,14.47-10.28,15.58-19.23S382.65,44.69,376.22,38.37Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "355.215px 57.8095px"
    },
    id: "el2cg0pp009xv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.22,38.37a4.09,4.09,0,0,1,.35.32c.23.23.58.55,1,1A35.64,35.64,0,0,1,381,43.9a29.48,29.48,0,0,1,3.84,7.68,23.86,23.86,0,0,1,.87,11.29A22.06,22.06,0,0,1,379.32,75a32.4,32.4,0,0,1-6.09,4.72,68,68,0,0,1-7.3,3.63,39.67,39.67,0,0,1-8.18,2.61,24.2,24.2,0,0,1-4.44.39,34.32,34.32,0,0,1-4.51-.39,32.71,32.71,0,0,1-8.94-2.5,22.73,22.73,0,0,1-7.66-5.68,31.13,31.13,0,0,1-5.15-8,34,34,0,0,1-2.28-9,49,49,0,0,1-.3-9,21.89,21.89,0,0,1,2.12-8.32A24.46,24.46,0,0,1,337.83,32.5a30.06,30.06,0,0,1,13.38-3.08,35.93,35.93,0,0,1,11.29,1.22,32.67,32.67,0,0,1,7.93,3.28,28.28,28.28,0,0,1,4.43,3.14c.46.41.79.75,1,1l.34.35-.37-.31c-.24-.2-.59-.53-1.06-.92a30.72,30.72,0,0,0-4.46-3,33.53,33.53,0,0,0-7.9-3.17,35.91,35.91,0,0,0-11.21-1.13A29.9,29.9,0,0,0,338,32.88a24.14,24.14,0,0,0-11,10.75,21.34,21.34,0,0,0-2,8.14,48,48,0,0,0,.31,8.85,33.75,33.75,0,0,0,2.24,8.85,30.61,30.61,0,0,0,5.07,7.91,22.08,22.08,0,0,0,7.49,5.56,32.13,32.13,0,0,0,8.79,2.46,35.53,35.53,0,0,0,4.45.4,24.15,24.15,0,0,0,4.34-.38,38.65,38.65,0,0,0,8.08-2.56A65.21,65.21,0,0,0,373,79.27a31.51,31.51,0,0,0,6-4.63,21.67,21.67,0,0,0,6.33-11.83,23.7,23.7,0,0,0-.79-11.14A29.63,29.63,0,0,0,380.83,44a39.35,39.35,0,0,0-3.33-4.26l-1-1C376.32,38.5,376.22,38.37,376.22,38.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "355.205px 57.8617px"
    },
    id: "eldvp0loc2she",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63,51.8a5.25,5.25,0,0,0-3-3.11,4.76,4.76,0,0,0-5.6-4.78,10.39,10.39,0,0,1-1.54.28l-.36-.08-.61-.17c-.33-.19-.63-.46-.94-.68A4.9,4.9,0,0,0,351,44a12.62,12.62,0,0,0-1.47.48,5.72,5.72,0,0,0-4.13.56c-1.24.77-1.83,3.43-1.49,4.79h0c-1.17.72-2.89,1.23-3.68,4.15a6,6,0,0,0,.95,4.79c.07.37-.1-.37,0,0-.85,2.13.67,4,.75,4.7.18,1.74,1.91,3.06,2.87,3.63a25.94,25.94,0,0,0,3.07,1.09c1.69.74,2.95,2.45,4.78,2.68,1.65.2,3.19-.88,4.84-1.06,1-.12,2.09.13,3.13.11a6.35,6.35,0,0,0,6-5.49l0-.06a6.27,6.27,0,0,0,2.57-8.23A5.25,5.25,0,0,0,369.63,51.8Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "354.995px 56.6072px"
    },
    id: "el3dtd572g0tu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.8,59c0,.06-.37-.09-.75-.51a3.41,3.41,0,0,1-.22-4.16c.34-.46.65-.64.69-.59a6,6,0,0,0-.77,2.68A6.05,6.05,0,0,0,346.8,59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "346.013px 56.3723px"
    },
    id: "elw0e9lykim0q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.17,61.28c-.08.12-.7-.32-.75-1.18s.49-1.37.58-1.26-.12.59-.06,1.23S347.27,61.17,347.17,61.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "346.804px 60.0623px"
    },
    id: "el2s4dqd33bm2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.33,62c.07,0,.06.44-.24,1.05a3.83,3.83,0,0,1-1.9,1.76,3.75,3.75,0,0,1-2.6.11c-.64-.21-.94-.51-.91-.56s.4.1,1,.2a4.19,4.19,0,0,0,2.31-.23,4.14,4.14,0,0,0,1.78-1.47C361.12,62.37,361.26,62,361.33,62Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "358.522px 63.5506px"
    },
    id: "elbc7qtpjum0u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.9,61c.07,0,.17.15.18.45a1.47,1.47,0,0,1-1.52,1.47c-.3,0-.46-.14-.44-.21s.67-.11,1.15-.58S362.76,61,362.9,61Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "362.099px 61.9604px"
    },
    id: "el91p1a3v27ys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.36,54.53a5.31,5.31,0,0,0-.45-2.52c-.73-1.24-2-1.47-2-1.61s.34-.11.85.05a3,3,0,0,1,1.59,1.29,3,3,0,0,1,.36,2C363.62,54.28,363.41,54.55,363.36,54.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "362.331px 52.4208px"
    },
    id: "elllio10mh2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.85,51c-.12.09-.56-.35-1.26-.47s-1.25.1-1.33,0,.51-.67,1.43-.49S357,51,356.85,51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "355.567px 50.5086px"
    },
    id: "elbw8wowo6rqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.1,59.45c.14,0,.29.59.83,1.06s1.12.57,1.12.71-.78.3-1.47-.33S352,59.43,352.1,59.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "353.038px 60.3985px"
    },
    id: "ela94xa5x7m88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.67,47c-.05.06-.34-.15-.83-.37a3.25,3.25,0,0,0-2-.23,2.49,2.49,0,0,0-1.55,1.18c-.26.46-.28.81-.36.81s-.19-.37,0-1a2.55,2.55,0,0,1,1.76-1.54,3,3,0,0,1,2.29.42C354.52,46.62,354.71,46.94,354.67,47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "352.25px 47.0848px"
    },
    id: "eljjux62wh2os",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.22,77.78c-1.33-1-3.18.44-4.84.27s-2.83-2.07-4.46-2.76c-1.85-.78-4,.14-6-.11-2.75-.36-4.67-2.82-6.27-5.09s-3.35-4.77-3.85-7.59a26.11,26.11,0,0,0-.57-3.54,3.24,3.24,0,0,0-2.43-2.37,2.44,2.44,0,0,0-2.42,2.72h0c1.15,6.66,4.18,13.14,9.21,17.66s12.2,6.85,18.79,5.33a5.22,5.22,0,0,0,2.92-1.51A2.17,2.17,0,0,0,359.22,77.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "344.116px 69.6769px"
    },
    id: "el3xye9wqalei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.87,35.31c3.06.68,6.18,1.38,8.86,3s4.94,4.28,7.81,5.8c.95.51,2.28.83,3,0a1.79,1.79,0,0,0,.29-1.69,4.24,4.24,0,0,0-.93-1.51c-3.6-4.2-9.09-6.18-14.34-7.89a6.26,6.26,0,0,0-2.51-.45,2.12,2.12,0,0,0-1.91,1.47",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "367.898px 38.5935px"
    },
    id: "ele8wfwtble1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.84,49a2.65,2.65,0,0,0-1.53-1.53l-.24.15a1.65,1.65,0,0,0-1.33.69,2.21,2.21,0,0,0-.4,1.46,2.06,2.06,0,0,0,1.07,1.75,1.79,1.79,0,0,0,2-.44A2.12,2.12,0,0,0,380.84,49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "379.14px 49.563px"
    },
    id: "elwtyqmh7onfl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,39a18.21,18.21,0,0,0-14.27,2.25A15,15,0,0,0,111.73,52a12,12,0,0,0,1.63,7.71,20.63,20.63,0,0,0,5.86,7.13,15,15,0,0,0,6.7,2.68,16.93,16.93,0,0,0,8.43-1.6c3.24-1.4,5.49-4.18,7.55-7,2.86-4,4.29-8.61,2.53-13.16S138.61,40.33,133.92,39Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "128.417px 53.9935px"
    },
    id: "elyced68qs88k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,39A17.08,17.08,0,0,1,141.45,43a12.87,12.87,0,0,1,3.33,5.19,12,12,0,0,1,.05,7.45,17.64,17.64,0,0,1-1.71,3.84,35.65,35.65,0,0,1-2.57,3.61,21.38,21.38,0,0,1-3.25,3.35A14.44,14.44,0,0,1,133,68.77a17.93,17.93,0,0,1-4.94,1.09,12.38,12.38,0,0,1-5.16-.76,17.35,17.35,0,0,1-4.55-2.55,18.81,18.81,0,0,1-3.4-3.75,26.21,26.21,0,0,1-2.43-4.21A12,12,0,0,1,111.39,54,13.38,13.38,0,0,1,114,45.89a16.3,16.3,0,0,1,5.65-4.9A19,19,0,0,1,130,38.25a12.4,12.4,0,0,1,3.9.7,8.46,8.46,0,0,1-1-.2,17.41,17.41,0,0,0-2.9-.29,19.15,19.15,0,0,0-10.19,2.85,16,16,0,0,0-5.48,4.83A13,13,0,0,0,111.87,54c.08,3,1.66,5.84,3.49,8.5a18.07,18.07,0,0,0,3.31,3.63,16.79,16.79,0,0,0,4.4,2.47,12,12,0,0,0,5,.74,17.68,17.68,0,0,0,4.8-1.06A13.79,13.79,0,0,0,137,66.07a20.89,20.89,0,0,0,3.19-3.26,35.42,35.42,0,0,0,2.55-3.55,17.38,17.38,0,0,0,1.69-3.72,11.67,11.67,0,0,0,0-7.21,12.75,12.75,0,0,0-3.18-5.1,15.93,15.93,0,0,0-3.71-2.71,21.43,21.43,0,0,0-2.66-1.21l-.72-.25A.86.86,0,0,1,133.92,39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "128.394px 54.0651px"
    },
    id: "elebeyhp6klbd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.2,47.05a2.88,2.88,0,0,0-2.23-.72,2.58,2.58,0,0,0-3.9-.85,5.38,5.38,0,0,1-.66.52l-.2.06-.33.07a6.17,6.17,0,0,1-.62-.08,2.64,2.64,0,0,0-2.06.58,2.69,2.69,0,0,0-.9,1.43,8.21,8.21,0,0,0-.58.6A3.11,3.11,0,0,0,120.89,50a2.87,2.87,0,0,0,.51,2.66h0a3.29,3.29,0,0,0-.7,2.93,3.24,3.24,0,0,0,1.68,2c.13.16-.14-.15,0,0,.14,1.24,1.33,1.73,1.56,2.06a3,3,0,0,0,2.29,1,15.08,15.08,0,0,0,1.75-.26c1-.08,2,.42,3,.06s1.3-1.24,2.05-1.75c.46-.32,1-.46,1.52-.74A3.42,3.42,0,0,0,136,53.84v0a3.4,3.4,0,0,0-.87-4.59A2.86,2.86,0,0,0,134.2,47.05Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "128.571px 52.7865px"
    },
    id: "els1332rp424",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14,56.33c0,.07-.21.11-.52,0a1.75,1.75,0,0,1-1-.78,1.79,1.79,0,0,1-.24-1.23c.06-.32.2-.48.26-.46s0,.75.42,1.42S125.17,56.19,125.14,56.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "124.248px 55.1283px"
    },
    id: "el7ta1vbwa43",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.89,57.31c0,.14-.49.13-.76-.31s-.08-.86.06-.82.21.3.38.55S125.92,57.16,125.89,57.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "125.443px 56.7836px"
    },
    id: "eljkq2m1gdwjp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.84,54.05c.07,0,.2.18.24.56a2,2,0,0,1-.45,1.4,2,2,0,0,1-1.29.72c-.38,0-.6,0-.6-.12s.88-.19,1.48-.93S132.7,54.07,132.84,54.05Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "131.912px 55.39px"
    },
    id: "elftqod6je4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.33,53.17c.09-.12.55.22.37.82s-.78.6-.78.45.21-.33.29-.61S133.23,53.26,133.33,53.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "133.331px 53.8347px"
    },
    id: "el3nyuh70hoad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.9,50c-.14,0-.31-.62-.92-1s-1.25-.23-1.3-.37.12-.2.41-.27a1.54,1.54,0,0,1,1.16.19,1.56,1.56,0,0,1,.71.94C132,49.76,132,50,131.9,50Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "130.828px 49.1599px"
    },
    id: "el8j85y6k043x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.89,49.93c-.07.13-.37.11-.68.21s-.55.28-.68.22,0-.55.52-.71S128,49.82,127.89,49.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "127.195px 49.9895px"
    },
    id: "elousqvbh2hri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.78,55.18c.13-.07.37.1.69.17s.61,0,.69.18-.27.47-.82.33S127.64,55.23,127.78,55.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "128.451px 55.5302px"
    },
    id: "el5nt11czp3b7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83,48.57c0,.14-.83,0-1.43.52A1.41,1.41,0,0,0,124,50c0,.26,0,.44,0,.48s-.24-.1-.32-.46a1.42,1.42,0,0,1,.46-1.28,1.62,1.62,0,0,1,1.27-.38C125.67,48.37,125.84,48.5,125.83,48.57Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "124.747px 49.4164px"
    },
    id: "eleni01sklbob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.86,62.12c-.89-.14-1.41,1-2.25,1.36s-1.88-.27-2.83-.18-1.87,1.08-2.88,1.47c-1.41.53-3-.16-4.3-.83a10.52,10.52,0,0,1-3.77-2.65,14.61,14.61,0,0,0-1.18-1.54,1.73,1.73,0,0,0-1.76-.51,1.32,1.32,0,0,0-.47,1.91h0a16.67,16.67,0,0,0,8.91,6.09A11.67,11.67,0,0,0,135.66,65a2.79,2.79,0,0,0,1-1.47A1.18,1.18,0,0,0,135.86,62.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "126.442px 63.3981px"
    },
    id: "elyw2ns6qqjvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.37,42.17a15.37,15.37,0,0,1,5-.82c1.76.09,3.45.78,5.21.77.59,0,1.31-.18,1.44-.75a1,1,0,0,0-.29-.88,2.4,2.4,0,0,0-.83-.49c-2.79-1.09-5.92-.63-8.87-.11a3.38,3.38,0,0,0-1.31.43,1.17,1.17,0,0,0-.54,1.19",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "130.099px 40.7522px"
    },
    id: "eljnsyftpohvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.84,42.86a1.38,1.38,0,0,0-1.12-.34l-.08.13a.92.92,0,0,0-.45.67,1.15,1.15,0,0,0,.18.8,1.11,1.11,0,0,0,.95.56,1,1,0,0,0,.87-.73A1.15,1.15,0,0,0,138.84,42.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "138.197px 43.5929px"
    },
    id: "el00u2pmdrezjt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.35,108.51c-9.2-3-14.71-11.41-12.3-18.79s11.81-10.92,21-7.92,14.7,11.41,12.3,18.79S448.54,111.51,439.35,108.51Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "443.698px 95.155px"
    },
    id: "el55jwrjo7pcr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.38,95.39a11.89,11.89,0,0,0,6.13,6.34,15.21,15.21,0,0,0,8.61,1.55c1.08-.13,2.3-.55,2.45-1.52s-.74-1.71-1.69-2a8.73,8.73,0,0,0-2.93-.14,12.43,12.43,0,0,1-4.8-.64,6.33,6.33,0,0,1-3.58-3c-.44-.94-.6-2.08-1.52-2.68a2,2,0,0,0-2.15,0,1.81,1.81,0,0,0-.52,2.09",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "441.914px 98.1823px"
    },
    id: "elgy46ana1638",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellr8iu1kqlqh"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "447.085px 89.2791px"
    },
    className: "animable",
    id: "el5u5r418u2dy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.84,92.18a5.43,5.43,0,0,0,3,1.48A1.82,1.82,0,0,0,453.92,92v0a4.55,4.55,0,0,0-.53-1.54c-1.82-3.21-5.55-5-9.54-5.5a5.25,5.25,0,0,0-2.13.06,1.94,1.94,0,0,0-1.42,1.26c-.31,1.13.88,2.27,2.12,2.76s2.61.59,3.79,1.18A13.29,13.29,0,0,1,448.84,92.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "447.085px 89.2791px"
    },
    id: "el2ia0jwdtwab",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M454.35,99.53a3.28,3.28,0,0,1-.74,1,9.1,9.1,0,0,1-2.82,2,13.83,13.83,0,0,1-11.21-.27,11.29,11.29,0,0,1-4.9-4,9.89,9.89,0,0,1-1.92-4.79,7,7,0,0,1,.54-3.44,5.85,5.85,0,0,1,.42-.84c.12-.18.18-.27.2-.26a7.06,7.06,0,0,1-.39,1.19,7.61,7.61,0,0,0-.31,3.3,9.76,9.76,0,0,0,1.94,4.5,11.21,11.21,0,0,0,4.68,3.73,13.87,13.87,0,0,0,10.76.44A12.51,12.51,0,0,0,454.35,99.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "443.539px 96.2577px"
    },
    id: "elgj0wouhqr2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.15,104.36a18.5,18.5,0,0,1,2.09-.52,12.31,12.31,0,0,0,4.52-2.3,10.23,10.23,0,0,0,3-4.06c.49-1.22.59-2,.7-2a4.26,4.26,0,0,1-.27,2.19,9.34,9.34,0,0,1-3,4.41,10.63,10.63,0,0,1-4.83,2.24A4.56,4.56,0,0,1,447.15,104.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "452.326px 99.9783px"
    },
    id: "elxitoyxg7t4o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441,103.59c.08-.16.87,0,1.84.31s1.76.48,1.74.66-.88.24-1.91,0S440.87,103.75,441,103.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "442.783px 104.123px"
    },
    id: "el508x7tvp6iq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.05,83.9c-.05-.15,3.08-.56,6.62.78s5.66,3.65,5.52,3.74-2.33-1.9-5.75-3.13S441,84.1,441.05,83.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "447.123px 86.0725px"
    },
    id: "eluqda11ovj4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,57.14c-7.79,2.88-16,.15-18.29-6.09s2.13-13.65,9.92-16.53,16-.15,18.29,6.09S302.81,54.26,295,57.14Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "290.816px 45.83px"
    },
    id: "el1uf1h475vrh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,51.49a10.2,10.2,0,0,0,7.51,1,13.12,13.12,0,0,0,6.61-3.55c.65-.66,1.25-1.59.84-2.32a1.82,1.82,0,0,0-2.21-.45,7.53,7.53,0,0,0-2,1.46,10.54,10.54,0,0,1-3.57,2.13,5.47,5.47,0,0,1-4-.12c-.8-.4-1.51-1.08-2.45-1a1.69,1.69,0,0,0-1.44,1.16,1.55,1.55,0,0,0,.77,1.68",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "291.175px 49.3886px"
    },
    id: "eltmxp6aq8wl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldpioxu9ty5g"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "289.995px 39.7096px"
    },
    className: "animable",
    id: "eljcvb7e42sbc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.71,41.09a4.82,4.82,0,0,0,2.78-.57,1.58,1.58,0,0,0,.53-2.28l0,0a3.78,3.78,0,0,0-1.19-.76c-2.93-1.18-6.38-.39-9.35,1.39A4.39,4.39,0,0,0,284.07,40a1.68,1.68,0,0,0-.29,1.61c.39.92,1.8,1.06,2.89.72s2.08-1,3.19-1.22A11.33,11.33,0,0,1,292.71,41.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "289.995px 39.7096px"
    },
    id: "els3cr0kw4xpp",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M300.34,43.1a2.89,2.89,0,0,1,0,1.09,7.51,7.51,0,0,1-.81,2.87,11.88,11.88,0,0,1-7.69,5.79,9.75,9.75,0,0,1-5.42-.06,8.53,8.53,0,0,1-3.84-2.21A6.12,6.12,0,0,1,281.15,48a4.43,4.43,0,0,1-.16-.8c0-.18,0-.28,0-.28a8.37,8.37,0,0,1,.37,1,6.62,6.62,0,0,0,1.55,2.39,8.43,8.43,0,0,0,3.7,2,9.53,9.53,0,0,0,5.14,0,11.94,11.94,0,0,0,7.48-5.43A11.11,11.11,0,0,0,300.34,43.1Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "290.691px 48.1524px"
    },
    id: "elkv3wk0zv3ap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.06,50.19c-.05-.06.46-.55,1.13-1.47A10.38,10.38,0,0,0,301,44.77a8.87,8.87,0,0,0-.17-4.31c-.33-1.08-.7-1.7-.62-1.75a3.76,3.76,0,0,1,1,1.62,8.09,8.09,0,0,1,.34,4.56A9.18,9.18,0,0,1,299.5,49,4.1,4.1,0,0,1,298.06,50.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "299.894px 44.45px"
    },
    id: "elm5gyuidvoxe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.48,53c0-.16.62-.43,1.4-.78s1.44-.61,1.53-.48-.47.64-1.31,1S293.51,53.12,293.48,53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "294.95px 52.386px"
    },
    id: "elxyldal1rvjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.05,39.68a12.11,12.11,0,0,1,10.59-3.44,29,29,0,0,0-5.54,1A29.45,29.45,0,0,0,283.05,39.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "288.345px 37.8791px"
    },
    id: "el0z35yzm5tacn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,395.28c-6.6,5.1-15.27,5-19.36-.34s-2.06-13.72,4.54-18.82,15.26-5,19.36.33S54.62,390.17,48,395.28Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "40.5946px 385.699px"
    },
    id: "el7v753xt51dj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.77,393.17a10.24,10.24,0,0,0,7.5-1.3,13.11,13.11,0,0,0,5.28-5.39c.42-.83.72-1.9.1-2.48a1.84,1.84,0,0,0-2.25.23,7.75,7.75,0,0,0-1.53,2,10.63,10.63,0,0,1-2.78,3.12,5.53,5.53,0,0,1-3.88,1.09c-.88-.14-1.77-.58-2.64-.21a1.71,1.71,0,0,0-1,1.54,1.55,1.55,0,0,0,1.24,1.38",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "41.7869px 388.556px"
    },
    id: "el5bb49a5rojg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt261saieqzn"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "38.1128px 380.362px"
    },
    className: "animable",
    id: "el9vcst9qsn3a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,380.59a4.72,4.72,0,0,0,2.49-1.39,1.59,1.59,0,0,0-.17-2.34h0a3.81,3.81,0,0,0-1.36-.37c-3.16-.25-6.23,1.55-8.54,4.14a4.46,4.46,0,0,0-1,1.54,1.7,1.7,0,0,0,.21,1.63c.66.77,2.05.47,3-.18s1.69-1.57,2.69-2.13A11.71,11.71,0,0,1,41,380.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "38.1128px 380.362px"
    },
    id: "elflgmt4wqab",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M48.89,380.22a2.81,2.81,0,0,1,.38,1,7.91,7.91,0,0,1,.08,3,11.92,11.92,0,0,1-5.63,7.86,9.8,9.8,0,0,1-5.21,1.57,8.52,8.52,0,0,1-4.35-1,6.16,6.16,0,0,1-2.19-2,4.17,4.17,0,0,1-.39-.72q-.12-.25-.09-.27a9.66,9.66,0,0,1,.66.86,6.44,6.44,0,0,0,2.2,1.82,8.45,8.45,0,0,0,4.14.8,9.54,9.54,0,0,0,4.93-1.53A12,12,0,0,0,49,384.18,10.92,10.92,0,0,0,48.89,380.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "40.4702px 386.938px"
    },
    id: "elllpng6tozw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.85,387.7a14.84,14.84,0,0,1,.63-1.75,10.45,10.45,0,0,0,.56-4.33,8.81,8.81,0,0,0-1.46-4.08c-.64-.94-1.18-1.42-1.12-1.49s.68.33,1.43,1.25a8,8,0,0,1,1.7,4.27,9.14,9.14,0,0,1-.74,4.53A4,4,0,0,1,48.85,387.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "49.042px 381.871px"
    },
    id: "elix6czfp20pp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.29,391.75c-.08-.14.46-.6,1.11-1.16s1.2-1,1.32-.93-.26.75-.95,1.35S45.37,391.88,45.29,391.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "46.512px 390.717px"
    },
    id: "el4lfk9lwi2g2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3,382.14a10,10,0,0,1,3.76-4.35,10.1,10.1,0,0,1,5.35-2.13,29.57,29.57,0,0,0-5,2.59A29.11,29.11,0,0,0,31.3,382.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "35.855px 378.9px"
    },
    id: "elbigf7s39alc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.32,158.86c-7.82-.13-14.07-5.31-14-11.58S49.87,136,57.68,136.17s14.07,5.3,14,11.57S65.13,159,57.32,158.86Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "57.5px 147.514px"
    },
    id: "el08tnsb0z34kc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.59,150.15a9.62,9.62,0,0,0,6.24,3.44,12.44,12.44,0,0,0,7-.86c.79-.36,1.64-1,1.52-1.76s-1-1.14-1.78-1.14a7.14,7.14,0,0,0-2.3.58,10.07,10.07,0,0,1-3.85.66A5.16,5.16,0,0,1,53,149.59c-.56-.62-1-1.46-1.81-1.7a1.61,1.61,0,0,0-1.66.52,1.46,1.46,0,0,0,.1,1.74",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "56.8254px 150.796px"
    },
    id: "ellg3gya1ng4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldph7bonycqk"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "58.7114px 141.929px"
    },
    className: "animable",
    id: "elzqwkcdi69hq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.76,144a4.47,4.47,0,0,0,2.63.44,1.47,1.47,0,0,0,1.24-1.81v0a3.68,3.68,0,0,0-.78-1.07c-2.17-2-5.47-2.51-8.68-2a4.28,4.28,0,0,0-1.62.56,1.57,1.57,0,0,0-.8,1.31c0,.94,1.22,1.54,2.29,1.62s2.16-.16,3.22,0A10.87,10.87,0,0,1,60.76,144Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "58.7114px 141.929px"
    },
    id: "elhhp0qwq3i1j",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M66.76,148.35a2.63,2.63,0,0,1-.33,1,7.37,7.37,0,0,1-1.69,2.24A11.14,11.14,0,0,1,56,154a9.12,9.12,0,0,1-4.73-1.9,8,8,0,0,1-2.62-3.24,5.72,5.72,0,0,1-.4-2.78,3.33,3.33,0,0,1,.13-.75c0-.17.07-.26.09-.25a7.09,7.09,0,0,1,0,1,6.06,6.06,0,0,0,.54,2.62,8,8,0,0,0,2.57,3,8.9,8.9,0,0,0,4.5,1.76,11.22,11.22,0,0,0,8.42-2.22A10.1,10.1,0,0,0,66.76,148.35Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "57.4892px 149.602px"
    },
    id: "elbilfop5aw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.35,153.8a13.27,13.27,0,0,1,1.49-.91A9.87,9.87,0,0,0,66.78,150a8.23,8.23,0,0,0,1.32-3.84c.09-1.06,0-1.72.05-1.74a3.39,3.39,0,0,1,.32,1.75,7.56,7.56,0,0,1-1.25,4.12A8.71,8.71,0,0,1,64,153.21,3.85,3.85,0,0,1,62.35,153.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "65.4161px 149.11px"
    },
    id: "el3g6ajuf3zpn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.39,154.68c0-.15.68-.17,1.49-.2s1.47,0,1.5.09-.62.4-1.48.43S57.36,154.82,57.39,154.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "58.885px 154.736px"
    },
    id: "el8g1xxp4cz6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.77,139.46a9.45,9.45,0,0,1,5.3-1,9.4,9.4,0,0,1,5.15,1.57A27.24,27.24,0,0,0,58,139,28.74,28.74,0,0,0,52.77,139.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "57.995px 139.22px"
    },
    id: "el2vta6n6413c",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-219",
    className: "animable",
    style: {
      transformOrigin: "250px 467.88px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.53,467.88c0,.15-101,.26-225.52.26S24.47,468,24.47,467.88s101-.26,225.54-.26S475.53,467.74,475.53,467.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250px 467.88px"
    },
    id: "elcwd69lw9e8",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-219",
    className: "animable",
    style: {
      transformOrigin: "394.196px 407.533px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.79,386.46a33.58,33.58,0,1,1,49,41h0a33.57,33.57,0,0,1-49-41Zm60.11,24.45a31.3,31.3,0,1,0-12.28,14.69A31.29,31.29,0,0,0,446.9,410.91Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "417.926px 399.03px"
    },
    id: "el27mvnm2i577",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.79,386.46a33.58,33.58,0,1,1,49,41h0a33.57,33.57,0,0,1-49-41Zm60.11,24.45a31.3,31.3,0,1,0-12.28,14.69A31.29,31.29,0,0,0,446.9,410.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "417.926px 399.03px"
    },
    id: "el8l1ymw0ixno",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.28,384.72a33.58,33.58,0,1,1,49,41h0a33.57,33.57,0,0,1-49-41Zm60.12,24.45a31.32,31.32,0,1,0-12.29,14.69A31.34,31.34,0,0,0,446.4,409.17Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "417.416px 397.29px"
    },
    id: "el3dp2x5i6e0x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.15,449.74l-.84-1.23a2.41,2.41,0,0,1,.31-3.11l51.71-31.24,3.92,5.78-51.67,31.21C340.67,451.71,339.1,451.15,338.15,449.74Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "365.065px 432.762px"
    },
    id: "elidqvfab2gkn",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cell--inject-219",
    className: "animable",
    style: {
      transformOrigin: "417.875px 400.118px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.75,414.81c-8.93.53-16.56-5.62-17-13.73S408.08,386,417,385.43s16.55,5.62,17,13.73S427.68,414.28,418.75,414.81Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "417.875px 400.118px"
    },
    id: "el1sssfqils3ch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3z4v502odvp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "417.348px 404.71px"
    },
    className: "animable",
    id: "eldrlut9wm54f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.1,404.23a10.58,10.58,0,0,0,7.45,3.9,12.73,12.73,0,0,0,7.93-1.73c.87-.54,1.77-1.4,1.57-2.41a2,2,0,0,0-2.14-1.32,7.23,7.23,0,0,0-2.57,1,10.1,10.1,0,0,1-4.34,1.18,5.53,5.53,0,0,1-4.11-1.6c-.7-.75-1.23-1.8-2.22-2a1.71,1.71,0,0,0-1.84.83,2.05,2.05,0,0,0,.27,2.23",
    id: "el9e91w9cques",
    className: "animable",
    style: {
      transformOrigin: "417.348px 404.71px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elpiqr4xx17q"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "418.759px 392.641px"
    },
    className: "animable",
    id: "eliddjkpqcjhq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.26,395.28a4.62,4.62,0,0,0,3.05.34,1.94,1.94,0,0,0,1.24-2.46l0,0a4.71,4.71,0,0,0-1-1.32c-2.67-2.44-6.48-2.76-10.08-1.78a4.74,4.74,0,0,0-1.81.86,2.15,2.15,0,0,0-.79,1.77c.13,1.22,1.55,1.89,2.78,1.9a32.35,32.35,0,0,1,3.66-.27A11.34,11.34,0,0,1,421.26,395.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "418.759px 392.641px"
    },
    id: "elqejkp2n2qu",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M428.53,400.39a1.21,1.21,0,0,1-.06.31,8.94,8.94,0,0,1-.25.88,9.86,9.86,0,0,1-1.65,2.92,10.53,10.53,0,0,1-4,3,12.49,12.49,0,0,1-6,1,10.25,10.25,0,0,1-3.1-.72,10.07,10.07,0,0,1-2.53-1.52,9.67,9.67,0,0,1-3.06-3.92,8.48,8.48,0,0,1-.63-3.3,6.81,6.81,0,0,1,.05-.91,1.8,1.8,0,0,1,.05-.31s0,.44,0,1.22a9,9,0,0,0,.72,3.21,9.56,9.56,0,0,0,3,3.77,10.09,10.09,0,0,0,2.47,1.47,9.88,9.88,0,0,0,3,.69,12.54,12.54,0,0,0,5.86-1,10.53,10.53,0,0,0,3.93-2.85,10,10,0,0,0,1.71-2.82C428.39,400.8,428.49,400.38,428.53,400.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "417.89px 403.18px"
    },
    id: "el7tbrv9gsy2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,407.83c0-.06.73-.43,1.76-1.28a11.58,11.58,0,0,0,3.16-4.08,11.76,11.76,0,0,0,1-5.07c0-1.34-.25-2.15-.2-2.16a1.61,1.61,0,0,1,.19.56,9.86,9.86,0,0,1,.24,1.59,10.83,10.83,0,0,1-4.25,9.34,9.58,9.58,0,0,1-1.36.87A2.39,2.39,0,0,1,424,407.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "427.087px 401.535px"
    },
    id: "eluuw7w7sd2e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.43,409.4a8.86,8.86,0,0,1,1.7-.21,8.37,8.37,0,0,1,1.71-.19,3.27,3.27,0,0,1-1.67.51A3.16,3.16,0,0,1,418.43,409.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "420.135px 409.292px"
    },
    id: "el84qva5qzlkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.71,390.13s.14-.11.42-.26a11.07,11.07,0,0,1,1.23-.53,13.5,13.5,0,0,1,8.67-.11,10,10,0,0,1,1.24.49,1.54,1.54,0,0,1,.43.25s-.66-.23-1.73-.52a15.13,15.13,0,0,0-8.54.11C412.36,389.88,411.74,390.18,411.71,390.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "417.705px 389.352px"
    },
    id: "ely8d2slf15j",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Microscope--inject-219",
    className: "animable",
    style: {
      transformOrigin: "90.2341px 366.732px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "63.69 315.65 52.37 316.97 50.57 319.24 51.49 326.33 53.88 328.16 64.77 326.16 63.69 315.65",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "57.67px 321.905px"
    },
    id: "el0f6gjlvo4yfq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.48,316.88a33.57,33.57,0,0,0,.55,5.46,34.17,34.17,0,0,0,1,5.4,32.84,32.84,0,0,0-.54-5.46A35.13,35.13,0,0,0,52.48,316.88Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "53.255px 322.31px"
    },
    id: "elv81ha2vixp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,327.79a34.91,34.91,0,0,0-.65-5.51A34.9,34.9,0,0,0,54,316.83a69,69,0,0,0,1.74,11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "54.875px 322.33px"
    },
    id: "el5no2p6qkyep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6,333.42c0,.65-7.24,11-7.24,11H60.73l-2.55-1.86-1.12-6.42L65,325.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "65.83px 335.145px"
    },
    id: "el85ec13vfxwt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,336.14a10.23,10.23,0,0,0,1.56,1.18c1,.7,2.3,1.69,3.72,2.85,2.85,2.32,5,4.39,5.09,4.3a7.49,7.49,0,0,0-1.3-1.47,44.64,44.64,0,0,0-3.51-3.17,37.83,37.83,0,0,0-3.83-2.77A7.25,7.25,0,0,0,57.06,336.14Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "62.245px 340.306px"
    },
    id: "elhdiat0z8gh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.83,335.14c-.06.13,2.63,1.4,5.46,3.7A49.37,49.37,0,0,1,68,343.45a6.35,6.35,0,0,0-1.08-1.63,22.82,22.82,0,0,0-3.35-3.32,24.81,24.81,0,0,0-3.94-2.6A7,7,0,0,0,57.83,335.14Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "62.9145px 339.295px"
    },
    id: "elmaem9s1fqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.29,
    y: 332.47,
    width: 12.16,
    height: 16.59,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "81.37px 340.765px"
    },
    id: "elcoct7ut4n48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.12,347.18a39.73,39.73,0,0,0,6.06.23,39.62,39.62,0,0,0,6.06-.23,42.15,42.15,0,0,0-6.06-.22A42.26,42.26,0,0,0,75.12,347.18Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "81.18px 347.186px"
    },
    id: "elxr724l8p85m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,345.69a42.15,42.15,0,0,0,6.06.22,42.26,42.26,0,0,0,6.06-.22,42.26,42.26,0,0,0-6.06-.22A42.15,42.15,0,0,0,75,345.69Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "81.06px 345.69px"
    },
    id: "eljkylhk0bmje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.46,327.81a16.71,16.71,0,0,1-30.37-12.08l6.42,4.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "78.1569px 325.485px"
    },
    id: "el71ajavt5d3w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.29,395.07H107.93v-16H73.52A4.07,4.07,0,0,1,69.45,375h0a4.07,4.07,0,0,1,4.07-4.07H93.59v-5.49H57.38a3.94,3.94,0,0,1-3.94-3.95h0a3.93,3.93,0,0,1,3.94-3.94h59.87v6.21h6.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "88.865px 376.31px"
    },
    id: "elkrfh68ajnt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25,357.55c0,12.58,0,24.94,0,37.52",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "117.25px 376.31px"
    },
    id: "ellzyyp0wg2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.3,395.07c.12,0,.21-8.4.2-18.76s-.12-18.76-.25-18.76-.21,8.4-.2,18.76S117.17,395.07,117.3,395.07Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "117.275px 376.31px"
    },
    id: "elzpepi9no6kd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,358.1c-.13,0-.23,4.74-.23,10.58s.1,10.59.23,10.59.22-4.74.22-10.59S108.11,358.1,108,358.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "107.995px 368.685px"
    },
    id: "elzalslnemqsl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.44,426.88A20.47,20.47,0,0,1,70,412.54h54.43l1.2,15.29Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "89.535px 420.185px"
    },
    id: "elp71qsrv8rh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.06,390.78V329a4.3,4.3,0,0,0-3.31-4.18L98.58,310.27,98.08,290l-30.58-.51L58,280.82,43.1,297.87h0l19.82,21.6,60.73,18.84,1,88.57H53.58A3.13,3.13,0,0,0,50.45,430v11.58H153.06Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "98.08px 361.2px"
    },
    id: "elxydebj6852l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.64,
    y: 352.17,
    width: 33.03,
    height: 5.38,
    rx: 2.6,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "76.155px 354.86px"
    },
    id: "elumej4wn5fs8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.24,357.55s-.26,0-.71-.15a2.58,2.58,0,0,1-1.78-2.73,2.5,2.5,0,0,1,2.41-2.36h2.33l25.58.07a2.39,2.39,0,0,1,2.35,2,2.74,2.74,0,0,1-.24,1.63,2.41,2.41,0,0,1-1.17,1.1,3.83,3.83,0,0,1-1.64.19h-5l-11.5.05-7.75.07-2.11,0a4.14,4.14,0,0,0-.73.05,5.15,5.15,0,0,0,.73,0l2.11.05,7.75.07,11.5,0h5a4.24,4.24,0,0,0,1.81-.22,2.9,2.9,0,0,0,1.39-1.29,3.2,3.2,0,0,0,.28-1.9,2.83,2.83,0,0,0-2.78-2.41L64.49,352l-2.34,0a2.75,2.75,0,0,0-1.93.91,2.65,2.65,0,0,0-.68,1.72,2.84,2.84,0,0,0,.31,1.52,2.66,2.66,0,0,0,1.65,1.31A2,2,0,0,0,62.24,357.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.211px 354.69px"
    },
    id: "elf33vbu1vkvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,390.26a15.86,15.86,0,1,0,15.85-15.86A15.85,15.85,0,0,0,123,390.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "138.86px 390.26px"
    },
    id: "elho3okjifeh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.05,390.77a17.27,17.27,0,0,1,.36-2.13,8.77,8.77,0,0,1,3.21-4.74,8.61,8.61,0,0,1,8.17-1.21,8.21,8.21,0,0,1,2.17,1.18,7.87,7.87,0,0,1,1.81,1.83,8.55,8.55,0,0,1,0,10.15,8.06,8.06,0,0,1-1.81,1.83,7.9,7.9,0,0,1-2.17,1.17,8.67,8.67,0,0,1-4.53.39,8.52,8.52,0,0,1-3.64-1.59,8.75,8.75,0,0,1-3.21-4.75,16.62,16.62,0,0,1-.36-2.13,6.85,6.85,0,0,0,.19,2.17,8.76,8.76,0,0,0,3.19,5,9,9,0,0,0,3.76,1.71,9.1,9.1,0,0,0,4.73-.37,9,9,0,0,0,4.2-3.13,9,9,0,0,0,0-10.67,8.44,8.44,0,0,0-1.91-1.91,8.17,8.17,0,0,0-2.29-1.22,9,9,0,0,0-4.72-.37,8.89,8.89,0,0,0-7,6.66A6.86,6.86,0,0,0,130.05,390.77Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "138.948px 390.814px"
    },
    id: "elq2iyt3s9son",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.87 283.12 44.69 302.89 38.34 296.39 56.39 277.14 62.87 283.12",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "50.605px 290.015px"
    },
    id: "elaxbcfds6l2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.18,265.56l8.3,7.91a1.42,1.42,0,0,1,.05,2L36.47,283a1.42,1.42,0,0,1-2,0L26,274.7a1.42,1.42,0,0,1,0-2l7.16-7.1A1.41,1.41,0,0,1,35.18,265.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "34.7528px 274.283px"
    },
    id: "elpmf5s4pzybd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8,275.15c.21.3,9.3,9.12,9.3,9.12l-7.21,7.38-9.15-9.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "43.92px 283.4px"
    },
    id: "eldnu3opgt9yu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.28 446.27 151.24 446.27 154.88 441.59 41.28 441.59 41.28 446.27",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.08px 443.93px"
    },
    id: "elwk3ll7ocwa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7jclkvo61z"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.04,
    y: 399.58,
    width: 28.04,
    height: 12.95,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "84.06px 406.055px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elbxwzkbgg8qa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,412.54a93.2,93.2,0,0,0,0-12.8,89.16,89.16,0,0,0,0,12.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "95.045px 406.14px"
    },
    id: "elmh4a684mwyi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.35,412.54a89.16,89.16,0,0,0,0-12.8,93.2,93.2,0,0,0,0,12.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "90.355px 406.14px"
    },
    id: "elo1o5djiczvh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.66,412.54a89.16,89.16,0,0,0,0-12.8,93.2,93.2,0,0,0,0,12.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "85.665px 406.14px"
    },
    id: "el3bug7iw3ebp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,412.54a89.16,89.16,0,0,0,0-12.8,93.2,93.2,0,0,0,0,12.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "81.005px 406.14px"
    },
    id: "el4p278rlhqw3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.28,412.54a93.2,93.2,0,0,0,0-12.8,93.2,93.2,0,0,0,0,12.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.28px 406.14px"
    },
    id: "els2stpd8woxf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.59,412.54a93.2,93.2,0,0,0,0-12.8,93.2,93.2,0,0,0,0,12.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "71.59px 406.14px"
    },
    id: "elos46arqymuo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.24 446.27 28.25 446.27 28.25 468.31 132.01 467.17 151.24 446.27",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.745px 457.29px"
    },
    id: "elvrxk1a3bmig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3,457.26c0-.13,25.2-.24,56.28-.24s56.27.11,56.27.24-25.19.24-56.27.24S29.3,457.4,29.3,457.26Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "85.575px 457.26px"
    },
    id: "elkougpqvcld",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--DNA--inject-219",
    className: "animable",
    style: {
      transformOrigin: "348.612px 186.697px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.45,131l-8.86-16.45-11.38-.21s14.34,18.62,13.31,26.51l7.72-4.71Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "399.725px 127.595px"
    },
    id: "el3eyqmhmcuy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6b4743i2f8v"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "399.725px 127.595px"
    },
    className: "animable",
    id: "elrd7epwk72aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.45,131l-8.86-16.45-11.38-.21s14.34,18.62,13.31,26.51l7.72-4.71Z",
    id: "el4v0w20cknq8",
    className: "animable",
    style: {
      transformOrigin: "399.725px 127.595px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M287.11,242.55a111.58,111.58,0,0,0,5.26,17.69l11.17,2.16S292.6,241.59,295,234l-7.6,2.87Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "295.325px 248.2px"
    },
    id: "elq1bquy7igk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj9lduzgzc8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "295.325px 248.2px"
    },
    className: "animable",
    id: "elamkp6zj297j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.11,242.55c.44,3.64,2.83,10.63,5.26,17.69l11.17,2.16S292.6,241.59,295,234l-7.6,2.87Z",
    id: "ellio4aeunuq9",
    className: "animable",
    style: {
      transformOrigin: "295.325px 248.2px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M359.83,108.08a20.83,20.83,0,0,0-.38,14.36c4.22,12.81,31.59,43.4,30.47,52.56s-11.47,12.21-11.47,12.21,5.61-4.42.68-13.94-21.37-31.86-23.66-36.57c-2.44-5-7.08-10.17-4.93-18.76S359.83,108.08,359.83,108.08Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "369.97px 147.645px"
    },
    id: "elg89l46qkyql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.37,148.27a20.83,20.83,0,0,0-.38,14.36c4.22,12.81,31.59,43.4,30.47,52.56S357,227.4,357,227.4s5.61-4.41.68-13.94S336.3,181.6,334,176.89c-2.45-5-7.08-10.17-4.94-18.76S338.37,148.27,338.37,148.27Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "348.502px 187.835px"
    },
    id: "elb527z0antit",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.48,187.17a20.87,20.87,0,0,0-.38,14.37c4.22,12.81,31.58,43.4,30.47,52.55s-11.47,12.22-11.47,12.22,5.61-4.42.68-13.94-21.38-31.86-23.66-36.57c-2.44-5-7.08-10.17-4.94-18.76S318.48,187.17,318.48,187.17Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "328.617px 226.74px"
    },
    id: "elnvr1u8gs7em",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el78yo828gaid"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "348.502px 187.835px"
    },
    className: "animable",
    id: "ele76adu85ftb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.37,148.27a20.83,20.83,0,0,0-.38,14.36c4.22,12.81,31.59,43.4,30.47,52.56S357,227.4,357,227.4s5.61-4.41.68-13.94S336.3,181.6,334,176.89c-2.45-5-7.08-10.17-4.94-18.76S338.37,148.27,338.37,148.27Z",
    id: "elo9tqqm6j66",
    className: "animable",
    style: {
      transformOrigin: "348.502px 187.835px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el2knqyc1135v"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "328.617px 226.74px"
    },
    className: "animable",
    id: "elpaclt20xuun"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.48,187.17a20.87,20.87,0,0,0-.38,14.37c4.22,12.81,31.58,43.4,30.47,52.55s-11.47,12.22-11.47,12.22,5.61-4.42.68-13.94-21.38-31.86-23.66-36.57c-2.44-5-7.08-10.17-4.94-18.76S318.48,187.17,318.48,187.17Z",
    id: "elal5xr1xhd8h",
    className: "animable",
    style: {
      transformOrigin: "328.617px 226.74px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elf308d7xivv"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 215.61,
    width: 38.4,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "331.2px 217.69px",
      transform: "rotate(28.1deg)"
    },
    className: "animable",
    id: "elvqlt0sd68wl"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3elzgtsue5o"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 206.79,
    width: 59.83,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "335.915px 208.87px",
      transform: "rotate(28.1deg)"
    },
    className: "animable",
    id: "els9t8338hmbc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el12xl7868wbxh"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.7,
    y: 197.73,
    width: 50.05,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "337.725px 199.81px",
      transform: "rotate(28.1deg)"
    },
    className: "animable",
    id: "elvppe0q6vsir"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el999bt37a3ks"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.5,
    y: 189.44,
    width: 29.34,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "343.17px 191.52px",
      transform: "rotate(28.1deg)"
    },
    className: "animable",
    id: "elkhpa9jo0tpq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.78,193.33a16,16,0,0,1,2-3.82,8.2,8.2,0,0,1-.9,2A8,8,0,0,1,341.78,193.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "342.78px 191.42px"
    },
    id: "el4y8nm9acxl6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxkiy8w5wwuh"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "369.97px 147.645px"
    },
    className: "animable",
    id: "el8b8v2po7z02"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.83,108.08a20.83,20.83,0,0,0-.38,14.36c4.22,12.81,31.59,43.4,30.47,52.56s-11.47,12.21-11.47,12.21,5.61-4.42.68-13.94-21.37-31.86-23.66-36.57c-2.44-5-7.08-10.17-4.93-18.76S359.83,108.08,359.83,108.08Z",
    id: "el7lunhqxqzvp",
    className: "animable",
    style: {
      transformOrigin: "369.97px 147.645px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elubdubi7i2bm"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.36,
    y: 133.58,
    width: 38.4,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "370.56px 135.66px",
      transform: "rotate(28.1deg)"
    },
    className: "animable",
    id: "elgyg30plcrct"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgkzxyr9fkn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.04,
    y: 126.18,
    width: 59.83,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "378.955px 128.26px",
      transform: "rotate(28.1deg)"
    },
    className: "animable",
    id: "eli8ecs2vnrv"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elbunvghm8mpe"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.22,
    y: 116.21,
    width: 50.06,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "381.25px 118.29px",
      transform: "rotate(28.1deg)"
    },
    className: "animable",
    id: "el0iv8rwz7z6ud"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el307rf8anug1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.01,
    y: 232.89,
    width: 38.4,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "323.21px 234.97px",
      transform: "rotate(-151.9deg)"
    },
    className: "animable",
    id: "el29gr6zyarv3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnavssqf3b9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.65,
    y: 241.48,
    width: 54.78,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "317.04px 243.56px",
      transform: "rotate(-151.9deg)"
    },
    className: "animable",
    id: "elqztoa01fw2s"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elg40ndpa424q"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.61,
    y: 250.77,
    width: 55.73,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "313.475px 252.85px",
      transform: "rotate(-151.9deg)"
    },
    className: "animable",
    id: "eljg6hwigdxmi"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ello8lyhnydme"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.91,
    y: 173.74,
    width: 38.4,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "349.11px 175.82px",
      transform: "rotate(28.1deg)"
    },
    className: "animable",
    id: "el66ba6ofb98v"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzplxfewawwa"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.59,
    y: 166.35,
    width: 59.83,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "357.505px 168.43px",
      transform: "rotate(28.1deg)"
    },
    className: "animable",
    id: "elyw34bsn645"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3s8d8daxg0c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.77,
    y: 156.38,
    width: 50.05,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "359.795px 158.46px",
      transform: "rotate(28.1deg)"
    },
    className: "animable",
    id: "el9k76u7e0lym"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj1lv1ox7jb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.57,
    y: 148.09,
    width: 29.34,
    height: 4.16,
    rx: 1.25,
    style: {
      fill: "#5290B0",
      transformOrigin: "365.24px 150.17px",
      transform: "rotate(28.1deg)"
    },
    className: "animable",
    id: "elk9xveqsvkgh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M408.82,129.87s3.45,5-.4,11.65-8.85,8.61-13,9.34c-15.26,2.73-48-5.58-58.26,1.6s-8.38,12.92-8.38,12.92-2.07-8.19,1.12-14.34c.63-1.21.86-1.81,1.46-2.85,2.44-4.25,6.27-7.08,12.27-8,7.43-1.1,37.27.27,37.27.27s16.53,1.41,22.19-2.11S408.82,129.87,408.82,129.87Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "369.181px 147.625px"
    },
    id: "el9wh4ucc92qe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.19,124.78c3-20.11,32.45-15,32.45-15l4.13-10.52s-23.5-2.51-31.23,6.11a29.71,29.71,0,0,0-4.53,7.13,19.05,19.05,0,0,0-1.5,9.54,8.81,8.81,0,0,0,.51,2.26Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "368.092px 111.85px"
    },
    id: "el811kp3p8znl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,250.49c-3,20.11-32.83,13.36-32.83,13.36l-4.12,10.52s22.42,1.4,31.23-6.11a24.15,24.15,0,0,0,5-6.56c2.58-4.69,1.32-7.53.7-11.21Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "329.944px 262.482px"
    },
    id: "elgc36mu90z35",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.25,171s3.27,4.7-.58,11.37-8.85,8.6-13,9.34c-10.59,1.89-29.91-1.71-44-1.48-6.23.1-11.28,1.23-14.41,3.43-10.22,7.18-7.9,12.33-7.9,12.33s-2.56-7.47.82-13.51c.56-1,.85-2.23,1.37-3.13,2.6-4.48,5.58-6.91,11.49-8.17,7.35-1.56,38.14.16,38.14.16s16.53,1.42,22.19-2.1S389.25,171,389.25,171Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "349.488px 188.495px"
    },
    id: "el7i0tzsxwge9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.92,211s3.27,4.7-.58,11.36-8.85,8.61-13,9.35c-6,1.07-14.73.61-23.75-.16-6.24-.53-12.64-1.34-18.31-1.37s-10.75.78-14.25,2.3a14.24,14.24,0,0,0-2.3,1.21c-10.23,7.18-7.95,12.51-7.95,12.51s-2-5.37.49-12.87a24.54,24.54,0,0,1,2.06-4.23c2.53-4.27,5.34-7,11.35-7.92a46.06,46.06,0,0,1,6.2-.64c11.55-.3,31.94.8,31.94.8s16.53,1.42,22.19-2.1S367.92,211,367.92,211Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "328.118px 228.6px"
    },
    id: "elyqt12xxqmtp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.94,120.59a8,8,0,0,1,.9-2,8.66,8.66,0,0,1,1.14-1.85,8.2,8.2,0,0,1-.89,2A8.32,8.32,0,0,1,380.94,120.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.96px 118.665px"
    },
    id: "elvc6pq340p1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.25,129.37a8,8,0,0,1,.9-2,8.32,8.32,0,0,1,1.15-1.85,8.5,8.5,0,0,1-.9,2A8,8,0,0,1,376.25,129.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.275px 127.445px"
    },
    id: "eljbumgxg9e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.28,138.69a8.2,8.2,0,0,1,.89-2,8.77,8.77,0,0,1,1.15-1.85,8.2,8.2,0,0,1-.89,2A8.77,8.77,0,0,1,371.28,138.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.3px 136.765px"
    },
    id: "elmokxev9mbu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.2,160.7a8,8,0,0,1,.9-2,8.32,8.32,0,0,1,1.15-1.85,9,9,0,0,1-.9,2A8.32,8.32,0,0,1,359.2,160.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.225px 158.775px"
    },
    id: "el0bem3suq1ayl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,169.22a8.39,8.39,0,0,1,.9-2A8.1,8.1,0,0,1,357,165.4a8.7,8.7,0,0,1-.9,2A8.1,8.1,0,0,1,355,169.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "356px 167.31px"
    },
    id: "elztt4to25smp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,178.75a8.2,8.2,0,0,1,.89-2,8.77,8.77,0,0,1,1.15-1.85,8.2,8.2,0,0,1-.89,2A8.77,8.77,0,0,1,350,178.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "351.02px 176.825px"
    },
    id: "elro4hwouaeib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.17,202a8.2,8.2,0,0,1,.89-2,8.77,8.77,0,0,1,1.15-1.85,8.2,8.2,0,0,1-.89,2A8.77,8.77,0,0,1,337.17,202Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "338.19px 200.075px"
    },
    id: "elrz2m9inpql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.33,209.94a8.39,8.39,0,0,1,.9-2,8.28,8.28,0,0,1,1.14-1.84,8.39,8.39,0,0,1-.89,2A8.53,8.53,0,0,1,333.33,209.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.35px 208.02px"
    },
    id: "el02wbu6dyic18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.29,219.13a8,8,0,0,1,.9-2,8.52,8.52,0,0,1,1.14-1.85,8.2,8.2,0,0,1-.89,2A8,8,0,0,1,329.29,219.13Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "330.31px 217.205px"
    },
    id: "elc3bznjiitt7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.08,245a8.2,8.2,0,0,1,.89-2,8.45,8.45,0,0,1,1.15-1.85,8.39,8.39,0,0,1-.89,2A8.77,8.77,0,0,1,315.08,245Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "316.1px 243.075px"
    },
    id: "el7bhb0had75n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,236.13a8.39,8.39,0,0,1,.89-2,8.22,8.22,0,0,1,1.15-1.84,16,16,0,0,1-2,3.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "322.02px 234.21px"
    },
    id: "eleu0mlf9wnkn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.75,253.85a8.7,8.7,0,0,1,.9-2A7.82,7.82,0,0,1,312.8,250a8.23,8.23,0,0,1-.9,2A8,8,0,0,1,310.75,253.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "311.775px 251.925px"
    },
    id: "elb58riu1o72c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.05,140.52h-.23l-.67,0c-.59,0-1.46.05-2.59.05-2.25,0-5.5,0-9.52,0-8-.14-19.13-.69-31.39-.52a43.17,43.17,0,0,0-8.89.58,14.85,14.85,0,0,0-7.21,3.81,18.06,18.06,0,0,0-2.5,2.93,22.75,22.75,0,0,0-1.78,3.17,26.29,26.29,0,0,0-1.9,6.24,18.73,18.73,0,0,0-.18,5.38,23.14,23.14,0,0,0,.82,4c.3,1.08.59,1.91.77,2.47l.21.64c.05.14.07.22.07.22a.74.74,0,0,1-.09-.21l-.24-.63c-.21-.56-.51-1.38-.83-2.46a23.3,23.3,0,0,1-.87-4,18.9,18.9,0,0,1,.14-5.42,25.7,25.7,0,0,1,1.89-6.31,22.43,22.43,0,0,1,1.79-3.22,18.38,18.38,0,0,1,2.52-3,15.07,15.07,0,0,1,7.33-3.9,43.24,43.24,0,0,1,8.95-.58c12.26-.17,23.37.41,31.4.59,4,.11,7.27.14,9.51.14h3.26A.77.77,0,0,1,395.05,140.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "361.474px 154.608px"
    },
    id: "elip14ikvcyjs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.29,150.16l-.17.06-.49.17-.81.25-1.13.25a42.72,42.72,0,0,1-7.34.73c-6.24.2-14.83-.5-24.28-1.37a117.48,117.48,0,0,0-13.35-.7A31.63,31.63,0,0,0,340,151.37a18.71,18.71,0,0,0-6.22,3.82c-.32.29-.59.56-.82.81s-.42.45-.56.63l-.34.39-.13.13a14,14,0,0,1,1.77-2.05,18.63,18.63,0,0,1,6.22-3.91,31.5,31.5,0,0,1,10.75-1.91,117.42,117.42,0,0,1,13.38.68c9.46.88,18,1.61,24.25,1.46a45.3,45.3,0,0,0,7.32-.63l1.14-.23.81-.23.5-.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "365.11px 153.214px"
    },
    id: "elruarasm7fx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.47,145.55a1.55,1.55,0,0,1,.22-.28c.16-.19.38-.44.64-.76a18.3,18.3,0,0,0,2.05-3,15.65,15.65,0,0,0,1.64-5.12,8.92,8.92,0,0,0-.14-3.16,17.24,17.24,0,0,0-1.16-3.21c-1.93-4.32-4.4-7.87-5.63-10.74-.66-1.4-1.19-2.54-1.59-3.31a6.23,6.23,0,0,0-.51-.85,1.74,1.74,0,0,0-.22-.26s0,0,.08,0a.75.75,0,0,1,.19.18,6.31,6.31,0,0,1,.56.84c.43.75,1,1.88,1.68,3.27,1.26,2.84,3.75,6.36,5.7,10.71a17.82,17.82,0,0,1,1.18,3.27,9.43,9.43,0,0,1,.13,3.25,15.68,15.68,0,0,1-1.73,5.18,17.43,17.43,0,0,1-2.14,3c-.29.32-.53.56-.69.72A2.07,2.07,0,0,1,405.47,145.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "405.572px 130.205px"
    },
    id: "elgzaczceytuc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.42,181.37l-.23,0-.68,0c-.59,0-1.47.06-2.61.07-2.26,0-5.54.06-9.59,0s-8.87-.29-14.22-.49-11.24-.35-17.42-.25a38.36,38.36,0,0,0-8.93.82,15.08,15.08,0,0,0-7.15,4,20,20,0,0,0-4.15,6.26,22.77,22.77,0,0,0-1.75,6.33,17.22,17.22,0,0,0,0,2.87,20,20,0,0,0,.4,2.53,39.56,39.56,0,0,0,1.17,3.95l.88,2.46c.09.27.16.48.22.64a.63.63,0,0,1,.06.22l-.09-.21c-.06-.16-.14-.37-.25-.63-.21-.56-.53-1.38-.92-2.44a34,34,0,0,1-1.22-4,18.81,18.81,0,0,1-.43-2.55,16.59,16.59,0,0,1,0-2.91,19.34,19.34,0,0,1,.6-3.13,24.91,24.91,0,0,1,1.13-3.27,20,20,0,0,1,4.18-6.35,15.25,15.25,0,0,1,7.28-4.14,37.44,37.44,0,0,1,9-.83c6.18-.11,12.08.05,17.43.26s10.16.45,14.21.55,7.33.14,9.59.12l2.61,0h.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "341.948px 195.532px"
    },
    id: "elzfqffjyg03f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.66,191a.63.63,0,0,1-.17.07l-.5.16-.81.25-1.13.26a43.52,43.52,0,0,1-7.34.73c-6.23.19-14.82-.5-24.28-1.38a117.31,117.31,0,0,0-13.34-.7,31.72,31.72,0,0,0-10.69,1.83,18.65,18.65,0,0,0-6.21,3.81,10.56,10.56,0,0,0-.82.81c-.24.24-.42.45-.57.63l-.34.39-.12.13a12.93,12.93,0,0,1,1.77-2,18.26,18.26,0,0,1,6.22-3.92,31.23,31.23,0,0,1,10.75-1.9,115.27,115.27,0,0,1,13.38.68c9.45.87,18,1.6,24.25,1.45a45.42,45.42,0,0,0,7.32-.63l1.13-.23.82-.23.5-.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "345.5px 194.078px"
    },
    id: "elwntdlv2y3w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.84,186.4a1.55,1.55,0,0,1,.22-.28l.67-.79a17.73,17.73,0,0,0,2.09-3.14,15.3,15.3,0,0,0,1.61-5.32,9.1,9.1,0,0,0-.29-3.25,22.94,22.94,0,0,0-1.29-3.3c-1-2.22-2.05-4.31-3.07-6.17s-2.08-3.45-2.93-4.8l-2.06-3.2-.55-.87-.09-.13,0-.05h0s0,0,0,0h0v0a.46.46,0,0,1,0,.08s0,0-.06-.07l0,0h0s0,0,0,0h0s0,0,0,0l0,0,.09.13c.15.19.35.47.61.84.51.74,1.24,1.81,2.13,3.15s2,2.92,3,4.78,2.08,3.95,3.1,6.18a22.68,22.68,0,0,1,1.3,3.35,9.18,9.18,0,0,1,.28,3.35,15.34,15.34,0,0,1-1.69,5.39,15.77,15.77,0,0,1-2.19,3.11c-.3.34-.54.59-.71.76A1.93,1.93,0,0,1,385.84,186.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "385.368px 170.75px"
    },
    id: "el0atl15tsepwg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,221.42a.89.89,0,0,1-.22,0l-.68,0c-.59,0-1.46.06-2.59.08-2.24,0-5.5.06-9.52,0s-8.8-.28-14.12-.48-11.14-.36-17.28-.26a41.41,41.41,0,0,0-8.87.73,15.08,15.08,0,0,0-7.21,3.83,18.49,18.49,0,0,0-2.5,2.93,21.77,21.77,0,0,0-1.78,3.17,25.88,25.88,0,0,0-1.91,6.24,18.73,18.73,0,0,0-.18,5.38,24.27,24.27,0,0,0,.82,4c.3,1.08.59,1.9.77,2.47.09.27.16.48.22.63l.06.22a1,1,0,0,1-.09-.21l-.24-.63c-.2-.55-.51-1.37-.83-2.45a22.87,22.87,0,0,1-.86-4,18.58,18.58,0,0,1,.13-5.43,26,26,0,0,1,1.89-6.31,22.77,22.77,0,0,1,1.79-3.21,18.09,18.09,0,0,1,2.53-3,15.37,15.37,0,0,1,7.32-3.92,41.69,41.69,0,0,1,8.94-.73c6.14-.1,12,.06,17.29.27s10.1.45,14.11.55,7.27.13,9.52.11l2.59,0h.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "320.425px 235.4px"
    },
    id: "el66wpcdess66",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.2,231.06l-.17.07-.49.16-.81.26-1.13.25a42.72,42.72,0,0,1-7.34.73c-6.24.2-14.83-.5-24.28-1.37a120,120,0,0,0-13.35-.71A31.66,31.66,0,0,0,299,232.28a18.87,18.87,0,0,0-6.22,3.81c-.32.29-.59.57-.82.81s-.42.45-.56.63l-.34.4-.13.13a14,14,0,0,1,1.77-2.05,18.63,18.63,0,0,1,6.22-3.92,31.56,31.56,0,0,1,10.75-1.9,115.16,115.16,0,0,1,13.38.68c9.46.87,18,1.6,24.25,1.46a46.54,46.54,0,0,0,7.33-.64l1.13-.23.81-.22.5-.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "324.065px 234.123px"
    },
    id: "el8erjin8evg5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.38,226.45a1.89,1.89,0,0,1,.23-.28l.66-.78a17.66,17.66,0,0,0,2.1-3.15,15.3,15.3,0,0,0,1.6-5.32,8.82,8.82,0,0,0-.29-3.24,20.92,20.92,0,0,0-1.29-3.31c-1-2.22-2.05-4.31-3.07-6.16s-2.07-3.45-2.93-4.81l-2.05-3.19-.56-.88-.08-.13,0,0h0s0,0,0,0h0v0c0,.06,0,.08,0,.09l-.06-.07v0h0s0,0,0,0h0l0,.05.1.12.6.84c.51.74,1.25,1.81,2.13,3.15s1.95,2.93,3,4.79,2.08,3.95,3.1,6.18a21.13,21.13,0,0,1,1.3,3.34,9.19,9.19,0,0,1,.29,3.35,15.55,15.55,0,0,1-1.69,5.39,17.15,17.15,0,0,1-2.19,3.12c-.3.33-.54.59-.71.75S364.39,226.46,364.38,226.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "363.922px 210.827px"
    },
    id: "elj8jxg6jo2ni",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tube--inject-219",
    className: "animable",
    style: {
      transformOrigin: "149.851px 185.325px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.37,285.19h0a25.47,25.47,0,0,1-25.48-25.47V100.08a7.26,7.26,0,0,1,7.25-7.25h36.45a7.25,7.25,0,0,1,7.25,7.25V259.72A25.47,25.47,0,0,1,149.37,285.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "149.365px 189.01px"
    },
    id: "elkmz824j47dk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.37,285.19l1.18-.08L152,285l2-.32a23.78,23.78,0,0,0,2.48-.6c.91-.24,1.86-.64,2.9-1a27.3,27.3,0,0,0,6.48-4.08,25.15,25.15,0,0,0,6-7.47,25.56,25.56,0,0,0,2.85-11c.08-8.22,0-17.61,0-28,0-20.75,0-45.45-.06-72.87,0-13.71,0-28.11,0-43V105.39c0-1.89,0-3.81,0-5.7a7,7,0,0,0-2.36-4.86A7.22,7.22,0,0,0,167,93.09H131.74a7.23,7.23,0,0,0-5.19,1.73,7,7,0,0,0-2.38,4.86c0,1.88,0,3.81,0,5.7v11.29c0,14.93,0,29.32,0,43,0,27.43,0,52.13,0,72.87,0,10.37-.07,19.76,0,28a25.62,25.62,0,0,0,2.86,10.95,25.15,25.15,0,0,0,5.95,7.47,27.1,27.1,0,0,0,6.48,4.08c1,.39,2,.79,2.9,1a23.78,23.78,0,0,0,2.48.6l2,.32,1.45.09,1.18.08s-.4,0-1.18,0l-1.46-.06-2-.29c-.76-.09-1.58-.37-2.5-.58s-1.87-.64-2.92-1a26.84,26.84,0,0,1-6.55-4.06,25.42,25.42,0,0,1-6-7.51,25.82,25.82,0,0,1-2.93-11.06c-.1-8.25-.05-17.62-.08-28,0-20.74,0-45.44-.06-72.87,0-13.72,0-28.11,0-43V105.38c0-1.9,0-3.79,0-5.73a7.46,7.46,0,0,1,2.55-5.21,7.71,7.71,0,0,1,5.53-1.87H167a7.66,7.66,0,0,1,5.52,1.88,7.47,7.47,0,0,1,2.54,5.21c0,1.94,0,3.83,0,5.73v11.29c0,14.92,0,29.32,0,43,0,27.42,0,52.12-.05,72.87,0,10.37,0,19.75-.08,28A25.78,25.78,0,0,1,172,271.63a25.34,25.34,0,0,1-6,7.52,27.16,27.16,0,0,1-6.55,4.06c-1.05.38-2,.78-2.92,1s-1.74.49-2.5.58l-2,.29-1.46.06C149.77,285.19,149.37,285.19,149.37,285.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.425px 188.873px"
    },
    id: "elqtq35m1sdv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.93,99.67h-56a6.84,6.84,0,0,1-6.84-6.84h0A6.83,6.83,0,0,1,121.91,86h56a6.83,6.83,0,0,1,6.83,6.83h0A6.83,6.83,0,0,1,177.93,99.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "149.915px 92.835px"
    },
    id: "elktgm940y5jq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.93,99.67a14.11,14.11,0,0,0,1.54-.24,6.74,6.74,0,0,0,4.7-9,6.72,6.72,0,0,0-4.95-4.14,13,13,0,0,0-2.52-.12l-54.79.08a6.58,6.58,0,0,0-2,12.85,11.47,11.47,0,0,0,3.57.31h7.12l24.63,0,16.61.09,4.51,0,1.18,0a2.12,2.12,0,0,1,.4,0,1.79,1.79,0,0,1-.4,0l-1.18,0-4.51,0-16.61.08-24.63.06h-7.12a11.87,11.87,0,0,1-3.72-.33,7.09,7.09,0,0,1,2.15-13.85l54.79.07a13.16,13.16,0,0,1,2.59.15,7,7,0,0,1,5.46,8.27,7.18,7.18,0,0,1-1.43,3,6.77,6.77,0,0,1-3.82,2.34A5.33,5.33,0,0,1,177.93,99.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.851px 92.565px"
    },
    id: "el2grueq1lwca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.29,279.44h0a20.6,20.6,0,0,1-20.6-20.6V157a41.41,41.41,0,0,1,22.17,0c7,2.94,13.51,3.47,19,0V258.84A20.59,20.59,0,0,1,149.29,279.44Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "149.275px 217.464px"
    },
    id: "elt11g0vbr1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elp7olgyrh58"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "150.196px 216.09px"
    },
    className: "animable",
    id: "elpda7uqpbcmo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.76,254.5l-.07-.07Z",
    id: "elcqrr124rwq6",
    className: "animable",
    style: {
      transformOrigin: "136.725px 254.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.88,202.9a4.49,4.49,0,0,0-.84-1.37,10.8,10.8,0,0,0-1.27-1.15c-.91-.73-1.81-1.4-2.65-2s-1.63-1-2.3-1.41l-1.58-.89-.44-.23-.06,0h-.05c-.61-.35-1.25-.7-1.89-1,1.79-.76,3.38-1.49,4.67-2.19a21.23,21.23,0,0,0,3-1.88l.43-.35.29-.28.18-.18.05-.06-.06,0a8,8,0,0,0,2.14-3.57h0s0,0,.06-.15a4.55,4.55,0,0,0,.14-.46A7.75,7.75,0,0,0,166,184a7.42,7.42,0,0,0-.37-2.59,4.57,4.57,0,0,0-.75-1.36,6.06,6.06,0,0,0-.76-.76h0l-.42-.36c-1.76-1.44-3.58-2.41-4.73-3.35-.59-.45-1.07-.81-1.42-1a2.18,2.18,0,0,0-.41-.24l-.12,0h0a1.37,1.37,0,0,1,.16.07,2.36,2.36,0,0,1,.39.25c.29.21.7.53,1.17.9l-1.86-1.3-4.9,2.34s2.23,1.08,4.72,2.59l-6.85-.18s0,0,0,0v0l-7.41-.19a24.9,24.9,0,0,1,5.79-2.75l-.49-5.38s-10.58,4-12,9.3a13.86,13.86,0,0,0-.41,4,9.14,9.14,0,0,0,1.4,4.39,4.12,4.12,0,0,0,.7.86l.17.16h0c1.35,1.89,3.32,2.83,4.81,4a15.08,15.08,0,0,0,1.42.92l-2.83,1.42a21.3,21.3,0,0,0-3.69,2.17,7.19,7.19,0,0,0-2.3,3.23,8.53,8.53,0,0,0-.44,1.81,11.7,11.7,0,0,0-.08,1.76c0,.27.06.51.09.77a6.31,6.31,0,0,0,.09.76c0,.12.05.24.07.37s.06.25.1.37c.06.28.12.57.2.82A9,9,0,0,0,136,210a10.86,10.86,0,0,0,1.23,1.53c.37.39.67.67.88.87l.23.22.09.07s0,0-.08-.08l0,0c1.12,1,2.36,1.65,3.39,2.44a16.9,16.9,0,0,0,1.65,1.05c-.77.38-1.54.77-2.32,1.18a18.42,18.42,0,0,0-3.67,2.28,7.42,7.42,0,0,0-2.22,3.32,9.72,9.72,0,0,0-.42,3.61,12,12,0,0,0,.21,1.64,1.24,1.24,0,0,1,0,.16c0,.2.09.39.14.57v0c.05.18.11.35.17.52l.06.17,0,.08a10,10,0,0,0,1.73,2.77,11.33,11.33,0,0,0,2.2,1.93h0c.77.54,1.54,1,2.22,1.53a24.2,24.2,0,0,0,2.22,1.39l-1.54.76c-.84.41-1.63.82-2.33,1.19l0,0a16.39,16.39,0,0,0-2.92,1.84,7,7,0,0,0-1,.94,6.15,6.15,0,0,0-1.42,2.54,8.89,8.89,0,0,0-.36,1.57,10.52,10.52,0,0,0-.08,1.76,12.43,12.43,0,0,0,.54,3.09,8.56,8.56,0,0,0,1.11,2.35,11.64,11.64,0,0,0,1.22,1.53c.37.39.68.68.88.87l.24.22.08.07s0,0-.07-.08l-.23-.23c-.2-.2-.5-.49-.86-.89a10.9,10.9,0,0,1-1.2-1.53,9.16,9.16,0,0,1-1.08-2.33l0-.14h0a11.33,11.33,0,0,0,1,2.18l0,.07a1,1,0,0,1,.08.11,7.48,7.48,0,0,0,.92,1.22,1.9,1.9,0,0,1-.25-.35c.28.33.59.68.94,1.07,1.24,1.38,2.73,2.85,4.34,4.38l5.24-1.47a57.75,57.75,0,0,1-6.44-5.44l7.67.2s0,.05,0,.05a.2.2,0,0,0,0-.05l11,.29a25.29,25.29,0,0,1-7,3.08l.49,5.37s9.88-4.2,12-9.29a11.29,11.29,0,0,0,.74-3.87,5.34,5.34,0,0,0-1.23-3.81,5,5,0,0,0-.84-1.1l0,0h0c-1.61-1.63-4.82-3.54-8.39-5.52,1.6-.69,3-1.36,4.21-2a19.8,19.8,0,0,0,3-1.88l.43-.35.29-.28.18-.18.06-.06-.07.05-.19.17-.29.27-.44.34a21.91,21.91,0,0,1-3,1.84c-1.21.64-2.68,1.31-4.31,2h0a36.91,36.91,0,0,0,7.21-3.8,8.43,8.43,0,0,0,3.52-6.6,8.66,8.66,0,0,1-.21,1.58l-.12.47c0,.11,0,.17,0,.17l.06-.16c0-.1.08-.26.14-.47a7.72,7.72,0,0,0,.27-1.8,7.26,7.26,0,0,0-.43-2.66,4.31,4.31,0,0,0-.56-1,4.53,4.53,0,0,0-1.14-1.18l-.41-.34c-.92-.74-1.81-1.41-2.65-2s-1.64-1-2.3-1.4l-1.58-.89-.44-.23-.07,0,0,0h0s0,0,0,0h0l.07,0,.42.26,1.53.9c-1.14-.67-2.36-1.36-3.62-2,2-.85,3.85-1.67,5.3-2.45a21.84,21.84,0,0,0,3-1.88l.42-.36.3-.28.17-.17.06-.07-.07.06-.13.11a8.44,8.44,0,0,0,2.63-6c0-.19,0-.36,0-.54a3,3,0,0,1,0,.42,8.16,8.16,0,0,1-.22,1.79c-.05.2-.08.36-.11.48s0,.17,0,.17a1.1,1.1,0,0,0,.06-.16,4.43,4.43,0,0,0,.14-.48,7.54,7.54,0,0,0,.27-1.8A7.29,7.29,0,0,0,165.88,202.9Zm-9.95,20.33-7.48-.2s0,0,0,0v0l-7.41-.19a19.09,19.09,0,0,1,2.29-1.42c.79-.42,1.63-.81,2.51-1.19l2.66.07s0,.09,0,.09,0,0,0-.09l2.4.06C152.66,221.33,154.39,222.31,155.93,223.23Zm-1.6,20c2,1.18,3.84,2.28,5,3.15l-11.15-.29v0s0,0,0,0l-9.33-.24a15.69,15.69,0,0,1,3.86-2.76l.3-.15Zm-6-18.24s0,0,0,0v0l10.8.28.4.28a8.41,8.41,0,0,1,2,2l-13.11-.34a.1.1,0,0,0,0,0s0,0,0,0l-9.86-.26a8.68,8.68,0,0,1-.56-1.09,10.65,10.65,0,0,1,.84-1.14Zm.31,9s0,0,0,0a.1.1,0,0,0,0,0l2,.05-1.5.68L147.8,234Zm7.28-2.29c.84-.41,1.56-.78,2.13-1.08C157.35,231.07,156.61,231.43,156,231.74Zm3.21-1.69-.94.48c-.83.42-2,1-3.43,1.67l-6-.15a.2.2,0,0,0,0-.05s0,0,0,.05l-4.52-.12a24.26,24.26,0,0,1-4-2.9l8.21.21a.13.13,0,0,1,0,0s0,0,0,0l11.51.3Zm-15.51-41.57a19.06,19.06,0,0,1-2.78-2.15,10.58,10.58,0,0,1-.84-1l9.48.25s0,.08,0,.08,0,0,0-.08l11.15.29c-.28.2-.59.4-.9.59l-.25.13-1.11.55c-.8.41-1.93,1-3.3,1.61Zm11.79.3h-.09c1.29-.62,2.36-1.16,3.13-1.56l1.08-.57A39.28,39.28,0,0,1,155.45,188.78Zm-6.38,16.59a.47.47,0,0,0,0-.17s0,.07,0,.17l-10.74-.28a10.12,10.12,0,0,1-.41-1,9.48,9.48,0,0,1,.94-1.21c.13-.15.3-.3.46-.46l9.69.25q0,.09,0,.09s0,0,0-.08l9.79.25c.52.33,1,.65,1.38.93a8.91,8.91,0,0,1,1.93,1.89Zm-11.27-1.46a6.31,6.31,0,0,1,1.23-1.53h.08c-.13.13-.28.26-.4.4a9.55,9.55,0,0,0-.89,1.17Zm17.58-3.09-13.63-.36,1.21-.69a44.66,44.66,0,0,1,4.2-1.9l3.17.08C152,198.9,153.77,199.88,155.38,200.82Zm-18.44,10.35-.05-.06-.13-.2Zm24-3.51-.69.46h0l-.29.15-1.1.57c-.85.42-2,1-3.49,1.7l-6.37-.17s0,0,0,0,0,0,0,0l-5.86-.15a18,18,0,0,1-2.75-2.14,9.37,9.37,0,0,1-.85-1Zm-12,4.7v0s0,0,0,0l2.32.06-2.51,1.13c-.77-.42-1.52-.84-2.24-1.26Zm6.71-1.82h-.06c1.37-.66,2.51-1.23,3.31-1.66l1.1-.59.06,0A38.57,38.57,0,0,1,155.59,210.54Zm-1-15.84c1.47-.61,2.87-1.22,4.14-1.84-1.19.6-2.57,1.22-4.11,1.86Zm11-8.89,0-.11v0Zm.22-1.38c0,.22,0,.42-.07.61C165.79,184.84,165.81,184.63,165.83,184.43Zm-16.18-3.53s0,0,0,0v0l10,.26a13.87,13.87,0,0,1,3,2.81l-13.07-.34h0l-10.77-.28a9.69,9.69,0,0,1-.4-1,11,11,0,0,1,1.44-1.69Zm-2.59,9.65,2.33.06c0,.08,0,.13,0,.13s0-.05,0-.13l1.67,0-2.12,1ZM135.18,208.3a13.37,13.37,0,0,0,1.68,2.77A8.59,8.59,0,0,1,136,210,8.79,8.79,0,0,1,135.18,208.3Zm-.38,17.81a5.78,5.78,0,0,1,0,.58,1.79,1.79,0,0,1,0-.23C134.8,226.35,134.81,226.23,134.8,226.11ZM137.27,248l.07-.13,10.8.28a.13.13,0,0,1,0,.05s0,0,0,0l12.82.33a.76.76,0,0,0,.37-.1,5.36,5.36,0,0,1,.92,2,9.9,9.9,0,0,1-.73.85l-13.28-.34s0,0,0,0a.1.1,0,0,0,0,0l-9.53-.25A7.23,7.23,0,0,1,137.27,248Zm13.39-6.77-1.79-.05c0-.06,0-.09,0-.09s0,0,0,.09l-1.58,0,1.33-.53.58-.23Zm-2.14-.75-1.62.65h-.05c.69-.29,1.4-.57,2.12-.85l0,0Zm15-17.89h0l0,0Zm-9.19-5.94c1.77-.72,3.46-1.44,4.95-2.18-1.38.71-3,1.44-4.9,2.21Z",
    id: "elehb24dba8q",
    className: "animable",
    style: {
      transformOrigin: "150.196px 216.09px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stem-cell--inject-219",
    className: "animable",
    style: {
      transformOrigin: "66.3727px 214.912px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.24,195.05c-6.72-7.84-17.56-12.23-27.88-12.46-9.79-.82-20.14,2.62-26.53,10.09-4,4.68-5.47,9.4-6,15.55s-.19,13.69,2.17,19.38a31.69,31.69,0,0,0,8.79,12.47c4.73,3.89,10.77,5.84,16.8,6.88,7.34,1.26,14.54-1.08,21.48-3.76,9.63-3.72,17.52-10.32,19.65-20.42S99,202.88,92.24,195.05Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "66.4605px 214.891px"
    },
    id: "eli929zv3l5hi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.24,195.05s.13.13.37.4.6.69,1,1.24a42.59,42.59,0,0,1,3.48,5.14,33.63,33.63,0,0,1,3.61,9.14,29,29,0,0,1,.73,6.1,26.76,26.76,0,0,1-.85,6.85,25.24,25.24,0,0,1-8.45,13.14,36.88,36.88,0,0,1-7.41,4.77,75.36,75.36,0,0,1-8.68,3.43,45,45,0,0,1-9.58,2.17,27.91,27.91,0,0,1-5.09,0,38.88,38.88,0,0,1-5.1-.89,37.31,37.31,0,0,1-9.94-3.72,26.78,26.78,0,0,1-4.45-3.15,27.3,27.3,0,0,1-3.73-4.08,35.83,35.83,0,0,1-5.08-9.67,38.85,38.85,0,0,1-1.71-10.48,55,55,0,0,1,.54-10.23A24.85,24.85,0,0,1,35.16,196a26.94,26.94,0,0,1,6.21-7A29.72,29.72,0,0,1,49,184.61a34.35,34.35,0,0,1,15.56-2.19,41.07,41.07,0,0,1,12.75,2.48,38.27,38.27,0,0,1,8.73,4.51,34,34,0,0,1,4.74,4c.49.51.84.93,1.08,1.2s.35.43.35.43l-.39-.39c-.26-.26-.61-.67-1.12-1.16A34.13,34.13,0,0,0,86,189.58a38.62,38.62,0,0,0-8.71-4.41,41.28,41.28,0,0,0-12.67-2.39A34.24,34.24,0,0,0,49.19,185,27.74,27.74,0,0,0,35.57,196.2a24.32,24.32,0,0,0-3.14,9.1,54.78,54.78,0,0,0-.52,10.13,38.8,38.8,0,0,0,1.69,10.34,35.33,35.33,0,0,0,5,9.52,25.45,25.45,0,0,0,8,7.09,37.56,37.56,0,0,0,9.8,3.68,40.62,40.62,0,0,0,5,.88,26.93,26.93,0,0,0,5,0,44,44,0,0,0,9.47-2.13,74.8,74.8,0,0,0,8.63-3.38,36.42,36.42,0,0,0,7.33-4.69,24.92,24.92,0,0,0,8.38-12.9,27.43,27.43,0,0,0,.87-6.75,29.39,29.39,0,0,0-.68-6.05,33.51,33.51,0,0,0-3.51-9.1,42.56,42.56,0,0,0-3.39-5.17c-.42-.55-.75-1-1-1.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "66.3727px 214.912px"
    },
    id: "elvg57byaxv0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,209.72a6,6,0,0,0-3.12-3.84,5.45,5.45,0,0,0-5.92-6,11.05,11.05,0,0,1-1.79.17l-.4-.12-.68-.25c-.36-.25-.67-.59-1-.88a5.63,5.63,0,0,0-7.56.17,17.13,17.13,0,0,0-1.72.4,6.58,6.58,0,0,0-4.77.24c-1.49.76-2.43,3.73-2.17,5.32h0c-1.4.71-3.42,1.11-4.6,4.37a6.82,6.82,0,0,0,.61,5.55c0,.44-.07-.43,0,0-1.18,2.36.37,4.6.39,5.45,0,2,1.88,3.67,2.92,4.42A28.81,28.81,0,0,0,57,226.25c1.86,1,3.13,3.09,5.2,3.52,1.86.4,3.72-.69,5.62-.73,1.2,0,2.37.36,3.56.44a7.27,7.27,0,0,0,7.38-5.69l0-.06a7.2,7.2,0,0,0,3.74-9.13A6,6,0,0,0,83.4,209.72Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "66.4589px 213.642px"
    },
    id: "elho4kvfnqfbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9xlohus6oc4"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "67.1338px 219.239px"
    },
    className: "animable",
    id: "elvmkx1sp2n4a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4,209.72a6.05,6.05,0,0,0-.41-1.1,6,6,0,0,1-1,4.32,7.18,7.18,0,0,1-3.74,9.13l0,.06a7.26,7.26,0,0,1-7.37,5.69c-1.19-.08-2.36-.47-3.56-.44-1.9,0-3.76,1.13-5.63.74-2.06-.44-3.33-2.52-5.19-3.53a28.09,28.09,0,0,1-3.39-1.54,8.29,8.29,0,0,1-2.42-2.87s0,.07,0,.11a7.49,7.49,0,0,0,2.92,4.42A28.81,28.81,0,0,0,57,226.25c1.86,1,3.13,3.09,5.2,3.52,1.86.4,3.72-.69,5.62-.73,1.2,0,2.37.36,3.56.44a7.27,7.27,0,0,0,7.38-5.69l0-.06a7.2,7.2,0,0,0,3.74-9.13A6,6,0,0,0,83.4,209.72Z",
    id: "eluufmq84g59f",
    className: "animable",
    style: {
      transformOrigin: "67.1338px 219.239px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M56.65,215.74s-.39-.16-.77-.68a3.89,3.89,0,0,1,.15-4.74c.42-.49.78-.67.82-.62s-.21.33-.52.84a4.25,4.25,0,0,0-.14,4.32C56.46,215.39,56.71,215.68,56.65,215.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "56.0007px 212.716px"
    },
    id: "el1dphz4ndtge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.85,218.33c-.08.11-.72-.45-.7-1.41s.67-1.51.75-1.39-.23.65-.23,1.4S57,218.24,56.85,218.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "56.5314px 216.929px"
    },
    id: "eliwqbwsg1i4g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.94,220.56c.06,0,0,.5-.4,1.15a4.42,4.42,0,0,1-2.34,1.81,4.34,4.34,0,0,1-2.94-.12c-.71-.3-1-.66-1-.71a8.32,8.32,0,0,1,1.12.36,4.55,4.55,0,0,0,4.86-1.55C72.68,221,72.86,220.53,72.94,220.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "69.6099px 222.14px"
    },
    id: "el4iqdlw6ekeu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.82,219.57c.07,0,.17.18.14.52a1.69,1.69,0,0,1-.61,1.14,1.66,1.66,0,0,1-1.25.36c-.33,0-.5-.18-.48-.24s.78,0,1.4-.53S74.68,219.57,74.82,219.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "73.7919px 220.586px"
    },
    id: "elyeg7cbvkhgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,212.22c-.07,0,0-.37.1-.91a3.76,3.76,0,0,0-.33-2,3.86,3.86,0,0,0-1.37-1.53c-.45-.29-.79-.41-.77-.48s.39-.08,1,.16a3.4,3.4,0,0,1,1.89,3.94C76.29,212,76,212.25,76,212.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "75.1277px 209.739px"
    },
    id: "el4ozp7msstdx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9,207.57c-.12.07-.57-.48-1.37-.69s-1.47,0-1.54-.13.11-.22.42-.34a2.09,2.09,0,0,1,1.26,0,2,2,0,0,1,1.06.7C68.93,207.33,69,207.54,68.9,207.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "67.4601px 206.944px"
    },
    id: "el3v92wrhkbb2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.65,216.73c.15,0,.24.72.82,1.31s1.25.76,1.24.91-.2.13-.52.07a2,2,0,0,1-1.1-.62,2,2,0,0,1-.55-1.14C62.51,216.93,62.59,216.73,62.65,216.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "63.6218px 217.897px"
    },
    id: "elqsyof1dz5rn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.81,202.77c-.06,0-.35-.23-.9-.53a3.59,3.59,0,0,0-2.27-.47A2.85,2.85,0,0,0,61.75,203c-.34.5-.38.91-.47.9s-.16-.44.15-1.08a2.87,2.87,0,0,1,2.14-1.56,3.49,3.49,0,0,1,2.54.68C66.66,202.35,66.86,202.73,66.81,202.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "64.0104px 202.567px"
    },
    id: "elp0cyaptsww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9vl1tq4gag"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "56.8515px 212.663px"
    },
    className: "animable",
    id: "eltfsx1rnidte"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.81,218.25a2.18,2.18,0,0,1-1.31-2.7,4.29,4.29,0,0,1-.09-5.13c.34-.47.78-.85,1.14-1.31s.64-1,1-1.43a1.81,1.81,0,0,1,1.55-.69,2.47,2.47,0,0,0-1.87,2.42,3.87,3.87,0,0,0-1.76,3,4,4,0,0,0,1.23,3.31,2.86,2.86,0,0,0,.11,2.62",
    id: "elm2vhdgxah4g",
    className: "animable",
    style: {
      transformOrigin: "56.8515px 212.663px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M69,238.34c-1.42-1.28-3.68.18-5.55-.16s-3-2.65-4.82-3.59c-2-1.08-4.55-.23-6.8-.72-3.1-.68-5-3.67-6.65-6.41s-3.36-5.78-3.65-9.05a30.74,30.74,0,0,0-.31-4.08,3.65,3.65,0,0,0-2.53-2.94,2.77,2.77,0,0,0-3,2.85h0c.66,7.72,3.48,15.4,8.78,21s13.23,9,20.9,7.92a5.9,5.9,0,0,0,3.49-1.43A2.5,2.5,0,0,0,69,238.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "52.6419px 227.37px"
    },
    id: "el7vndlg91k6t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.61,189.75c3.42,1.08,6.91,2.19,9.81,4.3s5.22,5.36,8.34,7.38c1,.68,2.52,1.17,3.43.32a2.07,2.07,0,0,0,.49-1.9,4.9,4.9,0,0,0-.92-1.82c-3.69-5.14-9.76-7.93-15.58-10.4a7.06,7.06,0,0,0-2.82-.76A2.45,2.45,0,0,0,72,188.36",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "82.675px 194.535px"
    },
    id: "elkxhp8lwyo3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.46,207.63a3,3,0,0,0-1.59-1.89l-.29.16a1.87,1.87,0,0,0-1.58.64,2.56,2.56,0,0,0-.6,1.63,2.35,2.35,0,0,0,1,2.1,2.06,2.06,0,0,0,2.36-.29A2.43,2.43,0,0,0,96.46,207.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "94.4615px 208.128px"
    },
    id: "elcpp8tso0s2j",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-219",
    className: "animable",
    style: {
      transformOrigin: "248.96px 266px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.33,393.78c-5.68-10.55-5.68-25.43-5.68-25.43s-1.86-43.38-5.94-79.93c-4.54-40.64-39.23-47.25-39.23-47.25l-3.63,75.73s10.4,73.63,12,87.15,8.17,50.22,16.28,63.47l41.92.11C379.37,443.56,372,404.32,366.33,393.78Z",
    style: {
      fill: "rgb(255, 191, 157)",
      transformOrigin: "346.95px 354.4px"
    },
    id: "elepiyycxd9ti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.28,435.91c.91-9.28,11.45-111.56,11.45-111.56l4.41-82s-22.63,3.05-34.12,24.29c-5.56,10.29-12.91,108-12.91,108s-9.24,36.42-10.8,50.84l-2.44,42.18h41.28Z",
    style: {
      fill: "rgb(255, 191, 157)",
      transformOrigin: "146.005px 355.005px"
    },
    id: "elhk8zmzbi4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.93,247.19l8.95,131-3.47,89.51,150.4,0-.26-77.38c-.08-4.3.89-13.71,1.3-18L327,267.8l-11.54-26.63-53-12.29-52.18-1.63Z",
    style: {
      fill: "rgb(255, 191, 157)",
      transformOrigin: "244.465px 347.475px"
    },
    id: "elfemelowvvkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.9,338.92c0,.36-7.17.93-16,1.27s-16.07.35-16.09,0,7.16-.92,16-1.27S220.89,338.57,220.9,338.92Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "204.855px 339.553px"
    },
    id: "elhknn22ywahj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,339.93c0,.35-6.76.26-15.06-.21s-15-1.13-15-1.48,6.77-.26,15.07.2S297.06,339.58,297,339.93Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "281.97px 339.085px"
    },
    id: "elntrkrj5iccj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.07,448.6c0,.15-1-.1-1.41-1.44a2.87,2.87,0,1,1,5.29.58c-.68,1.22-1.68,1.25-1.68,1.1s.57-.52.85-1.46a1.85,1.85,0,1,0-3.57-.39C240.62,448,241.18,448.44,241.07,448.6Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "242.422px 446.207px"
    },
    id: "el1tae059ahk7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59,288.42a10.68,10.68,0,0,1,.15,1.81c0,1.32.11,3,.19,5.22.21,4.52.55,11.07,1.32,19.13s2,17.62,3.24,28.28c.6,5.33,1.12,10.95,1.34,16.8s0,11.91-.22,18.08c-.81,24.72-1.72,47.1-2.63,63.29-.45,8.09-.9,14.64-1.25,19.16-.19,2.16-.34,3.89-.46,5.2a9.1,9.1,0,0,1-.25,1.81,11.15,11.15,0,0,1,0-1.83c.06-1.31.13-3,.22-5.21.21-4.66.49-11.18.84-19.17.69-16.19,1.45-38.57,2.26-63.29.21-6.19.5-12.2.25-18s-.7-11.4-1.26-16.72c-1.15-10.64-2.34-20.24-3-28.33s-.86-14.66-.92-19.19c0-2.27,0-4,0-5.22A9.12,9.12,0,0,1,165.59,288.42Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "168.666px 377.81px"
    },
    id: "elnqahr35656",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.7,282.34a9.53,9.53,0,0,1,.1,1.89c0,1.24.07,3.07,0,5.42-.09,4.71-.4,11.53-1.23,19.91s-2.2,18.33-3.65,29.35c-.7,5.51-1.39,11.31-1.8,17.32-.21,3-.32,6.08-.35,9.19s.07,6.27,0,9.48c-.17,25.63-.31,48.82-.42,65.75-.12,8.32-.21,15.1-.28,19.93-.05,2.26-.1,4.06-.13,5.41a11.18,11.18,0,0,1-.14,1.89,10.29,10.29,0,0,1-.12-1.89c0-1.35-.06-3.15-.1-5.41,0-4.83-.08-11.61-.14-19.92,0-16.93,0-40.11.05-65.72,0-3.2,0-6.38,0-9.53s.15-6.23.37-9.25c.43-6.06,1.15-11.87,1.88-17.39,1.52-11,3-20.94,3.92-29.3s1.39-15.14,1.63-19.83c.09-2.26.17-4.06.23-5.41A11.68,11.68,0,0,1,325.7,282.34Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "321.636px 375.11px"
    },
    id: "elbsa1z2zebld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.33,234.82l-1.26-103.88c-1.16-25.83,12.91-48,38.76-48.47l2.39.1a46.22,46.22,0,0,1,44.29,44.36c.88,22.4,1.56,47.15.92,59.12-1.33,24.78-26.29,27.61-26.29,27.61S269,228.74,269,236l-1.38,17.11-13.19-5.07Z",
    style: {
      fill: "rgb(255, 191, 157)",
      transformOrigin: "252.343px 167.79px"
    },
    id: "el9e97dscebho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.14,212.8s-15.66.28-31.88-10.87c0,0,7,19,31.83,17.75Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "253.2px 210.835px"
    },
    id: "elsc1al1l38c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.48,147.47a3.54,3.54,0,0,1-3.56,3.43,3.39,3.39,0,0,1-3.52-3.34,3.55,3.55,0,0,1,3.56-3.44A3.4,3.4,0,0,1,283.48,147.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "279.94px 147.51px"
    },
    id: "elk7h064lmxz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.79,136.81c-.46.45-3.06-1.65-6.87-1.8s-6.68,1.65-7.08,1.16c-.19-.21.29-1,1.55-1.86a9.63,9.63,0,0,1,5.68-1.5,9.27,9.27,0,0,1,5.44,2C288.65,135.76,289,136.61,288.79,136.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "281.824px 134.835px"
    },
    id: "elx51du0esxkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92,146.78a3.53,3.53,0,0,1-3.56,3.43,3.37,3.37,0,0,1-3.51-3.34,3.53,3.53,0,0,1,3.55-3.43A3.38,3.38,0,0,1,249.92,146.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "246.385px 146.825px"
    },
    id: "el42kw5l3ex8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.41,136.15c-.46.45-3.06-1.65-6.87-1.8s-6.68,1.65-7.07,1.16c-.2-.21.28-1,1.54-1.86a9.63,9.63,0,0,1,5.68-1.5,9.34,9.34,0,0,1,5.45,2C251.27,135.1,251.63,136,251.41,136.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "244.449px 134.175px"
    },
    id: "elkfeo1n8fsb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.86,166c0-.22,2.38-.53,6.24-.86,1-.06,1.9-.22,2.09-.88a4.91,4.91,0,0,0-.53-2.91c-.81-2.39-1.67-4.89-2.57-7.52-3.56-10.71-6.09-19.5-5.66-19.64s3.67,8.43,7.23,19.14c.85,2.64,1.67,5.15,2.45,7.56.32,1.12.9,2.4.35,3.84a2.45,2.45,0,0,1-1.66,1.36,6.86,6.86,0,0,1-1.66.16C266.27,166.29,263.87,166.2,263.86,166Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "268.535px 150.224px"
    },
    id: "elct9kev752b6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.13,124.29c-.55.95-4.21-.23-8.7-.51s-8.28.26-8.69-.76c-.18-.49.61-1.33,2.23-2a14.43,14.43,0,0,1,6.74-1,14.59,14.59,0,0,1,6.51,2C252.72,122.88,253.38,123.83,253.13,124.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "244.448px 122.307px"
    },
    id: "eljr1algr6qp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.42,125.62c-.81.84-3.89-.14-7.62-.28s-6.91.4-7.61-.52c-.31-.45.21-1.3,1.61-2.09a12,12,0,0,1,6.24-1.25,11.81,11.81,0,0,1,6,1.9C289.37,124.3,289.78,125.21,289.42,125.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "281.824px 123.703px"
    },
    id: "elgmo2f02eped",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.33,148.53c-.41-.2-16.82-5.74-17,11.23s16.91,13.63,16.94,13.14S210.33,148.53,210.33,148.53Z",
    style: {
      fill: "rgb(255, 191, 157)",
      transformOrigin: "201.829px 160.498px"
    },
    id: "elr4azqm49udf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.17,166.42c-.07,0-.3.21-.8.43a2.94,2.94,0,0,1-2.21,0c-1.79-.68-3.27-3.54-3.32-6.6a9.86,9.86,0,0,1,.86-4.22,3.42,3.42,0,0,1,2.25-2.25,1.51,1.51,0,0,1,1.74.83c.22.47.11.81.2.84s.37-.28.24-1a1.93,1.93,0,0,0-.66-1.07,2.23,2.23,0,0,0-1.63-.45,4.18,4.18,0,0,0-3.12,2.6,10,10,0,0,0-1.06,4.72c.07,3.42,1.79,6.64,4.24,7.37a3.17,3.17,0,0,0,2.71-.42C205.14,166.83,205.23,166.46,205.17,166.42Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "201.422px 160.335px"
    },
    id: "el6ol4zqldj3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.76,103.76a4,4,0,0,0-1.86-2.37c-1.93-1.17-4.17-1-6.34-1.1a35.78,35.78,0,0,1-15.48-4.08,17.73,17.73,0,0,0,4.6-3.15c2.78-2.71,4.4-6.88,3.19-10.56a2.36,2.36,0,0,0-1.32-1.64c-1.1-.35-2.07.72-2.85,1.57-2.56,2.8-4.91,4-8.67,3.56a15,15,0,0,1-6.43-2c-.08-.08-.14-.16-.21-.24-.88-.92-1.73-1.8-2.57-2.65h0c-6.31-6.41-11.75-10.86-17.38-13.2-8.24-3.43-22.08-4.94-30.75-2.77s-16.5,9.09-17.8,17.93c-4.8-4.15-12.07-4.2-18-1.9l-.15-.06c-6.59,2.26-10.41,9.16-12.42,15.84-.11.37-.21.74-.31,1.1a26.1,26.1,0,0,1-8.94,8.54c-.64.36-1.37.81-1.46,1.54s.52,1.33,1.11,1.76a13,13,0,0,0,5.29,2.27,29,29,0,0,1-2.23,4.59c-.76,1.25-1.66,2.74-1,4.06a2.76,2.76,0,0,0,2.88,1.29,8.13,8.13,0,0,0,3.08-1.34c-.76,1.74-1.51,3.49-2.26,5.23a15.45,15.45,0,0,0,7.15-.39c1.33,6.28,2.24,17.9,3.81,22.16,4.5.13,5.6-.34,7.87.44,2.92,1,1.74,6.19,5.58,4.76,2-.73,5-8.08,5.71-10.05a97,97,0,0,0,4.66-41,31.1,31.1,0,0,1,9.69-6.83l-.29.26c7-2.33,14.84-4.61,21.38-1.28,5.08,2.59,8,7.92,11.79,12.19,7.15,8.1,15.29,12.47,26.07,13,.89,7.51,1,19.76,1.32,26.76l6.13-13.93v.06c.49-.82.9-1.64,1.29-2.46l.14-.25v0a41,41,0,0,1,2-4l.06.06c3.75,3.39,9.39-1.66,6.45-5.76a9.48,9.48,0,0,0-2.09-2.15,7,7,0,0,0,6.57,1.78,5.43,5.43,0,0,0,3.89-5.32,4.63,4.63,0,0,0-2.7-3.73,15.55,15.55,0,0,0,8.87-1.85C327.59,107.59,329.33,106,328.76,103.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "256.236px 108.659px"
    },
    id: "elx8oqu1ftzi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.67,86a20.37,20.37,0,0,0-2.52,2.25,17.73,17.73,0,0,0-3.9,8.2,31.83,31.83,0,0,0-.71,6.3c0,2.29.12,4.74.27,7.32a64.66,64.66,0,0,1,.09,8.15,28,28,0,0,1-.61,4.29,8.92,8.92,0,0,1-1.8,4.15,3.77,3.77,0,0,1-3.52,1.14,5.64,5.64,0,0,1-3.13-1.82c-1.58-1.88-2-4.25-2.32-6.34l.52.07a20.76,20.76,0,0,1-3.08,5.16,7.38,7.38,0,0,1-4.86,2.58,4.74,4.74,0,0,1-2.56-.48,4.15,4.15,0,0,1-1.72-1.73,4.26,4.26,0,0,1-.5-2.21,3.09,3.09,0,0,1,.82-1.92l.26.24a15.91,15.91,0,0,1-5.38,3.94,14.2,14.2,0,0,1-1.66.62,2.51,2.51,0,0,1-.59.14,3.26,3.26,0,0,1,.56-.23c.37-.15.92-.36,1.61-.7a16.54,16.54,0,0,0,5.2-4l.26.24a3.17,3.17,0,0,0-.21,3.69,3.77,3.77,0,0,0,1.55,1.54,4.41,4.41,0,0,0,2.32.4,6.93,6.93,0,0,0,4.51-2.45,20.38,20.38,0,0,0,3-5.06l.37-.79.15.86c.38,2.09.77,4.36,2.21,6.06a5.07,5.07,0,0,0,2.81,1.63,3.18,3.18,0,0,0,3-1,8.52,8.52,0,0,0,1.66-3.88,27.77,27.77,0,0,0,.6-4.2,63.76,63.76,0,0,0-.06-8.08c-.13-2.58-.27-5-.21-7.36a31,31,0,0,1,.79-6.38A17.52,17.52,0,0,1,230,88.11,10.16,10.16,0,0,1,232.67,86Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "214.22px 106.937px"
    },
    id: "eldap71vncm6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.22,111.05s-.06.07-.2.17l-.62.45a8.73,8.73,0,0,1-1.06.66,15.12,15.12,0,0,1-1.52.78,22.09,22.09,0,0,1-10.65,1.79,28.17,28.17,0,0,1-14.93-5.71c-4.92-3.62-9.21-8.93-12.71-15-1.77-3-3.21-6.13-4.8-9a33.07,33.07,0,0,0-5.46-7.62,17,17,0,0,0-7.11-4.43,12,12,0,0,0-3.76-.47,13.33,13.33,0,0,0-3.47.62A14.45,14.45,0,0,0,234.87,80a17.53,17.53,0,0,0-1.32,3.71,1,1,0,0,1,0-.26c0-.2.08-.45.13-.76a13,13,0,0,1,1-2.79,14.32,14.32,0,0,1,2.83-3.74,14.55,14.55,0,0,1,5.3-3.21,13.69,13.69,0,0,1,3.58-.68,12.7,12.7,0,0,1,3.92.46,17.48,17.48,0,0,1,7.35,4.51,33.18,33.18,0,0,1,5.58,7.73c1.61,2.88,3,6,4.81,9,3.46,6,7.69,11.26,12.52,14.85a28,28,0,0,0,14.64,5.73,22.44,22.44,0,0,0,10.53-1.59A33.86,33.86,0,0,0,309.22,111.05Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "271.381px 93.6158px"
    },
    id: "el18v6xeqtxg1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.61,100.17a4.07,4.07,0,0,1-.9.61,20.34,20.34,0,0,1-2.65,1.31,26.38,26.38,0,0,1-4.19,1.32,26.88,26.88,0,0,1-10.72.22,25.1,25.1,0,0,1-4.24-1.15,18.24,18.24,0,0,1-2.71-1.2,3.56,3.56,0,0,1-.92-.57c.05-.1,1.41.62,3.76,1.38a28.55,28.55,0,0,0,4.2,1,28.77,28.77,0,0,0,10.52-.21,28.85,28.85,0,0,0,4.15-1.19C310.22,100.85,311.56,100.07,311.61,100.17Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "298.445px 102.113px"
    },
    id: "elyror5iv8yp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.51,177.58c-.2-.61-4.21.94-8.38-1.39s-5.38-6.75-6-6.57c-.27,0-.4,1.26.25,3.08a10.65,10.65,0,0,0,4.74,5.57,9.35,9.35,0,0,0,6.93.91C262.82,178.68,263.64,177.85,263.51,177.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "256.216px 174.546px"
    },
    id: "elnj3n3n26i3",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Zoom--inject-219",
    className: "animable",
    style: {
      transformOrigin: "340.349px 303.75px"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 239.69,
    cy: 236.38,
    r: 4.44,
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "239.69px 236.38px"
    },
    id: "elw8g4suyn8vs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.51,290H248.75a9.06,9.06,0,0,1-9.06-9.06v-39.5h1v39.5a8.06,8.06,0,0,0,8.06,8.06h68.76Z",
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "278.6px 265.72px"
    },
    id: "elmhi7nfhrjol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.45,
    cy: 303.75,
    r: 66.06,
    style: {
      fill: "rgb(255, 154, 108)",
      transformOrigin: "370.45px 303.75px"
    },
    id: "elbxzskjwuh1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.52,303.75s0-.37-.06-1.07,0-1.77-.14-3.14a67.9,67.9,0,0,0-1.9-11.92,66,66,0,0,0-24.07-36.29A65.92,65.92,0,0,0,382.61,239a67.17,67.17,0,0,0-25.8.3,69,69,0,0,0-8.8,2.52,66,66,0,0,0-30.6,22.95,65.07,65.07,0,0,0-5.37,8.64,61.92,61.92,0,0,0-4,9.51,65.81,65.81,0,0,0,0,41.55,60.29,60.29,0,0,0,4,9.52,65.12,65.12,0,0,0,5.36,8.65,66.06,66.06,0,0,0,30.61,23,70.63,70.63,0,0,0,8.8,2.51,67.17,67.17,0,0,0,25.8.3,65.59,65.59,0,0,0,27.74-12.29,66,66,0,0,0,24.07-36.29,68,68,0,0,0,1.9-11.91c.12-1.38.1-2.44.14-3.14s.06-1.07.06-1.07,0,1.45-.1,4.21a65.05,65.05,0,0,1-9.06,29.63,66.89,66.89,0,0,1-16.78,18.86,66.15,66.15,0,0,1-27.89,12.43,66.12,66.12,0,0,1-17.09,1,66.86,66.86,0,0,1-8.89-1.23,70.47,70.47,0,0,1-8.87-2.52,66.35,66.35,0,0,1-36.26-31.82,61.59,61.59,0,0,1-4.06-9.59,66.28,66.28,0,0,1,0-41.88,61.59,61.59,0,0,1,4.06-9.59,65,65,0,0,1,5.41-8.7,66.48,66.48,0,0,1,30.84-23.11,72.19,72.19,0,0,1,8.87-2.52,66.86,66.86,0,0,1,8.89-1.23,66.14,66.14,0,0,1,17.09,1A66,66,0,0,1,410.57,251a66.94,66.94,0,0,1,16.79,18.86,65.05,65.05,0,0,1,9.06,29.63C436.56,302.29,436.52,303.75,436.52,303.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.325px 303.785px"
    },
    id: "elvqmk1juvpaa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8atnwsc8o"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 370.95,
    cy: 303.75,
    r: 57.36,
    style: {
      fill: "rgb(255, 191, 157)",
      transformOrigin: "370.95px 303.75px",
      transform: "rotate(-21.69deg)"
    },
    className: "animable",
    id: "elt72sl6qnjkp"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.31,303.75s0-.32-.05-.93,0-1.53-.13-2.73a58.76,58.76,0,0,0-1.65-10.34,57.41,57.41,0,0,0-20.91-31.49,56.94,56.94,0,0,0-24.07-10.67,57.13,57.13,0,1,0,0,112.31,56.91,56.91,0,0,0,24.08-10.67,57.46,57.46,0,0,0,20.9-31.49,58.76,58.76,0,0,0,1.65-10.34c.11-1.19.09-2.11.13-2.72s.05-.93.05-.93,0,1.26-.08,3.66a56.52,56.52,0,0,1-7.86,25.73,58.21,58.21,0,0,1-14.57,16.39,56.47,56.47,0,0,1-11,6.59,55.71,55.71,0,0,1-13.24,4.21,57.57,57.57,0,1,1,0-113.16A57.48,57.48,0,0,1,405.8,258a58.08,58.08,0,0,1,14.57,16.39,56.52,56.52,0,0,1,7.86,25.73C428.35,302.48,428.31,303.75,428.31,303.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.838px 303.75px"
    },
    id: "elqt8he25lyf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.44,267.78A19.29,19.29,0,0,0,389,259a15.85,15.85,0,0,0-14,2.38,12.57,12.57,0,0,0-4.45,7,21.85,21.85,0,0,0-.82,9.72,15.84,15.84,0,0,0,3.1,7,17.86,17.86,0,0,0,7.57,5c3.48,1.34,7.24.89,10.91.24,5.08-.89,9.59-3.36,11.62-8.1S404,272.28,401.44,267.78Z",
    style: {
      fill: "rgb(255, 191, 157)",
      transformOrigin: "386.77px 274.639px"
    },
    id: "el5be4hlnn5w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.44,267.78a17.76,17.76,0,0,1,2.69,8.63,13.63,13.63,0,0,1-1.3,6.39,12.69,12.69,0,0,1-5.45,5.67,18.45,18.45,0,0,1-4.12,1.64,37.22,37.22,0,0,1-4.61.85,22.42,22.42,0,0,1-4.93.14,15.22,15.22,0,0,1-5-1.43,19.25,19.25,0,0,1-4.55-2.8,13.31,13.31,0,0,1-3.34-4.39,17.8,17.8,0,0,1-1.56-5.28,19.42,19.42,0,0,1,.18-5.34,27.94,27.94,0,0,1,1.26-5,12.66,12.66,0,0,1,2.51-4.28,14.19,14.19,0,0,1,8-4.24,17.26,17.26,0,0,1,7.88.45,20.14,20.14,0,0,1,9.87,5.57,15.31,15.31,0,0,1,1.92,2.45c.19.3.32.54.41.7a1.63,1.63,0,0,1,.12.25,1,1,0,0,1-.17-.22l-.44-.67a18.36,18.36,0,0,0-2-2.37,20.19,20.19,0,0,0-9.82-5.35,16.92,16.92,0,0,0-7.72-.38,13.69,13.69,0,0,0-7.69,4.14c-2.14,2.31-3.05,5.65-3.63,9a19.23,19.23,0,0,0-.17,5.2,17.73,17.73,0,0,0,1.52,5.12,12.72,12.72,0,0,0,3.21,4.21,18.49,18.49,0,0,0,4.42,2.74,14.71,14.71,0,0,0,4.8,1.39,21.51,21.51,0,0,0,4.82-.12,35.63,35.63,0,0,0,4.55-.81,18.55,18.55,0,0,0,4-1.57,12.44,12.44,0,0,0,5.33-5.46,13.47,13.47,0,0,0,1.34-6.22,16.77,16.77,0,0,0-.81-4.79,23.46,23.46,0,0,0-1.13-2.87c-.15-.3-.26-.54-.36-.73A1.23,1.23,0,0,1,401.44,267.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "386.653px 274.628px"
    },
    id: "ele4tod2cpm2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.6,273.36a3.75,3.75,0,0,0-1.43-2.71,3.47,3.47,0,0,0-.4-2.86,3.43,3.43,0,0,0-2.48-1.49,6.73,6.73,0,0,1-1.1-.12l-.23-.12-.38-.24a6.65,6.65,0,0,1-.51-.65,3.47,3.47,0,0,0-4.6-.8,10.1,10.1,0,0,0-1.1,0,4.05,4.05,0,0,0-2.92-.42c-1,.28-1.92,2-1.95,3h0a4.29,4.29,0,0,0-3.32,2.1,4.18,4.18,0,0,0-.29,3.45c0,.27,0-.27,0,0-1,1.28-.33,2.83-.42,3.35a4,4,0,0,0,1.24,3,18.08,18.08,0,0,0,1.87,1.34c1,.84,1.53,2.25,2.73,2.76s2.34,0,3.5.23c.73.13,1.39.5,2.11.7a4.48,4.48,0,0,0,5.15-2.57l0,0a4.47,4.47,0,0,0,2.69-1.86,4.54,4.54,0,0,0,.68-3.23A3.72,3.72,0,0,0,397.6,273.36Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "386.968px 273.916px"
    },
    id: "elb5dwj114ylh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eld75pufmpwsr"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "387.052px 278.316px"
    },
    className: "animable",
    id: "elf83gnnr9mao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.6,273.36a2.85,2.85,0,0,0-.12-.72,3.71,3.71,0,0,1-1.12,2.5,4.44,4.44,0,0,1-3.37,5.09l0,0a4.49,4.49,0,0,1-5.16,2.57c-.71-.2-1.38-.57-2.11-.7-1.16-.2-2.42.24-3.5-.23s-1.72-1.92-2.73-2.76a18.08,18.08,0,0,1-1.87-1.34,5.17,5.17,0,0,1-1.12-2v.07a4.58,4.58,0,0,0,1.24,3,18.08,18.08,0,0,0,1.87,1.34c1,.84,1.53,2.25,2.73,2.76s2.34,0,3.5.23c.73.13,1.39.5,2.11.7a4.48,4.48,0,0,0,5.15-2.57l0,0a4.47,4.47,0,0,0,2.69-1.86,4.54,4.54,0,0,0,.68-3.23A3.72,3.72,0,0,0,397.6,273.36Z",
    id: "elz5y61ztomts",
    className: "animable",
    style: {
      transformOrigin: "387.052px 278.316px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M380.65,273.79s-.2-.15-.35-.52a2.49,2.49,0,0,1-.14-1.51,2.42,2.42,0,0,1,.79-1.29c.3-.26.53-.34.54-.32a3.39,3.39,0,0,0-1.12,1.66A3.23,3.23,0,0,0,380.65,273.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "380.796px 271.969px"
    },
    id: "elp849jijydg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.46,275.39a.92.92,0,0,1-.2-.93c.11-.56.54-.81.56-.76s-.26.33-.36.81A3.68,3.68,0,0,0,380.46,275.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "380.515px 274.542px"
    },
    id: "elk66137uikbk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,278.68a1.33,1.33,0,0,1-.41.62,2.67,2.67,0,0,1-3.36.38,1.48,1.48,0,0,1-.54-.51s.23.18.62.38a2.75,2.75,0,0,0,3.18-.36C389.77,278.9,389.92,278.66,390,278.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "387.845px 279.393px"
    },
    id: "el3isx6ipacbz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.21,278.3c.07,0,.07.58-.51.9a.85.85,0,0,1-1-.08,2,2,0,0,0,.93-.1C391.07,278.77,391.16,278.28,391.21,278.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "390.471px 278.813px"
    },
    id: "elbqdvrm2a4y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.8,274a2.84,2.84,0,0,0,.27-1.82A2.76,2.76,0,0,0,392,270.7s.24,0,.53.24a2.09,2.09,0,0,1,.66,2.57C393,273.84,392.82,274,392.8,274Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "392.693px 272.35px"
    },
    id: "el8yr99wnsx38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.06,270.31c-.05,0-.24-.4-.72-.64a3.18,3.18,0,0,0-.94-.21,1,1,0,0,1,1,0C389,269.77,389.12,270.31,389.06,270.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "388.237px 269.818px"
    },
    id: "ely4y4ifd6ny9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.17,275.12a3.07,3.07,0,0,0,.29.92c.28.46.71.61.69.67s-.54,0-.87-.56A1,1,0,0,1,384.17,275.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.613px 275.924px"
    },
    id: "el1ibhk0bzcjz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.37,267.14s-.16-.19-.45-.45a2.26,2.26,0,0,0-1.35-.59,1.81,1.81,0,0,0-1.33.54,3.33,3.33,0,0,0-.36.52.88.88,0,0,1,.25-.61,1.81,1.81,0,0,1,1.45-.66,2.2,2.2,0,0,1,1.44.69A1.22,1.22,0,0,1,388.37,267.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "386.625px 266.525px"
    },
    id: "elj8femo2e4o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpdwwqjfhe1b"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "381.435px 272.073px"
    },
    className: "animable",
    id: "elgaa5y4svq4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.44,275.34a1.35,1.35,0,0,1-.47-1.8,2.65,2.65,0,0,1,.56-3.12c.27-.24.58-.42.85-.66s.51-.53.8-.74a1.12,1.12,0,0,1,1-.23,1.53,1.53,0,0,0-1.43,1.24,2.35,2.35,0,0,0-1.42,1.6,2.45,2.45,0,0,0,.35,2.16,1.74,1.74,0,0,0-.25,1.6",
    id: "elypc5y8fgytg",
    className: "animable",
    style: {
      transformOrigin: "381.435px 272.073px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elnze6117amfg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "378.819px 279.729px"
    },
    className: "animable",
    id: "elrwb9sx0aub"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.83,286.76c-.57-.77-1.82-.27-2.71-.62s-1.22-1.59-2-2.23-2.21-.55-3.27-1c-1.45-.64-2.12-2.29-2.64-3.79a11.26,11.26,0,0,1-.91-4.79,15.57,15.57,0,0,0,.25-2,1.83,1.83,0,0,0-1-1.68,1.39,1.39,0,0,0-1.77,1.1h0a17.61,17.61,0,0,0,2.27,11.18,12.3,12.3,0,0,0,9.48,5.91,2.94,2.94,0,0,0,1.85-.36A1.25,1.25,0,0,0,385.83,286.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "378.819px 279.729px"
    },
    id: "eletl0so1i0vd",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el1rw6k2qnlc9"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "396.756px 266.635px"
    },
    className: "animable",
    id: "elhgpfyf0gx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.83,263.18a16.53,16.53,0,0,1,4.4,3.06c1.26,1.37,2,3.14,3.37,4.43.44.43,1.12.82,1.65.49a1,1,0,0,0,.43-.89,2.45,2.45,0,0,0-.28-1c-1.31-2.88-4-4.83-6.63-6.61a3.41,3.41,0,0,0-1.31-.64,1.2,1.2,0,0,0-1.28.5",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "396.756px 266.635px"
    },
    id: "elthu7v0oo55f",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elp143vadkfr"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "401.247px 274.442px"
    },
    className: "animable",
    id: "eltqnm393kr5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.29,274.36a1.49,1.49,0,0,0-.6-1.08l-.16.05a.94.94,0,0,0-.84.16,1.36,1.36,0,0,0-.45.74,1.17,1.17,0,0,0,.31,1.13,1,1,0,0,0,1.19.09A1.23,1.23,0,0,0,402.29,274.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "401.247px 274.442px"
    },
    id: "elbz8adsnrgqm",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M386.5,300.58c-5.91-6.9-15.44-10.75-24.52-11-8.61-.71-17.71,2.31-23.33,8.87-3.53,4.12-4.81,8.28-5.28,13.68s-.17,12,1.91,17.05a28,28,0,0,0,7.73,11c4.16,3.41,9.47,5.13,14.77,6,6.46,1.11,12.79-1,18.9-3.31,8.47-3.27,15.4-9.07,17.28-17.95S392.41,307.47,386.5,300.58Z",
    style: {
      fill: "rgb(255, 191, 157)",
      transformOrigin: "363.827px 317.982px"
    },
    id: "elgymk3bq0nrt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.5,300.58s.12.11.33.35.52.6.91,1.09a36.35,36.35,0,0,1,3.07,4.52,29.06,29.06,0,0,1,3.18,8,23.78,23.78,0,0,1-.1,11.4,22.13,22.13,0,0,1-7.44,11.56,32.18,32.18,0,0,1-6.51,4.21,68.22,68.22,0,0,1-7.64,3,39.18,39.18,0,0,1-8.43,1.9,24,24,0,0,1-4.49,0,36.35,36.35,0,0,1-4.49-.78,33.41,33.41,0,0,1-8.75-3.28,22.91,22.91,0,0,1-7.2-6.36,31.59,31.59,0,0,1-4.47-8.52,34.37,34.37,0,0,1-1.51-9.22,48.85,48.85,0,0,1,.48-9,22,22,0,0,1,2.83-8.16,24.66,24.66,0,0,1,12.22-10,30.19,30.19,0,0,1,13.69-1.93,35.83,35.83,0,0,1,11.22,2.19,33.44,33.44,0,0,1,7.68,4,28.45,28.45,0,0,1,4.16,3.54c.44.45.74.82.95,1.05l.31.38-.35-.34c-.22-.23-.54-.58-1-1a31.42,31.42,0,0,0-4.21-3.44,33.58,33.58,0,0,0-7.66-3.87,36,36,0,0,0-11.14-2.09,29.79,29.79,0,0,0-13.51,2,24.29,24.29,0,0,0-12,9.83,21.28,21.28,0,0,0-2.76,8,48.6,48.6,0,0,0-.46,8.91,34.14,34.14,0,0,0,1.49,9.07,30.66,30.66,0,0,0,4.4,8.37,22.28,22.28,0,0,0,7,6.23,32.66,32.66,0,0,0,8.61,3.23,35.92,35.92,0,0,0,4.42.78,23.84,23.84,0,0,0,4.39,0,39.26,39.26,0,0,0,8.33-1.87,67.65,67.65,0,0,0,7.59-3,32.08,32.08,0,0,0,6.44-4.13,21.89,21.89,0,0,0,7.36-11.32,23.74,23.74,0,0,0,.17-11.25,29.57,29.57,0,0,0-3.08-8,37.66,37.66,0,0,0-3-4.55l-.87-1.12C386.59,300.72,386.5,300.58,386.5,300.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "363.778px 317.975px"
    },
    id: "elszxp4mtxa4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.79,311.51a6.59,6.59,0,0,0-3.4-4.18,5.91,5.91,0,0,0-6.45-6.53A12.73,12.73,0,0,1,370,301l-.44-.14-.73-.27a12.49,12.49,0,0,1-1.1-.95,6.13,6.13,0,0,0-8.23.18c-.63.12-1.25.26-1.87.44a7.09,7.09,0,0,0-5.19.26c-1.62.82-2.64,4.06-2.36,5.78h0c-1.52.78-3.72,1.22-5,4.76a7.46,7.46,0,0,0,.67,6c.05.48-.08-.47,0,0-1.29,2.56.41,5,.42,5.93,0,2.17,2,4,3.18,4.81s2.5,1,3.69,1.67c2,1.1,3.41,3.36,5.65,3.84,2,.43,4.05-.76,6.12-.81,1.31,0,2.58.4,3.88.48a7.9,7.9,0,0,0,8-6.18l.05-.07a7.81,7.81,0,0,0,4.07-9.93A6.57,6.57,0,0,0,381.79,311.51Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "363.356px 315.772px"
    },
    id: "elwwi2algs0m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el854iw6909kp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "364.075px 321.867px"
    },
    className: "animable",
    id: "elrhln7nriyyg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.79,311.51a6.46,6.46,0,0,0-.46-1.2,6.53,6.53,0,0,1-1.08,4.7,7.83,7.83,0,0,1-4.07,9.94l-.05.06a7.91,7.91,0,0,1-8,6.19c-1.3-.09-2.57-.51-3.88-.48-2.07,0-4.09,1.23-6.12.8-2.24-.48-3.63-2.74-5.65-3.83-1.19-.65-2.59-.88-3.69-1.68a8.94,8.94,0,0,1-2.62-3.12s0,.08,0,.12a8.19,8.19,0,0,0,3.18,4.81c1.1.79,2.5,1,3.69,1.67,2,1.1,3.41,3.36,5.65,3.84,2,.43,4.05-.76,6.12-.81,1.31,0,2.58.4,3.88.48a7.9,7.9,0,0,0,8-6.18l.05-.07a7.81,7.81,0,0,0,4.07-9.93A6.57,6.57,0,0,0,381.79,311.51Z",
    id: "el6169g191usr",
    className: "animable",
    style: {
      transformOrigin: "364.075px 321.867px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M352.68,318.05a.89.89,0,0,1-.23-.18,3.76,3.76,0,0,1-.5-.62,4.32,4.32,0,0,1,.16-5,3.65,3.65,0,0,1,.55-.59c.14-.12.23-.17.24-.16s-.3.29-.67.84a4.53,4.53,0,0,0-.79,2.39,4.67,4.67,0,0,0,.63,2.45C352.41,317.74,352.71,318,352.68,318.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "352.065px 314.774px"
    },
    id: "elu0pxvi0ww4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.9,320.88a1.93,1.93,0,0,1-.59-1.54,1.86,1.86,0,0,1,.65-1.51,3.91,3.91,0,0,0-.44,1.52A4.32,4.32,0,0,0,352.9,320.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "352.632px 319.355px"
    },
    id: "elaftxwlwtf2n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,323.3s0,.13-.09.34a4.2,4.2,0,0,1-.45.84,4.73,4.73,0,0,1-5.6,1.79,3.66,3.66,0,0,1-.85-.43c-.19-.12-.28-.21-.27-.22a9.74,9.74,0,0,0,1.17.51,4.82,4.82,0,0,0,5.43-1.74A9.56,9.56,0,0,0,370.4,323.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "366.77px 324.938px"
    },
    id: "el48doft6xtur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.45,322.22s.09.21,0,.54a1.85,1.85,0,0,1-1.9,1.54c-.34,0-.53-.12-.52-.14a2.48,2.48,0,0,0,1.63-.43A2.43,2.43,0,0,0,372.45,322.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.26px 323.261px"
    },
    id: "el4rgmitj5sf2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.71,314.22s.14-.36.24-1a3.81,3.81,0,0,0-1.92-4c-.53-.31-.91-.38-.9-.42a.62.62,0,0,1,.27,0,3.3,3.3,0,0,1,.7.26,3.73,3.73,0,0,1,2,4.15,3.35,3.35,0,0,1-.23.7C373.78,314.15,373.72,314.23,373.71,314.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.658px 311.503px"
    },
    id: "elemyvycrx616",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,309.17a2.93,2.93,0,0,0-3.16-.89,1.92,1.92,0,0,1,1.77-.24A2,2,0,0,1,366,309.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.42px 308.547px"
    },
    id: "elub9jgfw9vf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.21,319.14a3.48,3.48,0,0,0,.76,1.54,3.59,3.59,0,0,0,1.48.87,2,2,0,0,1-1.63-.73A2,2,0,0,1,359.21,319.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.323px 320.346px"
    },
    id: "elw5sau8s0lw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.73,303.94s-.31-.31-.9-.67a3.87,3.87,0,0,0-2.57-.59,3.13,3.13,0,0,0-2.15,1.44,4.26,4.26,0,0,0-.39,1.05.83.83,0,0,1,0-.31,2.3,2.3,0,0,1,.27-.81,3.12,3.12,0,0,1,2.24-1.58,3.86,3.86,0,0,1,2.68.67,4.54,4.54,0,0,1,.64.55C363.68,303.84,363.74,303.93,363.73,303.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.718px 303.806px"
    },
    id: "el8qwiigzwf4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltrzmkc4q41"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "352.922px 314.708px"
    },
    className: "animable",
    id: "el7mz2kfjnsm4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.85,320.79a2.36,2.36,0,0,1-1.42-2.94,4.67,4.67,0,0,1-.1-5.58c.37-.51.85-.93,1.24-1.42s.69-1.09,1.13-1.56a2,2,0,0,1,1.69-.75c-.95.27-2.23,1.33-2,2.63a4.21,4.21,0,0,0-1.92,3.25,4.37,4.37,0,0,0,1.34,3.6,3.12,3.12,0,0,0,.12,2.86",
    id: "ellztqx984x3",
    className: "animable",
    style: {
      transformOrigin: "352.922px 314.708px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M368.37,301.56c-.07,0-.33-.35-.88-.84a5.05,5.05,0,0,0-5.27-1c-.68.26-1.07.53-1.12.47s.27-.43,1-.81a4.79,4.79,0,0,1,3-.44,4.74,4.74,0,0,1,2.66,1.49C368.27,301.06,368.43,301.54,368.37,301.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "364.738px 300.213px"
    },
    id: "ella9kubqg0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.05,302.64c-.05.14-.65.05-1.36.1s-1.29.18-1.35.05.5-.53,1.32-.57S374.1,302.51,374.05,302.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "372.694px 302.531px"
    },
    id: "elwa36uedlkqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.43,310.33c-.12.08-.38-.09-.73-.15s-.65,0-.73-.15.27-.48.84-.36S379.56,310.27,379.43,310.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "378.714px 309.998px"
    },
    id: "eljys8o0g6rxf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.87,309.11c-.05.13-.44.11-.9.12s-.85,0-.9-.12.34-.4.9-.4S364.92,309,364.87,309.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "363.97px 308.971px"
    },
    id: "elally8jfq5z7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.8,311.06c-.14,0-.27-.44-.54-.89s-.6-.77-.53-.9.62,0,1,.63S371.94,311.07,371.8,311.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "371.341px 310.142px"
    },
    id: "elclmd715zzbj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.51,304.28c0,.15-.24.32-.48.57s-.42.52-.56.5-.19-.48.18-.86S360.49,304.14,360.51,304.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "359.938px 304.768px"
    },
    id: "elez80hoh1i95",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.14,315c-.14,0-.34-.47-.24-1.11s.42-1.06.54-1,.05.52,0,1.07S353.29,315,353.14,315Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "353.19px 313.942px"
    },
    id: "el84ksh6mo3d3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.49,304.29c-.14,0-.33-.55,0-1.2s.86-.89.93-.76-.23.47-.45,1S351.64,304.27,351.49,304.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "351.869px 303.293px"
    },
    id: "elr8v7vj5xf1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.93,313.47c-.13,0-.39-.91,0-2s1.24-1.6,1.32-1.48-.48.73-.83,1.67S346.08,313.45,345.93,313.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "346.491px 311.721px"
    },
    id: "elknc8n7i8ona",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el84f7ixb1di"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "351.648px 329.04px"
    },
    className: "animable",
    id: "elnq6ag059h4j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.05,338.66c-1.25-1.13-3.23.16-4.88-.15s-2.66-2.33-4.24-3.16c-1.79-.94-4-.2-6-.63-2.73-.59-4.44-3.23-5.85-5.64s-3-5.08-3.21-7.95a27,27,0,0,0-.27-3.6,3.23,3.23,0,0,0-2.23-2.58,2.44,2.44,0,0,0-2.66,2.51h0c.58,6.79,3.06,13.54,7.72,18.51s11.64,7.93,18.38,7a5.25,5.25,0,0,0,3.07-1.26A2.19,2.19,0,0,0,366.05,338.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "351.648px 329.04px"
    },
    id: "eldncc612nn8d",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eluvqyksi80xf"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "378.079px 300.123px"
    },
    className: "animable",
    id: "el4kc9yy8uicq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.35,295.92c3,.95,6.09,1.92,8.64,3.79s4.58,4.71,7.33,6.48c.91.6,2.22,1,3,.28a1.77,1.77,0,0,0,.43-1.67,4.31,4.31,0,0,0-.8-1.6c-3.25-4.52-8.58-7-13.71-9.15a6.4,6.4,0,0,0-2.48-.66,2.14,2.14,0,0,0-2,1.3",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "378.079px 300.123px"
    },
    id: "elfc2j58bp94n",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elt2ht6no0ks"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "388.459px 312.089px"
    },
    className: "animable",
    id: "el9sujbu6eoms"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.21,311.65a2.55,2.55,0,0,0-1.4-1.66l-.25.13a1.64,1.64,0,0,0-1.39.57,2.2,2.2,0,0,0-.53,1.43,2.09,2.09,0,0,0,.92,1.85,1.8,1.8,0,0,0,2.08-.26A2.12,2.12,0,0,0,390.21,311.65Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "388.459px 312.089px"
    },
    id: "elt2luqnl9ibm",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elpjyv33d7hsp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "332.26px 256.03px"
    },
    className: "animable",
    id: "el80zziev9kan"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 332.26,
    cy: 256.03,
    r: 1.66,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "332.26px 256.03px"
    },
    id: "elsedfddcymw",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el9lrfur3swfw"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "408.23px 352.6px"
    },
    className: "animable",
    id: "elsenylo83hdq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.89,352.6a1.66,1.66,0,1,1-1.66-1.66A1.66,1.66,0,0,1,409.89,352.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "408.23px 352.6px"
    },
    id: "el139cam723bip",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eldruj0sl9j4l"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "350.45px 361.48px"
    },
    className: "animable",
    id: "els2xtcycqogj"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 350.45,
    cy: 361.48,
    r: 1.66,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "350.45px 361.48px"
    },
    id: "elq4cqx0d63e",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elavc152eonx"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "356.18px 364.03px"
    },
    className: "animable",
    id: "el868njjrbroo"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 356.18,
    cy: 364.03,
    r: 2.58,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "356.18px 364.03px"
    },
    id: "eluf6hw33kgp",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elrozo6zc3kep"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "336.64px 252.36px"
    },
    className: "animable",
    id: "el9ceg2s2p454"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.11,252.36a2.47,2.47,0,1,1-2.47-2.47A2.47,2.47,0,0,1,339.11,252.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "336.64px 252.36px"
    },
    id: "elqhqo8hotoom",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el6elgc28kd6o"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "332.49px 275.93px"
    },
    className: "animable",
    id: "eljbicu212w4p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.39,275.93a1.9,1.9,0,1,1-1.9-1.9A1.9,1.9,0,0,1,334.39,275.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "332.49px 275.93px"
    },
    id: "ely9rx4dlx73k",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eluqf4otr2xjh"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "393.64px 297.39px"
    },
    className: "animable",
    id: "ellt0sjuqpua"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.54,297.39a1.9,1.9,0,1,1-1.89-1.9A1.89,1.89,0,0,1,395.54,297.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "393.64px 297.39px"
    },
    id: "el3yrdx2uod84",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elbxnpk3vmmvg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "404.26px 326px"
    },
    className: "animable",
    id: "eliu2a29cvmks"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.16,326a1.9,1.9,0,1,1-1.89-1.9A1.89,1.89,0,0,1,406.16,326Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "404.26px 326px"
    },
    id: "elilc9r5xw06",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elhn0zz1ycilb"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "411.5px 283.19px"
    },
    className: "animable",
    id: "el2p7iax3x7s5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.2,283.19a2.7,2.7,0,1,1-2.7-2.7A2.69,2.69,0,0,1,414.2,283.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "411.5px 283.19px"
    },
    id: "elv85pufv78uc",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el2hb1ad9jd8x"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "328.9px 286.42px"
    },
    className: "animable",
    id: "elgdwc1ptoeob"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333,286.42a4.1,4.1,0,1,1-4.1-4.1A4.11,4.11,0,0,1,333,286.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "328.9px 286.42px"
    },
    id: "el025qsg1g00m1",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M350.25,277.08a1.76,1.76,0,1,1-1.23,2.17A1.76,1.76,0,0,1,350.25,277.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "350.715px 278.777px"
    },
    id: "elrjxiapnp8ng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.67,272.11a1.76,1.76,0,1,1-1.23,2.17A1.77,1.77,0,0,1,345.67,272.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "346.136px 273.807px"
    },
    id: "el7l2ly7nn4jk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.17,280.07a1.76,1.76,0,1,1-1.23,2.16A1.76,1.76,0,0,1,348.17,280.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "348.638px 281.767px"
    },
    id: "elvq11ydpjnla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.41,269.33a1.76,1.76,0,1,1-1.23,2.17A1.78,1.78,0,0,1,347.41,269.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "347.878px 271.027px"
    },
    id: "el1ck4cpxaooy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.42,274.71a1.76,1.76,0,1,1-1.23,2.17A1.78,1.78,0,0,1,352.42,274.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "352.888px 276.407px"
    },
    id: "el8s7t6vdf1pq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,274a1.76,1.76,0,1,1-1.23,2.16A1.76,1.76,0,0,1,350,274Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "350.468px 275.697px"
    },
    id: "el6vm8r77hqqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.56,275.45a1.76,1.76,0,1,1-1.23,2.17A1.76,1.76,0,0,1,356.56,275.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "357.025px 277.147px"
    },
    id: "elyp800mvfcs8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.43,274.38a1.76,1.76,0,1,1-1.23,2.17A1.76,1.76,0,0,1,348.43,274.38Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "348.895px 276.077px"
    },
    id: "elqg4ygn0hker",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.15,277.05a1.76,1.76,0,1,1-1.23,2.17A1.76,1.76,0,0,1,354.15,277.05Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "354.615px 278.747px"
    },
    id: "el7r9ubj2rra5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.48,273.68a1.76,1.76,0,1,1-1.23,2.16A1.76,1.76,0,0,1,354.48,273.68Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "354.948px 275.377px"
    },
    id: "ell86zo18cdi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.45,271.81a1.76,1.76,0,1,1-1.23,2.17A1.76,1.76,0,0,1,352.45,271.81Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "352.915px 273.507px"
    },
    id: "el5ujf9aje1la",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.15,279.59a1.76,1.76,0,1,1-1.23,2.17A1.76,1.76,0,0,1,356.15,279.59Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "356.615px 281.287px"
    },
    id: "eldtyrv3gxvd7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.73,277.37a1.76,1.76,0,1,1-1.22,2.17A1.76,1.76,0,0,1,347.73,277.37Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "348.205px 279.065px"
    },
    id: "elgqnt6agwp1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.17,278.86a1.76,1.76,0,1,1-1.23,2.17A1.76,1.76,0,0,1,345.17,278.86Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "345.635px 280.557px"
    },
    id: "el5rscry0kx6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.33,271.09a1.76,1.76,0,1,1-1.23,2.17A1.76,1.76,0,0,1,348.33,271.09Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "348.795px 272.787px"
    },
    id: "elig4py9z3fbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.41,307.24a1.76,1.76,0,1,1,2.36.81A1.77,1.77,0,0,1,410.41,307.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.993px 306.469px"
    },
    id: "elh6dlgno6h7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.38,312.66a1.76,1.76,0,1,1,2.36.81A1.78,1.78,0,0,1,406.38,312.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "407.963px 311.887px"
    },
    id: "elpivmlzfe2w8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.73,308.72a1.76,1.76,0,1,1,2.36.81A1.76,1.76,0,0,1,413.73,308.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "415.313px 307.951px"
    },
    id: "eltznf6dblwk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.33,311.47a1.76,1.76,0,1,1,2.36.81A1.76,1.76,0,0,1,403.33,311.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.913px 310.701px"
    },
    id: "elvcu908flnck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.68,305.54a1.76,1.76,0,1,1,2.36.81A1.76,1.76,0,0,1,407.68,305.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "409.263px 304.771px"
    },
    id: "elzlpzpzu4phm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.38,308.07a1.76,1.76,0,1,1,2.36.81A1.76,1.76,0,0,1,407.38,308.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "408.963px 307.301px"
    },
    id: "ellbg7y0xhm2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.64,301.34a1.76,1.76,0,1,1,2.36.81A1.77,1.77,0,0,1,407.64,301.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "409.223px 300.569px"
    },
    id: "elmyv3eoo9lx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.1,309.53a1.76,1.76,0,1,1,2.36.8A1.77,1.77,0,0,1,408.1,309.53Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "409.679px 308.751px"
    },
    id: "elsqcbis0wqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.66,303.41a1.76,1.76,0,1,1,2.36.8A1.76,1.76,0,0,1,409.66,303.41Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "411.239px 302.633px"
    },
    id: "elc0xl2qkqb4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.28,303.71a1.76,1.76,0,1,1,2.36.81A1.76,1.76,0,0,1,406.28,303.71Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "407.863px 302.941px"
    },
    id: "el47daypyq7hm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.83,306.06a1.76,1.76,0,1,1,2.36.8A1.77,1.77,0,0,1,404.83,306.06Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "406.409px 305.281px"
    },
    id: "elh2392kxebzw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.78,301a1.76,1.76,0,1,1,2.36.81A1.76,1.76,0,0,1,411.78,301Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "413.363px 300.231px"
    },
    id: "el9cdbpmy4vd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.16,309.66a1.77,1.77,0,1,1,2.36.8A1.77,1.77,0,0,1,411.16,309.66Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "412.744px 308.869px"
    },
    id: "elfitobdmfrhj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.1,311.9a1.76,1.76,0,1,1,2.36.81A1.76,1.76,0,0,1,413.1,311.9Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "414.683px 311.131px"
    },
    id: "elxck98wshnmc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.88,310.24a1.77,1.77,0,1,1,2.36.8A1.76,1.76,0,0,1,404.88,310.24Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "406.464px 309.451px"
    },
    id: "el46nxcrkkgbv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.86,336.81A6.15,6.15,0,0,0,395.5,338a100.62,100.62,0,0,0-9.51,6.65c-1.12.84-2.36,2.08-1.92,3.4a2.23,2.23,0,0,0,1.9,1.37,4.29,4.29,0,0,0,2.42-.39c4.91-2.41,8-3.79,11.82-8.09a4.4,4.4,0,0,0,1-2.14C401.27,337.87,400.06,336.86,398.86,336.81Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "392.596px 343.133px"
    },
    id: "el6auzzbrtg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfpecqec90e6"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "390.417px 345.181px"
    },
    className: "animable",
    id: "elh4hr63igq0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.55,345.68c.09.33.57.51.91.5a1,1,0,1,0-.91-.5",
    id: "elb5a6dj1ccc",
    className: "animable",
    style: {
      transformOrigin: "390.417px 345.181px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elao7np4zuo5"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "386.992px 346.19px"
    },
    className: "animable",
    id: "elrkc4hfeyp6l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.38,346.53c.06.23.39.35.62.34a.71.71,0,0,0,.68-.72.72.72,0,0,0-.76-.64.69.69,0,0,0-.54,1",
    id: "elrwycx708h5g",
    className: "animable",
    style: {
      transformOrigin: "386.992px 346.19px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el0flp497icdys"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "396.792px 342.45px"
    },
    className: "animable",
    id: "eli8wmgr3o45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.39,342.66c0,.15.24.22.38.22a.43.43,0,1,0,0-.86.44.44,0,0,0-.34.64",
    id: "ellxynzbqn24m",
    className: "animable",
    style: {
      transformOrigin: "396.792px 342.45px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el8mtxoez2i3i"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "398.245px 338.96px"
    },
    className: "animable",
    id: "elvo07b2gemrr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.86,339.17c0,.15.24.22.39.22a.45.45,0,0,0,.43-.46.46.46,0,0,0-.48-.4.44.44,0,0,0-.34.64",
    id: "ellj8h0zoer",
    className: "animable",
    style: {
      transformOrigin: "398.245px 338.96px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eleacmzqyshpq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "393.811px 341.706px"
    },
    className: "animable",
    id: "ell3x970tn8g8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.21,342.05c.06.23.39.35.62.34a.69.69,0,0,0,.67-.72.69.69,0,1,0-1.29.38",
    id: "elf810zcuoqzi",
    className: "animable",
    style: {
      transformOrigin: "393.811px 341.706px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elywq0z5q0uye"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "393.242px 344.045px"
    },
    className: "animable",
    id: "el1a1jlmmh15e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.63,344.39c.06.22.38.34.61.34a.72.72,0,0,0,.68-.73.72.72,0,0,0-.75-.64.71.71,0,0,0-.54,1",
    id: "elb1wbl833lr",
    className: "animable",
    style: {
      transformOrigin: "393.242px 344.045px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el10ncb449jymn"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "395.779px 340.629px"
    },
    className: "animable",
    id: "elix6fpuzgsxd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395,341.08c.08.29.5.45.81.45a.9.9,0,1,0-.1-1.8.93.93,0,0,0-.71,1.35",
    id: "elruxdx40prqs",
    className: "animable",
    style: {
      transformOrigin: "395.779px 340.629px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M356.11,260.05a5.28,5.28,0,0,0,3-.31,85.18,85.18,0,0,0,9.09-3.69c1.08-.48,2.34-1.27,2.22-2.44a1.9,1.9,0,0,0-1.3-1.49A3.75,3.75,0,0,0,367,252c-4.5,1.06-7.31,1.62-11.26,4.44a3.73,3.73,0,0,0-1.24,1.56C354.33,258.73,355.14,259.78,356.11,260.05Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "362.453px 256.021px"
    },
    id: "el89r3fhq3g4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elawebbf5nwii"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "364.606px 254.745px"
    },
    className: "animable",
    id: "elqnaxhbi7sy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.45,254.5c0-.29-.37-.53-.65-.59a.86.86,0,1,0-.29,1.69.87.87,0,0,0,.94-1.1",
    id: "ely433fkqhn09",
    className: "animable",
    style: {
      transformOrigin: "364.606px 254.745px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elr2o57bp46w"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "367.668px 254.569px"
    },
    className: "animable",
    id: "elqogrn7xdg5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.22,254.39c0-.19-.25-.35-.44-.39a.58.58,0,1,0,.44.39",
    id: "elmwwqb129b5j",
    className: "animable",
    style: {
      transformOrigin: "367.668px 254.569px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el340un06cqza"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "358.898px 255.803px"
    },
    className: "animable",
    id: "el7jajlj9i4wq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.25,255.69c0-.12-.16-.22-.28-.25a.37.37,0,1,0,.28.25",
    id: "els1bfu6zwdsk",
    className: "animable",
    style: {
      transformOrigin: "358.898px 255.803px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elcuc0pq0hy9k"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "357.001px 258.391px"
    },
    className: "animable",
    id: "el8ynikoxwndb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.38,258.29c0-.12-.16-.22-.28-.25a.37.37,0,1,0-.12.72.38.38,0,0,0,.4-.47",
    id: "ele3yn3hkpbkm",
    className: "animable",
    style: {
      transformOrigin: "357.001px 258.391px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elzxdtxd4thcm"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "361.19px 256.968px"
    },
    className: "animable",
    id: "ele84l2swjdh6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.75,256.79c0-.19-.25-.35-.44-.39a.61.61,0,0,0-.7.47.62.62,0,0,0,.5.67.59.59,0,0,0,.64-.75",
    id: "elqlnl27lqilb",
    className: "animable",
    style: {
      transformOrigin: "361.19px 256.968px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el6wg923wbqb4"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "362.118px 255.179px"
    },
    className: "animable",
    id: "el6fo6xnhbqai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.67,255c0-.19-.25-.35-.44-.39a.58.58,0,1,0,.44.39",
    id: "elxgb6unxnfxs",
    className: "animable",
    style: {
      transformOrigin: "362.118px 255.179px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eljjw664eqsyn"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "359.415px 257.498px"
    },
    className: "animable",
    id: "elhv4bb608mas"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.13,257.27c0-.26-.33-.47-.58-.52a.76.76,0,1,0-.25,1.5.77.77,0,0,0,.83-1",
    id: "el626jdsl2l0d",
    className: "animable",
    style: {
      transformOrigin: "359.415px 257.498px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M330.59,301.11c-.58-1.75-2.69-1.54-3.74-.47a6.92,6.92,0,0,0-1.05,2,1.93,1.93,0,0,1-2.76.92,4.14,4.14,0,0,1-.67-.48c-.52-.51-1-1-1.5-1.5a1.86,1.86,0,0,0-2.61-.12h0c-.82.71.11,2.57.73,3.46a21.74,21.74,0,0,0,2.32,2.28c1.95,2,2.34,5.11,2.38,7.94s-.16,5.78.95,8.39a4.15,4.15,0,0,0,2.18,2.41,2.44,2.44,0,0,0,1.07.14c1.58-.19,2.05-1.78,1.78-3.06a11.32,11.32,0,0,0-1.22-2.79,15.6,15.6,0,0,1,.78-15.12,7.55,7.55,0,0,0,1.45-2.95A2.42,2.42,0,0,0,330.59,301.11Z",
    style: {
      fill: "#5290B0",
      transformOrigin: "324.32px 312.953px"
    },
    id: "el6tex8px0ae2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3o5nku9idjk"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "324.565px 306.555px"
    },
    className: "animable",
    id: "elaecv12s8ajq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.37,305.76c-.27,0-.5.32-.56.58a.81.81,0,0,0,.6,1,.82.82,0,0,0,.93-.65.8.8,0,0,0-1-.89",
    id: "elbguayqepaof",
    className: "animable",
    style: {
      transformOrigin: "324.565px 306.555px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el32o5dxwbo4g"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "325.52px 317.91px"
    },
    className: "animable",
    id: "elyfk9nmbd7tc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.31,317.11c-.26,0-.49.32-.56.58a.82.82,0,0,0,.6,1,.79.79,0,1,0,0-1.54",
    id: "elba4d96izg5",
    className: "animable",
    style: {
      transformOrigin: "325.52px 317.91px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el0t7rcsh3ahem"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "326.137px 308.806px"
    },
    className: "animable",
    id: "elge8tqhifz06"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326,308.29c-.18,0-.33.21-.38.39a.56.56,0,0,0,.41.65.56.56,0,0,0,.63-.44.54.54,0,0,0-.66-.6",
    id: "eltfni10lm39o",
    className: "animable",
    style: {
      transformOrigin: "326.137px 308.806px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elzuiwtwm4rf9"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "322.275px 305.604px"
    },
    className: "animable",
    id: "el9jqhsupoc7q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.11,304.9c-.24,0-.44.29-.49.51a.69.69,0,1,0,1.34.28.7.7,0,0,0-.85-.79",
    id: "elhmwjisaysjt",
    className: "animable",
    style: {
      transformOrigin: "322.275px 305.604px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el15hkr4rdx4b"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "325.283px 314.994px"
    },
    className: "animable",
    id: "elx7xaosl5jrq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.19,314.42c-.18,0-.33.22-.38.39a.53.53,0,1,0,1,.21.54.54,0,0,0-.66-.6",
    id: "elvvrb12ravu",
    className: "animable",
    style: {
      transformOrigin: "325.283px 314.994px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elzpvat6242ks"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "327.293px 324.466px"
    },
    className: "animable",
    id: "ellzsomrejkq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.2,323.89c-.18,0-.34.22-.38.39a.53.53,0,1,0,1,.22.54.54,0,0,0-.65-.61",
    id: "el7gzxu2ze24t",
    className: "animable",
    style: {
      transformOrigin: "327.293px 324.466px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elsfs035afapg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "328.367px 303.925px"
    },
    className: "animable",
    id: "elareixce4dwc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.2,303.39c-.18,0-.34.22-.38.39a.56.56,0,0,0,.4.65.53.53,0,1,0,0-1",
    id: "elcqg9v0tt9eu",
    className: "animable",
    style: {
      transformOrigin: "328.367px 303.925px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eld9rtqhrqhfc"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "320.616px 304.079px"
    },
    className: "animable",
    id: "elpz8gc9qciua"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.47,303.57c-.17,0-.33.22-.37.39a.53.53,0,1,0,.37-.39",
    id: "elwsoa7ly00cc",
    className: "animable",
    style: {
      transformOrigin: "320.616px 304.079px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elx2br7f8velp"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "326.691px 306.406px"
    },
    className: "animable",
    id: "elqu7t7e2739q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.55,305.89c-.18,0-.33.21-.37.39a.55.55,0,0,0,.4.65.56.56,0,0,0,.63-.44.54.54,0,0,0-.66-.6",
    id: "ell24bhff5fx",
    className: "animable",
    style: {
      transformOrigin: "326.691px 306.406px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elspm3ehah8f"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "325.184px 310.511px"
    },
    className: "animable",
    id: "elvga6gk6z8ta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.1,310.19c-.11,0-.21.13-.24.24a.36.36,0,0,0,.26.41.35.35,0,0,0,.39-.28.33.33,0,0,0-.41-.37",
    id: "el717oevq4vl",
    className: "animable",
    style: {
      transformOrigin: "325.184px 310.511px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el3rutkaiqwb9"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "325.983px 322.638px"
    },
    className: "animable",
    id: "el9d3ss92ykpl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.9,322.32c-.11,0-.21.13-.24.24a.33.33,0,1,0,.65.14.34.34,0,0,0-.41-.38",
    id: "elctv6m34ajwe",
    className: "animable",
    style: {
      transformOrigin: "325.983px 322.638px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eljjikphi822"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "323.871px 305.027px"
    },
    className: "animable",
    id: "el9ubjouan74q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.78,304.71c-.11,0-.2.14-.23.24a.33.33,0,1,0,.23-.24",
    id: "elgdib8bfl7lj",
    className: "animable",
    style: {
      transformOrigin: "323.871px 305.027px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el9gruv7q3h0b"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "326.743px 320.57px"
    },
    className: "animable",
    id: "elzqj3yblxvc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.65,320c-.18,0-.33.21-.38.38a.53.53,0,1,0,1,.22.54.54,0,0,0-.66-.6",
    id: "elq73qveq29qe",
    className: "animable",
    style: {
      transformOrigin: "326.743px 320.57px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elc18ht3aute"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "324.076px 308.869px"
    },
    className: "animable",
    id: "el17i6xl9ryosh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.93,308.36c-.18,0-.33.22-.37.39a.53.53,0,1,0,.37-.39",
    id: "elqlabcvgrvl9",
    className: "animable",
    style: {
      transformOrigin: "324.076px 308.869px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eltxr5mq6vxi"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "325.32px 320.182px"
    },
    className: "animable",
    id: "elia8knmxhq6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.18,319.67c-.18,0-.33.21-.37.38a.54.54,0,0,0,.4.65.55.55,0,0,0,.63-.43.54.54,0,0,0-.66-.6",
    id: "el70i1ygubdut",
    className: "animable",
    style: {
      transformOrigin: "325.32px 320.182px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el9vg4an32p5k"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "327.546px 322.235px"
    },
    className: "animable",
    id: "elbg5f0v05sts"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.37,321.57c-.24,0-.44.28-.5.51a.69.69,0,1,0,1.36.28.71.71,0,0,0-.86-.79",
    id: "elslyyhgysfvh",
    className: "animable",
    style: {
      transformOrigin: "327.546px 322.235px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M343.13,359.82l-.21-.1-.6-.32c-.52-.3-1.3-.7-2.26-1.3a79.61,79.61,0,0,1-7.94-5.42,66.5,66.5,0,0,1-10.33-9.82,55.6,55.6,0,0,1-4.93-6.85,52.53,52.53,0,0,1-4-8.13,65.62,65.62,0,0,1-4-17,67.23,67.23,0,0,1-.31-7.62c.07-2.39.2-4.62.46-6.63a62.67,62.67,0,0,1,1.85-9.44c.29-1.09.6-1.92.77-2.49l.22-.64a.9.9,0,0,1,.1-.22,1.93,1.93,0,0,1-.05.23c0,.18-.1.4-.17.66-.14.58-.42,1.41-.67,2.52a66.7,66.7,0,0,0-1.68,9.42c-.24,2-.35,4.22-.4,6.59a71.74,71.74,0,0,0,.36,7.57,66.33,66.33,0,0,0,4,16.86,53.25,53.25,0,0,0,4,8.05,57.33,57.33,0,0,0,4.87,6.8,68.28,68.28,0,0,0,10.18,9.84,92,92,0,0,0,7.82,5.54c.95.62,1.71,1.05,2.22,1.38l.57.37C343.08,359.76,343.14,359.81,343.13,359.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "325.836px 321.83px"
    },
    id: "elllkf7i5qkho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,262.24a4.63,4.63,0,0,1-.52-.49c-.33-.32-.79-.84-1.42-1.45a64.76,64.76,0,0,0-5.58-5,61.64,61.64,0,0,0-46.14-13.08,63.84,63.84,0,0,0-7.36,1.31c-.86.19-1.52.39-2,.49a3.43,3.43,0,0,1-.7.14,3,3,0,0,1,.67-.24c.44-.14,1.09-.37,1.95-.59a55.74,55.74,0,0,1,7.36-1.48A60.33,60.33,0,0,1,409.72,255a56.16,56.16,0,0,1,5.48,5.12c.62.63,1.05,1.17,1.36,1.52A4.67,4.67,0,0,1,417,262.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "385.14px 251.767px"
    },
    id: "el2cszew5onr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.71,269.18c-.12.08-.59-.5-1-1.28s-.73-1.48-.6-1.55.59.5,1.05,1.29S421.84,269.11,421.71,269.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "420.914px 267.766px"
    },
    id: "ele99hu4fmewi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.41,293a8.38,8.38,0,0,1-1.48-.16c-.95-.14-2.33-.3-4-.39a28,28,0,0,0-13,2.15A17.35,17.35,0,0,0,337.35,309s0-.14,0-.39a9.63,9.63,0,0,1,0-1.11,13.25,13.25,0,0,1,1-4,18.46,18.46,0,0,1,9.33-9.44,26.87,26.87,0,0,1,13.23-2.05,32.67,32.67,0,0,1,4,.56A7.78,7.78,0,0,1,366.41,293Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "351.872px 300.44px"
    },
    id: "el6oi37wrr8sw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.11,301.6a34.22,34.22,0,0,0-12.45-8.21,7.1,7.1,0,0,1,2.16.57,23.13,23.13,0,0,1,4.8,2.42,22.87,22.87,0,0,1,4.12,3.46A7.09,7.09,0,0,1,384.11,301.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "377.885px 297.495px"
    },
    id: "elqo0093inhf",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisorder);
export default __webpack_public_path__ + "static/media/Disorder.3e703f1b2a26182e30189d8e7065af5f.svg";
export { ForwardRef as ReactComponent };